webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LOCAL_API_URL */
/* unused harmony export MHS_API_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOGIN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SIGNUP_URL; });
/* unused harmony export FACEBOOK_LOGIN_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ASSO_SEARCH_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DONATION_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REGISTER_CARD_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WALLET_BALANCE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RECHARGE_ACCOUNT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DONATATION_URL; });

var LOCAL_API_URL = 'http://localhost:8080';
var MHS_API_URL = 'https://api.microhuchasolidaria.org';

var API_URL = { CurrentUrl: MHS_API_URL, LastURL: '' };
var LOGIN_URL = '/signin';
var SIGNUP_URL = '/signup';
var FACEBOOK_LOGIN_URL = '/signin/facebook';
var ASSO_SEARCH_URL = '/search/asso';
var DONATION_URL = '/metrics';
var REGISTER_CARD_URL = '/register_card';
var WALLET_BALANCE_URL = '/wallet_balance';
var RECHARGE_ACCOUNT_URL = '/recharge_account';
var DONATATION_URL = '/donation';

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(221)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(305),
  /* scopeId */
  "data-v-4bef26c6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(215)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(298),
  /* scopeId */
  "data-v-12efeadd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.f4769f9.eot";

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(220)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(304),
  /* scopeId */
  "data-v-4300bb03",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(241)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(327),
  /* scopeId */
  "data-v-fee6689c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(225)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(309),
  /* scopeId */
  "data-v-634adbc8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */,
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_app__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_user__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_messages__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_countries__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_associations__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_donations__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_accounts__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_slides__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_establishment__ = __webpack_require__(128);













__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_2__modules_app__["a" /* default */],
    countries: __WEBPACK_IMPORTED_MODULE_5__modules_countries__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_3__modules_user__["a" /* default */],
    messages: __WEBPACK_IMPORTED_MODULE_4__modules_messages__["a" /* default */],
    associations: __WEBPACK_IMPORTED_MODULE_6__modules_associations__["a" /* default */],
    donations: __WEBPACK_IMPORTED_MODULE_7__modules_donations__["a" /* default */],
    accounts: __WEBPACK_IMPORTED_MODULE_8__modules_accounts__["a" /* default */],
    slides: __WEBPACK_IMPORTED_MODULE_9__modules_slides__["a" /* default */],
    establishment: __WEBPACK_IMPORTED_MODULE_10__modules_establishment__["a" /* default */]
  },
  strict: true
}));

/***/ }),
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fontawesome-webfont.912ec66.svg";

/***/ }),
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(214)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(297),
  /* scopeId */
  "data-v-1062a6bc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports) {

window.FontAwesomeCdnConfig = {
  autoA11y: {
    enabled: false
  },
  asyncLoading: {
    enabled: false
  },
  reporting: {
    enabled: false
  },
  useUrl: "use.fontawesome.com",
  faCdnUrl: "https://cdn.fontawesome.com:443",
  code: "8500ab3a5a"
};
!function(){function a(a){var b,c=[],d=document,e=d.documentElement.doScroll,f="DOMContentLoaded",g=(e?/^loaded|^c/:/^loaded|^i|^c/).test(d.readyState);g||d.addEventListener(f,b=function(){for(d.removeEventListener(f,b),g=1;b=c.shift();)b()}),g?setTimeout(a,0):c.push(a)}function b(a,b){var c=!1;return a.split(",").forEach(function(a){var d=new RegExp(a.trim().replace(".","\\.").replace("*","(.*)"));b.match(d)&&(c=!0)}),c}function c(a){"undefined"!=typeof MutationObserver&&new MutationObserver(a).observe(document,{childList:!0,subtree:!0})}function d(a){var b,c,d,e;a=a||"fa",b=document.querySelectorAll("."+a),Array.prototype.forEach.call(b,function(a){c=a.getAttribute("title"),a.setAttribute("aria-hidden","true"),d=a.nextElementSibling?!a.nextElementSibling.classList.contains("sr-only"):!0,c&&d&&(e=document.createElement("span"),e.innerHTML=c,e.classList.add("sr-only"),a.parentNode.insertBefore(e,a.nextSibling))})}!function(){"use strict";function a(a){l.push(a),1==l.length&&k()}function b(){for(;l.length;)l[0](),l.shift()}function c(a){this.a=m,this.b=void 0,this.f=[];var b=this;try{a(function(a){f(b,a)},function(a){g(b,a)})}catch(c){g(b,c)}}function d(a){return new c(function(b,c){c(a)})}function e(a){return new c(function(b){b(a)})}function f(a,b){if(a.a==m){if(b==a)throw new TypeError;var c=!1;try{var d=b&&b.then;if(null!=b&&"object"==typeof b&&"function"==typeof d)return void d.call(b,function(b){c||f(a,b),c=!0},function(b){c||g(a,b),c=!0})}catch(e){return void(c||g(a,e))}a.a=0,a.b=b,h(a)}}function g(a,b){if(a.a==m){if(b==a)throw new TypeError;a.a=1,a.b=b,h(a)}}function h(b){a(function(){if(b.a!=m)for(;b.f.length;){var a=b.f.shift(),c=a[0],d=a[1],e=a[2],a=a[3];try{0==b.a?e("function"==typeof c?c.call(void 0,b.b):b.b):1==b.a&&("function"==typeof d?e(d.call(void 0,b.b)):a(b.b))}catch(f){a(f)}}})}function i(a){return new c(function(b,c){function d(c){return function(d){g[c]=d,f+=1,f==a.length&&b(g)}}var f=0,g=[];0==a.length&&b(g);for(var h=0;h<a.length;h+=1)e(a[h]).c(d(h),c)})}function j(a){return new c(function(b,c){for(var d=0;d<a.length;d+=1)e(a[d]).c(b,c)})}var k,l=[];k=function(){setTimeout(b)};var m=2;c.prototype.g=function(a){return this.c(void 0,a)},c.prototype.c=function(a,b){var d=this;return new c(function(c,e){d.f.push([a,b,c,e]),h(d)})},window.Promise||(window.Promise=c,window.Promise.resolve=e,window.Promise.reject=d,window.Promise.race=j,window.Promise.all=i,window.Promise.prototype.then=c.prototype.c,window.Promise.prototype["catch"]=c.prototype.g)}(),function(){function a(a){this.el=a;for(var b=a.className.replace(/^\s+|\s+$/g,"").split(/\s+/),c=0;c<b.length;c++)d.call(this,b[c])}function b(a,b,c){Object.defineProperty?Object.defineProperty(a,b,{get:c}):a.__defineGetter__(b,c)}if(!("undefined"==typeof window.Element||"classList"in document.documentElement)){var c=Array.prototype,d=c.push,e=c.splice,f=c.join;a.prototype={add:function(a){this.contains(a)||(d.call(this,a),this.el.className=this.toString())},contains:function(a){return-1!=this.el.className.indexOf(a)},item:function(a){return this[a]||null},remove:function(a){if(this.contains(a)){for(var b=0;b<this.length&&this[b]!=a;b++);e.call(this,b,1),this.el.className=this.toString()}},toString:function(){return f.call(this," ")},toggle:function(a){return this.contains(a)?this.remove(a):this.add(a),this.contains(a)}},window.DOMTokenList=a,b(Element.prototype,"classList",function(){return new a(this)})}}();var e=function(a,b,c){function d(a){return g.body?a():void setTimeout(function(){d(a)})}function e(){h.addEventListener&&h.removeEventListener("load",e),h.media=c||"all"}var f,g=window.document,h=g.createElement("link");if(b)f=b;else{var i=(g.body||g.getElementsByTagName("head")[0]).childNodes;f=i[i.length-1]}var j=g.styleSheets;h.rel="stylesheet",h.href=a,h.media="only x",d(function(){f.parentNode.insertBefore(h,b?f:f.nextSibling)});var k=function(a){for(var b=h.href,c=j.length;c--;)if(j[c].href===b)return a();setTimeout(function(){k(a)})};return h.addEventListener&&h.addEventListener("load",e),h.onloadcssdefined=k,k(e),h},f=null;!function(){function a(a,b){document.addEventListener?a.addEventListener("scroll",b,!1):a.attachEvent("scroll",b)}function b(a){document.body?a():document.addEventListener?document.addEventListener("DOMContentLoaded",function b(){document.removeEventListener("DOMContentLoaded",b),a()}):document.attachEvent("onreadystatechange",function c(){"interactive"!=document.readyState&&"complete"!=document.readyState||(document.detachEvent("onreadystatechange",c),a())})}function c(a){this.a=document.createElement("div"),this.a.setAttribute("aria-hidden","true"),this.a.appendChild(document.createTextNode(a)),this.b=document.createElement("span"),this.c=document.createElement("span"),this.h=document.createElement("span"),this.f=document.createElement("span"),this.g=-1,this.b.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;",this.c.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;",this.f.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;",this.h.style.cssText="display:inline-block;width:200%;height:200%;font-size:16px;max-width:none;",this.b.appendChild(this.h),this.c.appendChild(this.f),this.a.appendChild(this.b),this.a.appendChild(this.c)}function d(a,b){a.a.style.cssText="max-width:none;min-width:20px;min-height:20px;display:inline-block;overflow:hidden;position:absolute;width:auto;margin:0;padding:0;top:-999px;left:-999px;white-space:nowrap;font:"+b+";"}function e(a){var b=a.a.offsetWidth,c=b+100;return a.f.style.width=c+"px",a.c.scrollLeft=c,a.b.scrollLeft=a.b.scrollWidth+100,a.g!==b?(a.g=b,!0):!1}function g(b,c){function d(){var a=f;e(a)&&a.a.parentNode&&c(a.g)}var f=b;a(b.b,d),a(b.c,d),e(b)}function h(a,b){var c=b||{};this.family=a,this.style=c.style||"normal",this.weight=c.weight||"normal",this.stretch=c.stretch||"normal"}function i(){if(null===l){var a=document.createElement("div");try{a.style.font="condensed 100px sans-serif"}catch(b){}l=""!==a.style.font}return l}function j(a,b){return[a.style,a.weight,i()?a.stretch:"","100px",b].join(" ")}var k=null,l=null,m=null;h.prototype.load=function(a,e){var f=this,h=a||"BESbswy",i=e||3e3,l=(new Date).getTime();return new Promise(function(a,e){if(null===m&&(m=!!window.FontFace),m){var n=new Promise(function(a,b){function c(){(new Date).getTime()-l>=i?b():document.fonts.load(j(f,f.family),h).then(function(b){1<=b.length?a():setTimeout(c,25)},function(){b()})}c()}),o=new Promise(function(a,b){setTimeout(b,i)});Promise.race([o,n]).then(function(){a(f)},function(){e(f)})}else b(function(){function b(){var b;(b=-1!=q&&-1!=r||-1!=q&&-1!=s||-1!=r&&-1!=s)&&((b=q!=r&&q!=s&&r!=s)||(null===k&&(b=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent),k=!!b&&(536>parseInt(b[1],10)||536===parseInt(b[1],10)&&11>=parseInt(b[2],10))),b=k&&(q==t&&r==t&&s==t||q==u&&r==u&&s==u||q==v&&r==v&&s==v)),b=!b),b&&(w.parentNode&&w.parentNode.removeChild(w),clearTimeout(x),a(f))}function m(){if((new Date).getTime()-l>=i)w.parentNode&&w.parentNode.removeChild(w),e(f);else{var a=document.hidden;!0!==a&&void 0!==a||(q=n.a.offsetWidth,r=o.a.offsetWidth,s=p.a.offsetWidth,b()),x=setTimeout(m,50)}}var n=new c(h),o=new c(h),p=new c(h),q=-1,r=-1,s=-1,t=-1,u=-1,v=-1,w=document.createElement("div"),x=0;w.dir="ltr",d(n,j(f,"sans-serif")),d(o,j(f,"serif")),d(p,j(f,"monospace")),w.appendChild(n.a),w.appendChild(o.a),w.appendChild(p.a),document.body.appendChild(w),t=n.a.offsetWidth,u=o.a.offsetWidth,v=p.a.offsetWidth,m(),g(n,function(a){q=a,b()}),d(n,j(f,'"'+f.family+'",sans-serif')),g(o,function(a){r=a,b()}),d(o,j(f,'"'+f.family+'",serif')),g(p,function(a){s=a,b()}),d(p,j(f,'"'+f.family+'",monospace'))})})},f=h}();var g={observe:function(a,b){for(var c=b.prefix,d=function(a){var b=a.weight?"-"+a.weight:"",d=a.style?"-"+a.style:"",e=a.className?"-"+a.className:"",g=a.className?"-"+a.className+b+d:"",h=document.getElementsByTagName("html")[0].classList,i=function(a){h.add(c+e+"-"+a),h.add(c+g+"-"+a)},j=function(a){h.remove(c+e+"-"+a),h.remove(c+g+"-"+a)};i("loading"),new f(a.familyName).load(a.testString).then(function(){i("ready"),j("loading")},function(){i("failed"),j("loading")})},e=0;e<a.length;e++)d(a[e])}},h={load:function(a){var b=document.createElement("link");b.href=a,b.media="all",b.rel="stylesheet",document.getElementsByTagName("head")[0].appendChild(b)},loadAsync:function(a){e(a)}},i={load:function(a){var b=document.createElement("script"),c=document.scripts[0];b.src=a,c.parentNode.appendChild(b)}};try{if(window.FontAwesomeCdnConfig){var j=window.FontAwesomeCdnConfig,k=j.useUrl,l=j.faCdnUrl,m=j.code,n="FontAwesome",o="fa",p="",q=d.bind(d,"fa"),r=function(){};j.autoA11y.enabled&&(a(q),c(q)),j.reporting.enabled&&b(j.reporting.domains,location.host)&&i.load(l+"/js/stats.js"),cssUrl="https://"+k+"/"+m+".css",new f(n).load(p).then(function(){var a=(window.FontAwesomeHooks||{}).loaded||r;a()},r),j.asyncLoading.enabled?h.loadAsync(cssUrl):h.load(cssUrl),g.observe([{familyName:n,testString:p}],{prefix:o+"-events-icons"})}}catch(s){}}();

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
const localizations = {
  'hi': 'أهلا وسهلا',
  'Thanks for your generous heart. You are changing the world for a lot of people who lost hope': '.شكرا لقلبكم السخي. أنت تغير حياة الكثير من الناس الذين فقدوا الأمل',
  'Login successfully!': '!تسجيل الدخول بنجاح',
  'Loading': 'جاري التحميل',
  'Page is under-construction': 'الصفحة قيد الإنشاء',
  'address': 'عنوان',
  'city': 'المدينة',
  'twitter': 'تويتر',
  'Charities': 'الجمعيات الخيرية',
  'My Donations': 'تبرعاتي',
  'Sign in using Facebook': 'أدخل مستخدما الفيسبوك',
  'Home': 'الرئيسية',
  'Solidarity Account': 'حساب التضامن',
  'Total Donations': 'إجمالي للتبرعات',
  'Country': 'الوطن',
  'Email': 'البريد الالكتروني',
  'Password': 'كلمة السر',
  'Settings': 'إعدادات',
  'Wallet Balance': 'رصيد المحفظة',
  'Account balance': 'رصيد الحساب',
  'Net Amount': 'المبلغ الصافي',
  'Card Number': 'رقم البطاقة',
  'CVV Code': 'رقم الكود',
  'Expiration Date': 'تاريخ الإنتهاء',
  'MM': 'الشهر',
  'YY': 'السنة',
  'Charged Amount': 'المبلغ المشحون',
  'Refill': 'إعادة تعبئة',
  'Old Password': 'كلمة مرور القديمة',
  'New Password': 'كلمة المرور الجدية',
  'Confirm Password': 'تأكد كلمة المرور',
  'Change Password': 'تغيير كلمة السر',
  'Sign up': 'سجل',
  'First name': 'الإسم الأول',
  'Last name': 'الكنية',
  'Birthday': 'تاريخ الولادة',
  'Gender': 'الجنس',
  'Male': 'دكر',
  'Female': 'أنثى',
  'Nationality': 'الجنسية',
  'If you already have an account': 'إذا كان لديك حساب',
  'Login here': 'أدخل هنا',
  'If you don\'t have an account yet': 'إذا لم يكن لديك حساب',
  'Sign up here': 'سجل هنا',
  'Unable to set charities list': 'غير قادر على تعيين قائمة الجمعيات الخيرية',
  'Error while loading charities list': 'حدث خطأ أثناء تحميل قائمة المؤسسات الخيرية',
  'Not data in resp': 'لا توجد بيانات في الرد',
  'Card registration error': 'خطأ في تسجيل البطاقة',
  'Error occured while waiting for the payments service': 'حدث خطأ أثناء انتظار خدمة الدفعات',
  'The card number is too short': 'رقم البطاقة قصير جدا',
  'The expiration date is either invalid or already expired': 'تاريخ انتهاء الصلاحية إما غير صالح أو منتهية الصلاحية',
  'No email, please logout and login again': 'لا البريد الإلكتروني في المخزن، يرجى الخروج وتسجيل الدخول مرة أخرى',
  'Error rechargin account': 'حدث خطأ أثناء إعادة شحن الحساب',
  'Recharge successful': 'نجحت بإعادة',
  'Login': 'الدخول',
  'Logout': 'الخروج',
  'EUR': 'يورو',
  'Donation Destination': 'جهة التبرع',
  'Sorry, your donation to this charity failed': 'عذرا، فشل التبرع لهذا الجمعية الخيرية',
  'donation successful': 'نجحت في التبرع',
  '2 euros are the least amount you can donate': 'أقل كميةيمكن أن تتبرع 20 يورو',
  'Invalid charity id': 'معرف الجمعية غير صحيح',
  'Donate': 'تبرع',
  'ES': 'أسبانيا',
  'FR': 'فرنسا',
  'BE': 'بلجيكا',
  'CH': 'سويسرا',
  'MA': 'المغرب',
  'TN': 'تونس',
  'GB': 'المملكة المتحدة',
  'US': 'الولايات المتحدة',
  'Help': 'مساعدة',
  'Terms and conditions': 'الشروط والأحكام',
  'Login as Establishment': 'أدخل كمؤسسة',
  'Login as User': 'أدخل كمستخدم عادي',
  'Signup as Establishment': 'سجل كمؤسسة',
  'Signup as User': 'سجل كمستخدم',
  'I create and validate my account.<br>I credit my account with my credit card...': 'أسجّل وأفتح حساب أريد أن أساعد للإنخراط٠٠٠أشحن رصيدى بواسطة بطاقة ال ائتمان الخاصّة بى٠٠٠',
  'I can browse non-profit charities and I decide to donate from 2 to 10 euros. I can give as many times as I want...': 'سأجد لائحة الجمعيات المنضمّة وسأقرّرأن أتطوّع بمبلغ يتراوح بين 2 و10 يورو حيث يمكننى التجديد٠٠٠',
  'my donation is transmitted to the charity with 0 comission...': 'تبرّعى أحيل إلى المنضّمة الخيرية بنجاح و بصفة مجّانية٠٠٠',
  'I can ask the charity for my tax certificate.': '',

  'Your subscription ends in {days} day ::: Your subscription ends in {days} days': 'ينتهي إشتراكك في {days} يوم ::: ينتهي إشتراكك في {days} أيام',
  'Duration': 'المدة',
  '1 month': '1 شهر',
  '3 month': '2 شهر',
  '6 month': '6 أشهر',
  '12 month': '12 اشهر',
  'Your QR Code': 'رمز الإستجابة السريع',
  'VAT': 'الضريبة',
  'Total Amount Charged': 'المبلغ الإجمالي المشحونة',
  'Pay Subscription': 'ادفع مبلغ المشاركة',
  'Powered by Mangopay': 'مدعومة من Mangopay',
  'Sorry, only users are allowed to login through this form': 'عذرا، يسمح الدوخو للمستخدمين العاديين فقط',
  'Sorry, only establishments are allowed to login through this form': 'عذرا، يسمح الدخول لمستخدمي المؤسسات فقط ',
  '{x} day ::: {x} days': '{x} يوما ::: {x} أيام',
  'Subscription': 'المشاركة المالية',
  'My QR Code': 'رمز الإستجابة السريع لمؤسستي',
  'TAX': 'الضريبة',
  'Sorry transaction failed': 'معذرة، فشلت  العملية',
  'Subscription successful': 'تم دفع رسوم المشاركة',
  'Started secure transacion please complete process in the new window after you click continue': ' (بدء معاملة آمنة يرجى إكمال العملية في نافذة جديدة بعد النقر (متابعة',
  'Sorry, no 3DS link to complete the transacion': 'عذرا، لايوجد رابط لإتمام العملية في طريقة 3DS',
  'Map': 'الخريطة',
  'Version': 'الإصدار',
  'You are redirected to complete the 3DS secure transacion. If you want the transacion to complete continue to the following page and come back when done': 'تتم إعادة توجيهك لاستكمال المعاملة الآمنة 3DS. إذا كنت تريد إتمام المعاملة، فاستمر في الصفحة التالية وعد هنا عند الانتهاء',
  '3DS Transaction': 'عملية 3DS',
  'Continue': 'متابعة',
  'Skip': 'تخطى',
  'Sorry, no QR code image found': 'عذرا، لايوجد صورة رمز الاستجابة السريع',
  'Days left from subscription': 'الأيام المتبقية من المشاركة',
  'Unable to set associations list': 'تعذر تعيين قائمة الجمعيات',
  'Error while loading associations list': 'حدث خطأ أثناء تحميل قائمة الجمعيات',
  'Country of residence': 'بلد الإقامة',
  'Personal Info': 'المعلومات الشخصية',
  'Establishment Info': 'معلومات الؤسسة',
  'Establishment name': 'اسم المؤسسة',
  'City': 'المدينة',
  'Zip Code': 'رمز البريدي',
  'CIF Code': 'رقم الهوية للضريبة',
  'IWantToHelp': 'IWantToHelp',
  'I have donated to a charity with IWantToHelp http://web.iwanttohelp.org.uk #IWantToHelp': 'تبرعت مستخدما IWantToHelp http://ar.jevaisaider.org/ #JeVaisAider ',
  'fundraising,user,widget,IWantToHelp': 'fundraising,user,widget,JeVaisAider',
  'YQuieroAyudar': 'JeVaisAider',
  'Share': 'شارك',
  'Search by name or description': 'ابحث مستخدما اسمها او وصفها',
  'Supportive Establishments': 'المؤسسات الداعمة',
  'Please confirm your email now to access your account!': 'يرجى إكمال التأكيد في بريدك الإلكتروني الآن للدخول إلى حسابك',
  'Date': 'التاريخ',
  'Amount': 'الكمية',
  'Charity': 'الجمعية الخيرية',
  'Social Login': 'الدخول مغ مواقع التواصل',
  'Logout from facebook': 'الخروج من فيسبوك',
  'Login with facebook': 'الدخول مع فيسبوك',
  'Login with your Social Account': 'الدخول مغ مواقع التواصل',
  'Add Supportive Establishment': 'إضافة مؤسسة داعمة جديدة',
  'Are you sure to logout and register new establishment?': 'هل أنت متأكد من الخروج وتسجيل مؤسسة جديدة؟',
  'Cancel': 'إلغاء',
  'Admin': '',
  'Admin Dashboard': '',
  'Dashboard': '',
  'All': '',
  'Add': '',
  'Update': '',
  'All Associations': '',
  'Add New Association': '',
  'Update Associations.': '',
  'Association name': '',
  'description': '',
  'Logo URL': '',
  'Twitter Username': '',
  'IBAN': '',
  'BIC': '',
  'Association registration failed, please try again': '',
  'Association registration successful': '',
  'Register': ''
}

/* harmony default export */ __webpack_exports__["a"] = (localizations);


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
const localizations = {
  'hi': 'Hola',
  'Thanks for your generous heart. You are changing the world for a lot of people who lost hope': 'Gracias por tu generoso corazón, estás cambiando el mundo para muchas personas que ayudas',
  'Login successfully!': 'Éxito',
  'Loading': 'Cargando',
  'Page is under-construction': 'Página en construcción',
  'address': 'dirección',
  'city': 'ciudad',
  'twitter': 'twitter',
  'Charities': 'Organismos sin ánimo de lucro',
  'My Donations': 'Mis donativos',
  'Sign in using Facebook': 'Iniciar sesión con Facebook',
  'Home': 'Inicio',
  'Solidarity Account': 'Cuenta solidaria',
  'Total Donations': 'Total donativos',
  'Country': 'Ciudad',
  'Email': 'Email',
  'Password': 'Contraseña',
  'Settings': 'Ajustes',
  'Wallet Balance': 'Cuenta solidaria',
  'Account balance': 'Saldo',
  'Net Amount': 'Cantidad neta',
  'Card Number': 'Tarjeta de crédito',
  'CVV Code': 'Código CVV',
  'Expiration Date': 'Fecha de expiración',
  'MM': 'MM',
  'YY': 'YY',
  'Charged Amount': 'Cantidad total',
  'Refill': 'Recargar',
  'Old Password': 'Antigua contraseña',
  'New Password': 'Nueva contraseña',
  'Confirm Password': 'Repita la contraseña',
  'Change Password': 'Cambiar contraseña',
  'Sign up': 'Regístrate',
  'First name': 'Nombre',
  'Last name': 'Apellidos',
  'Birthday': 'Fecha de nacimiento',
  'Gender': 'Sexo',
  'Male': 'Hombre',
  'Female': 'Mujer',
  'Nationality': 'Nacional de',
  'If you already have an account': 'Si ya tiene una cuenta',
  'Login here': 'Login aquí',
  'If you don\'t have an account yet': 'Si no tiene cuenta',
  'Sign up here': 'Regístrate aquí',
  'Unable to set charities list': 'Listado de organizaciones no disponible',
  'Error while loading charities list': 'Error para conseguir el listado de organizaciones',
  'Not data in resp': 'Sin datos en la consulta',
  'Card registration error': 'Error de registro de la tarjeta',
  'Error occured while waiting for the payments service': 'Error en el servicio de pagos',
  'The card number is too short': 'Número demasiado corto',
  'The expiration date is either invalid or already expired': 'La fecha de vencimiento no es válida o ya ha vencido',
  'No email, please logout and login again': 'No hay correo electrónic, por favor cierre la sesión y vuelva a iniciar sesión',
  'Error recharging account': 'Error al recargar la cuenta',
  'Recharge successful': 'Recarga exitosa',
  'Login': 'Iniciar sesión',
  'Logout': 'Cerrar',
  'Euro': 'Euro',
  'Donation Destination': 'Destinatario donativo',
  'Sorry, your donation to this charity failed': 'Su donativo no ha sido entregado',
  'donation successful': 'Donativo realizado',
  '2 euros are the least amount you can donate': 'Su donativo es como mínimo 2 euros',
  'Invalid charity id': 'ID organisme invalide',
  'Donate': 'Donar',
  'ES': 'España',
  'FR': 'Francia',
  'BE': 'Bélgica',
  'CH': 'Suiza',
  'MA': 'Marruecos',
  'TN': 'Túnez',
  'GB': 'Reino Unido',
  'US': 'Estados-Unidos',
  'Help': 'Ayuda',
  'Terms and conditions': 'Términos y condiciones',
  'Login as Establishment': 'Acceder como establecimiento',
  'Login as User': 'Acceder',
  'Signup as Establishment': 'Regístrate como establecimiento',
  'Signup as User': 'Regístrate',
  'I create and validate my account.<br>I credit my account with my credit card...': 'Me doy de alta y confirmo por email mi cuenta solidaria yoquieroayudar.<br>Añado saldo a mi cuenta con mi tarjeta de credito...',
  'I can browse non-profit charities and I decide to donate from 2 to 10 euros. I can give as many times as I want...': 'Puedo consultar los organismos solidarios registrados y hacer un donativo desde 2 hasta 10 euros.<br>Puedo repetirlo tantas veces como quiera...',
  'my donation is transmitted to the charity with 0 comission...': 'Mi donativo llega al organismo solidario sin comisiones...',
  'I can ask the charity for my tax certificate.': 'Puedo pedir mi certificado fiscal de donativos.',
  'Your subscription ends in {days} day ::: Your subscription ends in {days} days': 'Su suscripción termina en {days} día ::: Su suscripción termina en {days} días',
  'Duration': 'Duración',
  '1 month': '1 mes',
  '3 month': '3 meses',
  '6 month': '6 meses',
  '12 month': '12 meses',
  'Your QR Code': 'Su código QR',
  'VAT': 'IVA',
  'Total Amount Charged': 'Importe total cobrado',
  'Pay Subscription': 'Pago de suscripción',
  'Powered by Mangopay': 'Desarrollado por Mangopay',
  'Sorry, only users are allowed to login through this form': 'Lo siento, solo los usuarios pueden iniciar sesión a través de este formulario',
  'Sorry, only establishments are allowed to login through this form': 'Lo siento, solo los establecimientos tienen permiso para ingresar a través de este formulario',
  '{x} day ::: {x} days': '{x} día ::: {x} días',
  'Subscription': 'Suscripción',
  'My QR Code': 'Mi código QR',
  'TAX': 'IVA',
  'Sorry transaction failed': 'Error en la transacción',
  'Subscription successful': 'Suscripción correcta',
  'Started secure transaction please complete process in the new window after you click continue': 'Inicio de la transacción segura. Complete el proceso haciendo clic en continuar',
  'Sorry, no 3DS link to complete the transaction': 'Lo sentimos, no hay vínculo seguro 3DS para completar la transacción',
  'Map': 'Mapa',
  'Version': 'Versión',
  'You are redirected to complete the 3DS secure transaction. If you want the transaction to complete continue to the following page and come back when done': 'Se redirigirá para completar la transacción segura 3DS. Si desea que la transacción se complete, continúe en la siguiente página y vuelva cuando termine',
  '3DS Transaction': 'Transacción segura 3DS',
  'Continue': 'Seguir',
  'Skip': 'Saltar',
  'Sorry, no QR code image found': 'Lo sentimos, no tiene ningun código QR',
  'Days left from subscription': 'Días restantes de la suscripción',
  'Unable to set associations list': 'No se puede establecer la lista de asociaciones',
  'Error while loading associations list': 'Error al cargar la lista de asociaciones',
  'Country of residence': 'País de residencia',
  'Personal Info': 'Información',
  'Establishment Info': 'Información establecimiento',
  'Establishment name': 'Nombre del establecimiento',
  'City': 'Ciudad',
  'Zip Code': 'Código postal',
  'CIF Code': 'Código CIF',
  'IWantToHelp': 'IWantToHelp',
  'I have donated to a charity with IWantToHelp http://web.iwanttohelp.org.uk #IWantToHelp': 'Acabo de hacer un donativo con YoQuieroAyudar http://web.microhuchasolidaria.org/ #YoQuieroAyudar',
  'fundraising,user,widget,IWantToHelp': 'fundraising,user,widget,YoQuieroAyudar',
  'YQuieroAyudar': 'YoQuieroAyudar',
  'Share': 'Compartir',
  'Search by name or description': 'Buscar por nombre o descripción',
  'Supportive Establishments': 'Establecimientos solidarios',
  'Please confirm your email now to access your account!': 'Confirma tu correo electrónico ahora para acceder a tu cuenta',
  'Date': 'Fecha',
  'Amount': 'Importe',
  'Charity': 'Organismo',
  'Social Login': 'Login social',
  'Logout from facebook': 'Cerrar sesión',
  'Login with facebook': 'Iniciar sesión',
  'Login with your Social Account': 'Login social',
  'Add Supportive Establishment': 'Añadir establecimiento solidario',
  'Are you sure to logout and register new establishment?': 'Esta seguro/a de cerrar la sesión y crear un nuevo establecimiento solidario?',
  'Cancel': 'Cancelar',
  'Admin': 'Admin',
  'Admin Dashboard': 'Panel de administración',
  'Dashboard': 'Administración',
  'All': 'Todo',
  'Add': 'Añadir',
  'Update': 'Actualizar',
  'All Associations': 'Todos',
  'Add New Association': 'Añadir nuevo organismo',
  'Update Associations.': 'Actualizar organismo',
  'Association name': 'Nombre organismo',
  'description': 'descripción',
  'Logo URL': 'URL logo',
  'Twitter Username': 'Cuenta twitter',
  'IBAN': 'IBAN',
  'BIC': 'BIC',
  'Association registration failed, please try again': 'Se ha producido un error al registrar la asociación. Inténtelo de nuevo',
  'Association registration successful': 'Registro de la asociación con éxito',
  'Register': 'Registro'
}

/* harmony default export */ __webpack_exports__["a"] = (localizations);


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
const localizations = {
  'hi': 'Bonjour',
  'Thanks for your generous heart. You are changing the world for a lot of people who lost hope': 'Merci pour votre générosité. Vous changez le monde pour beaucoup de gens que vous aidez',
  'Login successfully!': 'Connexion valide!',
  'Loading': 'Chargement',
  'Page is under-construction': 'Page en construction',
  'address': 'adresse',
  'city': 'ville',
  'twitter': 'twitter',
  'Charities': 'Organismes solidaires',
  'My Donations': 'Mes dons',
  'Sign in using Facebook': 'Connectez-vous avec Facebook',
  'Home': 'Accueil',
  'Solidarity Account': 'Compte solidaire',
  'Total Donations': 'Total des dons',
  'Country': 'Pays',
  'Email': 'Email',
  'Password': 'Mot de passe',
  'Settings': 'Réglages',
  'Wallet Balance': 'Votre solde',
  'Account balance': 'Votre solde',
  'Net Amount': 'Montant net',
  'Card Number': 'Número de la carte de crédit',
  'CVV Code': 'Code validation CVV',
  'Expiration Date': 'Date de validité',
  'MM': 'MM',
  'YY': 'YY',
  'Charged Amount': 'Montant total débité',
  'Refill': 'Recharger',
  'Old Password': 'Ancien mot de passe',
  'New Password': 'Nouveau mot de passe',
  'Confirm Password': 'Confirmer mot de passe',
  'Change Password': 'Modifier mot de passe',
  'Sign up': 'Créer un compte',
  'First name': 'Prénom',
  'Last name': 'Nom',
  'Birthday': 'Date de naissance',
  'Gender': 'Sexe',
  'Male': 'Homme',
  'Female': 'Femme',
  'Nationality': 'Nationalité',
  'If you already have an account': 'Si vous avez un compte',
  'Login here': 'Connexion ici',
  'If you don\'t have an account yet': 'Si vous n´avez pas de compte',
  'Sign up here': 'Enregistrez vous ici',
  'Unable to set charities list': 'Impossible d´obtenir la liste des organismes',
  'Error while loading charities list': 'Erreur lors du chargement de la liste des organismes',
  'Not data in resp': 'Pas de données disponibles',
  'Card registration error': 'Erreur d\'enregistrement de la carte',
  'Error occured while waiting for the payments service': 'Une erreur s\'est produite en attendant le service de paiement',
  'The card number is too short': 'Numération de la carte trop courte',
  'The expiration date is either invalid or already expired': 'La date d\'expiration est soit invalide, soit déjà expirée',
  'No email, please logout and login again': 'Pas de courrier électronique, fermez la session et connectez-vous à nouveau',
  'Error recharging account': 'Erreur de recharge du compte',
  'Recharge successful': 'Recharge réussie',
  'Login': 'Connectez-vous',
  'Logout': 'Fermer',
  'EURO': 'Euro',
  'Donation Destination': 'Destinataire du don',
  'Sorry, your donation to this charity failed': 'Son don n\'a pu aboutir',
  'donation successful': 'Don effectué',
  '2 euros are the least amount you can donate': 'Son don est de minimum 2 euros',
  'Invalid charity id': 'ID organisme invalide',
  'Donate': 'Donner',
  'ES': 'Espagne',
  'FR': 'France',
  'BE': 'Belgique',
  'CH': 'Suisse',
  'MA': 'Maroc',
  'TN': 'Tunisie',
  'GB': 'Royaume-Uni',
  'US': 'Etats-Unis',
  'Help': 'Aide',
  'Terms and conditions': 'Termes et conditions',
  'Login as Establishment': 'Accéder comme établissement',
  'Login as User': 'Accéder',
  'Signup as Establishment': 'Créer un compte comme établissement',
  'Signup as User': 'Créer un compte',
  'I create and validate my account.<br>I credit my account with my credit card...': 'Je crée et je valide mon compte JeVaisAider.<br>Je crédite mon compte solidaire  avec ma carte bancaire...',
  'I can browse non-profit charities and I decide to donate from 2 to 10 euros. I can give as many times as I want...': 'Je consulte l´ensemble des organismes présents et je décide de faire un don de 2 a 10 euros.<br>Je peux donner plusieurs fois...',
  'my donation is transmitted to the charity with 0 comission...': 'Je demande à l´organisme d\'intérêt général mon certificat fiscal.',
  'I can ask the charity for my tax certificate.': 'Mon don est transmis à l\'organisme solidaire sans comissions...',

  'Your subscription ends in {days} day ::: Your subscription ends in {days} days': 'Votre abonnement se termine dans {days} jour ::: Votre abonnement se termine dans {days} jours',
  'Duration': 'Durée',
  '1 month': '1 mois',
  '3 month': '3 mois',
  '6 month': '6 mois',
  '12 month': '12 mois',
  'Your QR Code': 'Votre code QR',
  'VAT': 'TVA',
  'Total Amount Charged': 'Montant total facturé',
  'Pay Subscription': 'Payer l´abonnement',
  'Powered by Mangopay': 'Propulsé par Mangopay',
  'Sorry, only users are allowed to login through this form': 'Désolé, seuls les utilisateurs peuvent se connecter via ce formulaire',
  'Sorry, only establishments are allowed to login through this form': 'Désolé, seuls les établissements peuvent se connecter via ce formulaire ',
  '{x} day ::: {x} days': '{x} jour ::: {x} jours',
  'Subscription': 'Abonnement',
  'My QR Code': 'Mon code QR',
  'TAX': 'TVA',
  'Sorry transaction failed': 'Désolé, la transaction a échoué',
  'Subscription successful': 'Abonnement réussi',
  'Started secure transaction please complete process in the new window after you click continue': 'Transaction sécurisée, veuillez compléter le processus après avoir cliqué sur continuer',
  'Sorry, no 3DS link to complete the transaction': 'Désolé, aucun lien 3DS pour compléter la transaction',
  'Map': 'Carte',
  'Version': 'Version',
  'You are redirected to complete the 3DS secure transaction. If you want the transaction to complete continue to the following page and come back when done': 'Vous êtes redirigé pour compléter la transaction sécurisée 3DS. Si vous souhaitez que la transaction se termine, continuez à la page suivante et revenez une fois terminé',
  '3DS Transaction': 'Transaction 3DS',
  'Continue': 'Continuer',
  'Skip': 'Passer',
  'Sorry, no QR code image found': 'Désolé, pas de code QR disponible',
  'Days left from subscription': 'Jours restants de l\'abonnement',
  'Unable to set associations list': 'Impossible de définir la liste des associations',
  'Error while loading associations list': 'Erreur lors du chargement de la liste des associations',
  'Country of residence': 'Pays',
  'Personal Info': 'Information',
  'Establishment Info': 'Information établissement',
  'Establishment name': 'Nom de l\'établissement',
  'City': 'Ville',
  'Zip Code': 'Code Postal',
  'CIF Code': 'Numéro SIRET',
  'IWantToHelp': 'IWantToHelp',
  'I have donated to a charity with IWantToHelp http://web.iwanttohelp.org.uk #IWantToHelp': 'Je viens de faire un don avec Je Vais Aider http://web.jevaisaider.org/ #JeVaisAider',
  'fundraising,user,widget,IWantToHelp': 'fundraising,user,widget,JeVaisAider',
  'YQuieroAyudar': 'JeVaisAider',
  'Share': 'Partager',
  'Search by name or description': 'Rechercher par nom ou description',
  'Supportive Establishments': 'Etablissements solidaires',
  'Please confirm your email now to access your account!': 'Veuillez confirmer votre courrier électronique maintenant pour accéder à votre compte',
  'Date': 'Date',
  'Amount': 'Montant',
  'Charity': 'Organisme',
  'Social Login': 'Login social',
  'Logout from facebook': 'Fermer session',
  'Login with facebook': 'Connexion',
  'Login with your Social Account': 'Login social',
  'Add Supportive Establishment': 'Ajouter établissement solidaire',
  'Are you sure to logout and register new establishment?': 'Êtes vous sur de vouloir fermer la session et créer un nouvel établissement solidaire?',
  'Cancel': 'Annuler',
  'Admin': 'Admin',
  'Admin Dashboard': 'Tableau d\´administration',
  'Dashboard': 'Administration',
  'All': 'Tous',
  'Add': 'Ajouter',
  'Update': 'Actualizer',
  'All Associations': 'Tous',
  'Add New Association': 'Ajouter organisme',
  'Update Associations.': 'Actualizer organisme',
  'Association name': 'Nom organisme',
  'description': 'description',
  'Logo URL': 'URL logo',
  'Twitter Username': 'Compte Twitter',
  'IBAN': 'IBAN',
  'BIC': 'BIC',
  'Association registration failed, please try again': 'L\'enregistrement de l\'organisme a échoué, réessayez',
  'Association registration successful': 'Enregistrement de l\'organisme réussi',
  'Register': 'Enregistrement'
}

/* harmony default export */ __webpack_exports__["a"] = (localizations);


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
const localizations = {
  'hi': 'Привет',
  'Thanks for your generous heart. You are changing the world for a lot of people who lost hope': 'Спасибо за ваше великодушное сердце. Вы меняете мир для многих людей, которые потеряли надежду',
  'Login successfully!': 'Вход успешен!',
  'Loading': 'Загрузка',
  'Page is under-construction': 'Страница в разработке',
  'address': 'адрес',
  'city': 'город',
  'twitter': 'twitter',
  'Charities': 'Благотворительные организации',
  'My Donations': 'Мои пожертвования',
  'Sign in using Facebook': 'Войти с помощью Facebook',
  'Home': 'Главная',
  'Solidarity Account': 'Аккаунт солидарности',
  'Total Donations': 'Всего пожертвований',
  'Country': 'Страна',
  'Email': 'Email',
  'Password': 'Пароль',
  'Settings': 'Настройки',
  'Wallet Balance': 'Баланс кошелька',
  'Account balance': 'Баланс аккаунта',
  'Net Amount': 'Чистая сумма',
  'Card Number': 'Номер карты',
  'CVV Code': 'Код CVV',
  'Expiration Date': 'Действительно до',
  'MM': 'MM',
  'YY': 'YY',
  'Charged Amount': 'Сумма',
  'Refill': 'Пополнение',
  'Old Password': 'Старый пароль',
  'New Password': 'Новый пароль',
  'Confirm Password': 'Подтвердить пароль',
  'Change Password': 'Изменить пароль',
  'Sign up': 'Регистрация',
  'First name': 'Имя',
  'Last name': 'Фамилия',
  'Birthday': 'День рождения',
  'Gender': 'Пол',
  'Male': 'Мужчина',
  'Female': 'Женщина',
  'Nationality': 'Национальность',
  'If you already have an account': 'Если у Вас уже есть аккаунт',
  'Login here': 'Войти здесь',
  'If you don\'t have an account yet': 'Если у Вас ещё нет аккаунта',
  'Sign up here': 'Зарегистрироваться здесь',
  'Unable to set charities list': 'Невозможно установить список благотворительных организаций',
  'Error while loading charities list': 'Ошибка при загрузке списка благотворительных организаций',
  'Not data in resp': 'Нет данных в ответе',
  'Card registration error': 'Ошибка регистрации карты',
  'Error occured while waiting for the payments service': 'Ошибка при ожидании службы платежей',
  'The card number is too short': 'Номер карты слишком короткий',
  'The expiration date is either invalid or already expired': 'Дата истечения срока действия неверная или уже прошла',
  'No email, please logout and login again': 'Нет электронной почты, пожалуйста, выйдите из системы и войдите снова',
  'Error recharging account': 'Ошибка пополнения счёта',
  'Recharge successful': 'Пополнение успешно',
  'Login': 'Вход',
  'Logout': 'Выход',
  'Euro': 'Евро',
  'Donation Destination': 'Назначение пожертвования',
  'Sorry, your donation to this charity failed': 'Извините, пожертвование этой благотворительной организации не удалось',
  'donation successful': 'пожертвование успешно',
  '2 euros are the least amount you can donate': '2 евро — это наименьшая сумма, которую можно пожертвовать',
  'Invalid charity id': 'Неверный id благотворительной организации',
  'Donate': 'Пожертвовать',
  'ES': 'Испания',
  'FR': 'Франция',
  'BE': 'Бельгия',
  'CH': 'Швейцария',
  'MA': 'Марокко',
  'TN': 'Тунис',
  'GB': 'Великобритания',
  'US': 'США',
  'Help': 'Помощь',
  'Terms and conditions': 'Условия',
  'Login as Establishment': 'Вход для организации',
  'Login as User': 'Вход для пользователя',
  'Signup as Establishment': 'Регистрация для организации',
  'Signup as User': 'Регистрация для пользователя',
  'I create and validate my account.<br>I credit my account with my credit card...': 'Я создаю и подтверждаю аккаунт.Я кредитую аккаунт своей кредитной картой...',
  'I can browse non-profit charities and I decide to donate from 2 to 10 euros. I can give as many times as I want...': 'Я могу просматривать некоммерческие благотворительные организации и пожертвовать от 2 до 10 евро.Могу жертвовать столько раз, сколько хочу...',
  'my donation is transmitted to the charity with 0 comission...': 'Моё пожертвование передаётся благотворительной организации с 0 комиссией.',
  'I can ask the charity for my tax certificate.': 'Я могу запросить в благотворительной организации бумагу для налоговой.',
  'Your subscription ends in {days} day ::: Your subscription ends in {days} days': 'Подписка заканчивается через {days} день ::: Подписка заканчивается через {days} дней',
  'Duration': 'Длительность',
  '1 month': '1 месяц',
  '3 month': '3 месяца',
  '6 month': '6 месяцев',
  '12 month': '12 месяцев',
  'Your QR Code': 'Ваш QR-код',
  'VAT': 'НДС',
  'Total Amount Charged': 'Общая начисленная сумма',
  'Pay Subscription': 'Оплатить подписку',
  'Powered by Mangopay': 'Работает на Mangopay',
  'Sorry, only users are allowed to login through this form': 'Извините, только пользователи могут входить через эту форму',
  'Sorry, only establishments are allowed to login through this form': 'Извините, только организации могут входить через эту форму',
  '{x} day ::: {x} days': '{x} день ::: {x} дней',
  'Subscription': 'Подписка',
  'My QR Code': 'Мой QR-код',
  'TAX': 'Налог',
  'Sorry transaction failed': 'Ошибка транзакции',
  'Subscription successful': 'Подписка успешна',
  'Started secure transaction please complete process in the new window after you click continue': 'После начала безопасной транзакции, пожалуйста, завершите процесс в новом окне после нажатия кнопки продолжения',
  'Sorry, no 3DS link to complete the transaction': 'Извините, нет 3DS ссылки для завершения транзакции',
  'Map': 'Карта',
  'Version': 'Версия',
  'You are redirected to complete the 3DS secure transaction. If you want the transaction to complete continue to the following page and come back when done': 'Вы перенаправлены для завершения транзакции с поддержкой 3DS. Если вы хотите, чтобы транзакция завершилась, перейдите на следующую страницу и вернитесь, когда закончите',
  '3DS Transaction': '3DS транзакция',
  'Continue': 'Продолжение',
  'Skip': 'Пропустить',
  'Sorry, no QR code image found': 'Извините, не найдено картинки QR-кода',
  'Days left from subscription': 'Дни, оставшиеся от подписки',
  'Unable to set associations list': 'Невозможно установить список организаций',
  'Error while loading associations list': 'Ошибка при загрузке списка организаций',
  'Country of residence': 'Страна проживания',
  'Personal Info': 'Личная информация',
  'Establishment Info': 'Информация об организации',
  'Establishment name': 'Название организации',
  'City': 'Город',
  'Zip Code': 'Почтовый индекс',
  'CIF Code': 'ИНН',
  'IWantToHelp': 'ЯХочуПомочь',
  'I have donated to a charity with IWantToHelp http://web.iwanttohelp.org.uk #IWantToHelp': 'Я сделал пожертвование благотворительной организации с помощью ЯХочуПомочь http://web.iwanttohelp.org.uk #ЯХочуПомочь',
  'fundraising,user,widget,IWantToHelp': 'Сбор средств, пользователь, виджет, ЯХочуПомочь',
  'YQuieroAyudar': 'ЯХочуПомочь',
  'Share': 'Поделиться',
  'Search by name or description': 'Поиск по названию или описанию',
  'Supportive Establishments': 'Поддерживающие организации',
  'Please confirm your email now to access your account!': '',
  'Date': '',
  'Amount': '',
  'Charity': '',
  'Social Login': '',
  'Logout from facebook': '',
  'Login with facebook': '',
  'Login with your Social Account': '',
  'Add Supportive Establishment': '',
  'Are you sure to logout and register new establishment?': '',
  'Cancel': '',
  'Admin': '',
  'Admin Dashboard': '',
  'Dashboard': '',
  'All': '',
  'Add': '',
  'Update': '',
  'All Associations': '',
  'Add New Association': '',
  'Update Associations.': '',
  'Association name': '',
  'description': '',
  'Logo URL': '',
  'Twitter Username': '',
  'IBAN': '',
  'BIC': '',
  'Association registration failed, please try again': '',
  'Association registration successful': '',
  'Register': ''
}

/* harmony default export */ __webpack_exports__["a"] = (localizations);


/***/ }),
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_i18n__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_events__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_social_sharing__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_social_sharing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_social_sharing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_offline_plugin_runtime__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_offline_plugin_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_offline_plugin_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vodal__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vodal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vodal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_carousel__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__translations_locales_es__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__translations_locales_fr__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__translations_locales_ar__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__translations_locales_ru__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vodal_common_css__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vodal_common_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vodal_common_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vodal_rotate_css__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vodal_rotate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vodal_rotate_css__);





__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);










__WEBPACK_IMPORTED_MODULE_9_offline_plugin_runtime__["install"]();


__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__, {
  load: {
    key: 'AIzaSyB16sGmIekuGIvYOfNoW9T44377IU2d2Es' }
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vue_social_sharing___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component(__WEBPACK_IMPORTED_MODULE_10_vodal___default.a.name, __WEBPACK_IMPORTED_MODULE_10_vodal___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_vue_carousel___default.a);






__webpack_require__(87);
__webpack_require__(86);
__webpack_require__(91);
__webpack_require__(99);



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vuex_i18n___default.a.plugin, __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.i18n.add('es', __WEBPACK_IMPORTED_MODULE_12__translations_locales_es__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.i18n.add('fr', __WEBPACK_IMPORTED_MODULE_13__translations_locales_fr__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.i18n.add('ar', __WEBPACK_IMPORTED_MODULE_14__translations_locales_ar__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.i18n.add('ru', __WEBPACK_IMPORTED_MODULE_15__translations_locales_ru__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_events___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],

  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_q__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_q__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);


var GMKEY = 'AIzaSyB16sGmIekuGIvYOfNoW9T44377IU2d2Es';
var GMBASE_URL = 'https://maps.googleapis.com/maps/api/geocode/json';
function getCoordinates(address) {
  address = address.replace(' ', '+');
  var url = GMBASE_URL + '?address=' + encodeURIComponent(address) + '&key=' + GMKEY;
  var deferred = __WEBPACK_IMPORTED_MODULE_0_q___default.a.defer();
  __WEBPACK_IMPORTED_MODULE_1_axios___default()({
    method: 'GET',
    url: url
  }).then(function (resp) {
    console.log('raw response');
    console.log(resp);
    if (resp.data === undefined && resp.data.results === undefined && resp.data.results[0] === undefined) {
      deferred.resolve(resp);
    } else {
      deferred.resolve(resp.data.results[0]);
    }
  }).catch(function (err) {
    deferred.reject(err);
  });

  return deferred.promise;
}
function getCenter(country) {
  var lat = 40.4167578;
  var long = -3.7059379;

  switch (country) {
    case 'fr':
      lat = 46.613326;
      long = 2.206351;
      break;
    case 'be':
      lat = 50.579488;
      long = 4.459974;
      break;
    case 'tn':
      lat = 34.110093;
      long = 9.613839;
      break;
    case 'ch':
      lat = 46.931645;
      long = 8.207400;
      break;
    case 'ma':
      lat = 32.014581;
      long = -6.477707;
      break;
    default:
      break;
  }
  return { lat: lat, lng: long };
}

function getMarkers(establishments) {
  if (establishments === undefined || establishments.length < 1) {
    return null;
  }
  var markers = [];
  for (var i = 0; i < establishments.length; i++) {
    var marker = {
      position: { lat: 0, lng: 0 },
      infoText: 'Marker'
    };
    marker.position.lat = establishments[i].geo_y;
    marker.position.lng = establishments[i].geo_x;
    marker.infoText = establishments[i].name;

    markers.push(marker);
  }
  return markers;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getCoordinates: getCoordinates,
  getCenter: getCenter,
  getMarkers: getMarkers
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var state = {
  RegisterCardResponse: {},
  AccountBalance: 0,
  BalanceCurrency: 'EUR',
  Transactions: []
};

var getters = {
  getTransactions: function getTransactions(state) {
    return state.Transactions;
  },
  getRegCardResponse: function getRegCardResponse(state) {
    return state.RegisterCardResponse;
  },
  getRegCardHasResponse: function getRegCardHasResponse(state) {
    return Boolean(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.RegisterCardResponse) === 0 && state.RegisterCardResponse === Object);
  },
  getBalance: function getBalance(state) {
    return parseInt(state.AccountBalance);
  },
  getCurrency: function getCurrency(state) {
    return state.BalanceCurrency;
  }
};

var mutations = {
  setTransactions: function setTransactions(state, context) {
    state.Transactions = context instanceof Array ? context : [];
  },
  setRegCardResponse: function setRegCardResponse(state, context) {
    state.RegisterCardResponse = context;
  },
  setBalance: function setBalance(state, context) {
    state.AccountBalance = parseInt(context) / 100;
  },
  setCurrency: function setCurrency(state, context) {
    state.BalanceCurrency = context;
  }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_variables__ = __webpack_require__(7);


var state = {
  Version: '1.1.8',
  CurrentState: '',
  CurrentPage: '',
  PreviousPage: '',
  NexPage: '',
  PageHistory: [],
  loading: false,
  notLoading: true,
  loadingStartedAt: null,
  loadingNormalSeconds: 5,
  api_url: 'http://localhost:8080',
  testMode: false,

  VNCC: 0,
  loginAsUser: true,
  showSlide: true,
  waitingFor: {},
  showGoTo: false,
  showShare: false,
  selectedCountry: 'ES',
  api_db: 'mhs',
  showSocialLogin: false,
  FBAuthorized: false,
  FBProfile: {},
  readyFB: false,
  showLoginVideo: true
};

var getters = {
  getShowVideo: function getShowVideo(state) {
    return state.showLoginVideo;
  },
  getReadyFB: function getReadyFB(state) {
    return state.readyFB;
  },
  getFBProfile: function getFBProfile(state) {
    return state.FBProfile;
  },
  getFBAuthorized: function getFBAuthorized(state) {
    return state.FBAuthorized;
  },
  getSocialLogin: function getSocialLogin(state) {
    return state.showSocialLogin;
  },
  getApiDB: function getApiDB(state) {
    return state.api_db;
  },
  getSelectedCountry: function getSelectedCountry(state) {
    return state.selectedCountry;
  },
  getShowShare: function getShowShare(state) {
    return state.showShare;
  },
  getShowGoTo: function getShowGoTo(state) {
    return state.showGoTo;
  },
  waitingForEstablishment: function waitingForEstablishment(state) {
    return state.waitingFor.POS;
  },
  waitingForBalance: function waitingForBalance(state) {
    return state.waitingFor.balance;
  },
  getStillLoading: function getStillLoading(state) {
    if (state.notLoading) {
      console.log('notLoading = ' + state.notLoading);
      return false;
    }
    var now = new Date();
    var diff = now - state.loadingStartedAt;
    var normal = state.loadingNormalSeconds * 1000;
    console.log('diff = ' + diff + ' normal = ' + normal);
    console.log('stillLoading = ' + (diff > normal));
    return diff > normal;
  },
  getShowSlide: function getShowSlide(state) {
    return state.showSlide;
  },
  getLoginAsUser: function getLoginAsUser(state) {
    return state.loginAsUser;
  },
  getAppMode: function getAppMode(state) {
    return state.testMode ? 'test' : 'normal';
  },
  getVNCC: function getVNCC(state) {
    return state.VNCC;
  },
  getVersion: function getVersion(state) {
    return state.Version;
  },
  getCurrentState: function getCurrentState(state) {
    return state.CurrentState;
  },
  getCurrentPage: function getCurrentPage(state) {
    return state.CurrentPage;
  },
  getPageHistory: function getPageHistory(state) {
    return state.PageHistory;
  },
  getLoading: function getLoading(state) {
    return state.loading;
  }
};

var mutations = {
  setShowVideo: function setShowVideo(state, context) {
    state.showLoginVideo = Boolean(context);
  },
  setReadyFB: function setReadyFB(state, context) {
    state.readyFB = Boolean(context);
  },
  setFBProfile: function setFBProfile(state, context) {
    if (context.name === undefined && context.id === undefined) {
      return;
    }
    state.FBProfile = context;
  },
  setFBAuthorized: function setFBAuthorized(state, context) {
    state.FBAuthorized = Boolean(context);
  },
  setShowSocialLogin: function setShowSocialLogin(state, context) {
    state.showSocialLogin = Boolean(context);
  },
  setSelectedCountry: function setSelectedCountry(state, context) {
    state.selectedCountry = typeof context === 'string' ? context.toUpperCase() : context.code;
  },
  setShowShare: function setShowShare(state, context) {
    state.showShare = Boolean(context);
  },
  setShowGoTo: function setShowGoTo(state, context) {
    state.showGoTo = Boolean(context);
  },
  setWaitingForEstablishment: function setWaitingForEstablishment(state, context) {
    state.waitingFor.POS = Boolean(context);
  },
  setWaitingForBalance: function setWaitingForBalance(state, context) {
    state.waitingFor.balance = Boolean(context);
  },
  setShowSlides: function setShowSlides(state, context) {
    state.showSlide = Boolean(context);
  },
  setLoginAsUser: function setLoginAsUser(state, context) {
    state.loginAsUser = Boolean(context);
  },
  incrementVNCC: function incrementVNCC(state) {
    state.VNCC += 1;
    if (state.VNCC === 5) {
      state.testMode = true;
      __WEBPACK_IMPORTED_MODULE_0__api_variables__["a" /* API_URL */].LastURL = __WEBPACK_IMPORTED_MODULE_0__api_variables__["a" /* API_URL */].CurrentUrl;
      __WEBPACK_IMPORTED_MODULE_0__api_variables__["a" /* API_URL */].CurrentUrl = 'https://api-test.microhuchasolidaria.org';
    } else if (state.VNCC > 5) {
      state.VNCC = 0;
      state.testMode = false;
    }
  },
  setAPIUrl: function setAPIUrl(state, url) {
    if (typeof url === 'string' && url !== '') {
      state.api_url = url;
      __WEBPACK_IMPORTED_MODULE_0__api_variables__["a" /* API_URL */].CurrentUrl = state.api_url;
    }
  },
  setAPI: function setAPI(state, apiName) {
    if (apiName === undefined) {
      switch (state.selectedCountry) {
        case 'ES':
          apiName = 'mhs';
          break;
        case 'FR':
          apiName = 'jva';
          break;
        case 'BE':
          apiName = 'jva';
          break;
        case 'CH':
          apiName = 'jva';
          break;
        case 'MA':
          apiName = 'jva';
          break;
        case 'TN':
          apiName = 'jva';
          break;
        case 'GB':
          apiName = 'iwth';
          break;
        case 'US':
          apiName = 'iwth';
          break;
        default:
          apiName = 'jva';
      }
    }

    apiName = typeof apiName === 'string' ? apiName.toLowerCase() : apiName;

    console.log('changing api to ' + apiName);
    if (apiName.indexOf('mhs') > -1) {
      state.api_url = 'https://api.microhuchasolidaria.org';
      state.api_db = 'mhs';
    } else if (apiName.indexOf('test-mhs') > -1) {
      state.api_url = 'https://api-test.microhuchasolidaria.org';
      state.api_db = 'test-mhs';
    } else if (apiName.indexOf('iwth') > -1) {
      state.api_url = 'https://api.iwanttohelp.org.uk';
      state.api_db = 'iwth';
    } else {
      state.api_url = 'https://api.jevaisaider.org';
      state.api_db = 'jva';
    }
    console.log(state.api_url);
    __WEBPACK_IMPORTED_MODULE_0__api_variables__["a" /* API_URL */].LastURL = __WEBPACK_IMPORTED_MODULE_0__api_variables__["a" /* API_URL */].CurrentUrl;
    __WEBPACK_IMPORTED_MODULE_0__api_variables__["a" /* API_URL */].CurrentUrl = state.api_url;
  },
  setCurrentState: function setCurrentState(state, newState) {
    state.CurrentState = newState;
  },
  setCurrentPage: function setCurrentPage(state, newPage) {
    state.PageHistory.push(newPage);
    console.log(newPage);
    state.CurrentPage = newPage;
  },
  setLoading: function setLoading(state, newValue) {
    if (newValue) {
      state.loadingStartedAt = new Date();
    }
    state.loading = newValue;
    state.notLoading = !state.loading;
  },
  goToPreviousPage: function goToPreviousPage(state) {
    if (state.PreviousPage) {
      state.CurrentPage = state.PreviousPage;

      state.NexPage = state.PageHistory.pop();
    }
  },
  goToNextPage: function goToNextPage(state) {
    if (state.NexPage) {
      state.PreviousPage = state.CurrentPage;

      state.CurrentPage = state.NexPage;
    }
  }
};

var actions = {
  changeCurrentState: function changeCurrentState(context) {
    context.commit('setCurrentState', context);
  },
  changeCurrentPage: function changeCurrentPage(context) {
    context.commit('setCurrentPage', context);
  },
  changeLoading: function changeLoading(context) {
    context.commit('setLoading', context);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  list: [],
  allAssociations: [],
  selected: {}
};

var getters = {
  getCurrentAssoList: function getCurrentAssoList(state) {
    return state.list;
  },
  getAssociations: function getAssociations(state) {
    return state.allAssociations;
  },
  getAssoById: function getAssoById(state, id) {
    return state.allAssociations.filter(function (asso) {
      return asso.id === id;
    });
  },
  getSelectedAssociation: function getSelectedAssociation(state) {
    return state.selected;
  }
};

var mutations = {
  setCurrentAssoList: function setCurrentAssoList(state, currentList) {
    state.list = currentList;
  },
  selectAssoById: function selectAssoById(state, id) {
    var assos = state.allAssociations.filter(function (asso) {
      return asso.id === id;
    });
    state.selected = assos[0];
  },
  setAssoList: function setAssoList(state, context) {
    if (context.list) {
      console.log('setting asso allAssociations');
      state.allAssociations = context.list;
      state.list = context.list;
      return;
    }
    console.log('not setting asso list');
  },
  resetAssoList: function resetAssoList(state) {
    state.allAssociations = [];
  }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  'list': [{
    'name': 'Spain',
    'db': 'mhs',
    'code': 'ES'
  }, {
    'name': 'France',
    'db': 'jva',
    'code': 'FR'
  }, {
    'name': 'Belgium',
    'db': 'jva',
    'code': 'BE'
  }, {
    'name': 'Switzerland',
    'db': 'jva',
    'code': 'CH'
  }, {
    'name': 'Morocco',
    'db': 'jva',
    'code': 'MA'
  }, {
    'name': 'Tunisia',
    'db': 'jva',
    'code': 'TN'
  }, {
    'name': 'United Kingdom',
    'db': 'iwth',
    'code': 'GB'
  }, {
    'name': 'United States',
    'db': 'iwth',
    'code': 'US'
  }, {
    'name': '_________________',
    'code': '_'
  }, {
    'name': 'Afghanistan',
    'code': 'AF'
  }, {
    'name': 'Åland Islands',
    'code': 'AX'
  }, {
    'name': 'Albania',
    'code': 'AL'
  }, {
    'name': 'Algeria',
    'code': 'DZ'
  }, {
    'name': 'American Samoa',
    'code': 'AS'
  }, {
    'name': 'AndorrA',
    'code': 'AD'
  }, {
    'name': 'Angola',
    'code': 'AO'
  }, {
    'name': 'Anguilla',
    'code': 'AI'
  }, {
    'name': 'Antarctica',
    'code': 'AQ'
  }, {
    'name': 'Antigua and Barbuda',
    'code': 'AG'
  }, {
    'name': 'Argentina',
    'code': 'AR'
  }, {
    'name': 'Armenia',
    'code': 'AM'
  }, {
    'name': 'Aruba',
    'code': 'AW'
  }, {
    'name': 'Australia',
    'code': 'AU'
  }, {
    'name': 'Austria',
    'code': 'AT'
  }, {
    'name': 'Azerbaijan',
    'code': 'AZ'
  }, {
    'name': 'Bahamas',
    'code': 'BS'
  }, {
    'name': 'Bahrain',
    'code': 'BH'
  }, {
    'name': 'Bangladesh',
    'code': 'BD'
  }, {
    'name': 'Barbados',
    'code': 'BB'
  }, {
    'name': 'Belarus',
    'code': 'BY'
  }, {
    'name': 'Belize',
    'code': 'BZ'
  }, {
    'name': 'Benin',
    'code': 'BJ'
  }, {
    'name': 'Bermuda',
    'code': 'BM'
  }, {
    'name': 'Bhutan',
    'code': 'BT'
  }, {
    'name': 'Bolivia',
    'code': 'BO'
  }, {
    'name': 'Bosnia and Herzegovina',
    'code': 'BA'
  }, {
    'name': 'Botswana',
    'code': 'BW'
  }, {
    'name': 'Bouvet Island',
    'code': 'BV'
  }, {
    'name': 'Brazil',
    'code': 'BR'
  }, {
    'name': 'British Indian Ocean Territory',
    'code': 'IO'
  }, {
    'name': 'Brunei Darussalam',
    'code': 'BN'
  }, {
    'name': 'Bulgaria',
    'code': 'BG'
  }, {
    'name': 'Burkina Faso',
    'code': 'BF'
  }, {
    'name': 'Burundi',
    'code': 'BI'
  }, {
    'name': 'Cambodia',
    'code': 'KH'
  }, {
    'name': 'Cameroon',
    'code': 'CM'
  }, {
    'name': 'Canada',
    'code': 'CA'
  }, {
    'name': 'Cape Verde',
    'code': 'CV'
  }, {
    'name': 'Cayman Islands',
    'code': 'KY'
  }, {
    'name': 'Central African Republic',
    'code': 'CF'
  }, {
    'name': 'Chad',
    'code': 'TD'
  }, {
    'name': 'Chile',
    'code': 'CL'
  }, {
    'name': 'China',
    'code': 'CN'
  }, {
    'name': 'Christmas Island',
    'code': 'CX'
  }, {
    'name': 'Cocos (Keeling) Islands',
    'code': 'CC'
  }, {
    'name': 'Colombia',
    'code': 'CO'
  }, {
    'name': 'Comoros',
    'code': 'KM'
  }, {
    'name': 'Congo',
    'code': 'CG'
  }, {
    'name': 'Congo, The Democratic Republic of the',
    'code': 'CD'
  }, {
    'name': 'Cook Islands',
    'code': 'CK'
  }, {
    'name': 'Costa Rica',
    'code': 'CR'
  }, {
    'name': 'Cote D\'Ivoire',
    'code': 'CI'
  }, {
    'name': 'Croatia',
    'code': 'HR'
  }, {
    'name': 'Cuba',
    'code': 'CU'
  }, {
    'name': 'Cyprus',
    'code': 'CY'
  }, {
    'name': 'Czech Republic',
    'code': 'CZ'
  }, {
    'name': 'Denmark',
    'code': 'DK'
  }, {
    'name': 'Djibouti',
    'code': 'DJ'
  }, {
    'name': 'Dominica',
    'code': 'DM'
  }, {
    'name': 'Dominican Republic',
    'code': 'DO'
  }, {
    'name': 'Ecuador',
    'code': 'EC'
  }, {
    'name': 'Egypt',
    'code': 'EG'
  }, {
    'name': 'El Salvador',
    'code': 'SV'
  }, {
    'name': 'Equatorial Guinea',
    'code': 'GQ'
  }, {
    'name': 'Eritrea',
    'code': 'ER'
  }, {
    'name': 'Estonia',
    'code': 'EE'
  }, {
    'name': 'Ethiopia',
    'code': 'ET'
  }, {
    'name': 'Falkland Islands (Malvinas)',
    'code': 'FK'
  }, {
    'name': 'Faroe Islands',
    'code': 'FO'
  }, {
    'name': 'Fiji',
    'code': 'FJ'
  }, {
    'name': 'Finland',
    'code': 'FI'
  }, {
    'name': 'French Guiana',
    'code': 'GF'
  }, {
    'name': 'French Polynesia',
    'code': 'PF'
  }, {
    'name': 'French Southern Territories',
    'code': 'TF'
  }, {
    'name': 'Gabon',
    'code': 'GA'
  }, {
    'name': 'Gambia',
    'code': 'GM'
  }, {
    'name': 'Georgia',
    'code': 'GE'
  }, {
    'name': 'Germany',
    'code': 'DE'
  }, {
    'name': 'Ghana',
    'code': 'GH'
  }, {
    'name': 'Gibraltar',
    'code': 'GI'
  }, {
    'name': 'Greece',
    'code': 'GR'
  }, {
    'name': 'Greenland',
    'code': 'GL'
  }, {
    'name': 'Grenada',
    'code': 'GD'
  }, {
    'name': 'Guadeloupe',
    'code': 'GP'
  }, {
    'name': 'Guam',
    'code': 'GU'
  }, {
    'name': 'Guatemala',
    'code': 'GT'
  }, {
    'name': 'Guernsey',
    'code': 'GG'
  }, {
    'name': 'Guinea',
    'code': 'GN'
  }, {
    'name': 'Guinea-Bissau',
    'code': 'GW'
  }, {
    'name': 'Guyana',
    'code': 'GY'
  }, {
    'name': 'Haiti',
    'code': 'HT'
  }, {
    'name': 'Heard Island and Mcdonald Islands',
    'code': 'HM'
  }, {
    'name': 'Holy See (Vatican City State)',
    'code': 'VA'
  }, {
    'name': 'Honduras',
    'code': 'HN'
  }, {
    'name': 'Hong Kong',
    'code': 'HK'
  }, {
    'name': 'Hungary',
    'code': 'HU'
  }, {
    'name': 'Iceland',
    'code': 'IS'
  }, {
    'name': 'India',
    'code': 'IN'
  }, {
    'name': 'Indonesia',
    'code': 'ID'
  }, {
    'name': 'Iran, Islamic Republic Of',
    'code': 'IR'
  }, {
    'name': 'Iraq',
    'code': 'IQ'
  }, {
    'name': 'Ireland',
    'code': 'IE'
  }, {
    'name': 'Isle of Man',
    'code': 'IM'
  }, {
    'name': 'Israel',
    'code': 'IL'
  }, {
    'name': 'Italy',
    'code': 'IT'
  }, {
    'name': 'Jamaica',
    'code': 'JM'
  }, {
    'name': 'Japan',
    'code': 'JP'
  }, {
    'name': 'Jersey',
    'code': 'JE'
  }, {
    'name': 'Jordan',
    'code': 'JO'
  }, {
    'name': 'Kazakhstan',
    'code': 'KZ'
  }, {
    'name': 'Kenya',
    'code': 'KE'
  }, {
    'name': 'Kiribati',
    'code': 'KI'
  }, {
    'name': 'Korea, Democratic People\'S Republic of',
    'code': 'KP'
  }, {
    'name': 'Korea, Republic of',
    'code': 'KR'
  }, {
    'name': 'Kuwait',
    'code': 'KW'
  }, {
    'name': 'Kyrgyzstan',
    'code': 'KG'
  }, {
    'name': 'Lao People\'S Democratic Republic',
    'code': 'LA'
  }, {
    'name': 'Latvia',
    'code': 'LV'
  }, {
    'name': 'Lebanon',
    'code': 'LB'
  }, {
    'name': 'Lesotho',
    'code': 'LS'
  }, {
    'name': 'Liberia',
    'code': 'LR'
  }, {
    'name': 'Libyan Arab Jamahiriya',
    'code': 'LY'
  }, {
    'name': 'Liechtenstein',
    'code': 'LI'
  }, {
    'name': 'Lithuania',
    'code': 'LT'
  }, {
    'name': 'Luxembourg',
    'code': 'LU'
  }, {
    'name': 'Macao',
    'code': 'MO'
  }, {
    'name': 'Macedonia, The Former Yugoslav Republic of',
    'code': 'MK'
  }, {
    'name': 'Madagascar',
    'code': 'MG'
  }, {
    'name': 'Malawi',
    'code': 'MW'
  }, {
    'name': 'Malaysia',
    'code': 'MY'
  }, {
    'name': 'Maldives',
    'code': 'MV'
  }, {
    'name': 'Mali',
    'code': 'ML'
  }, {
    'name': 'Malta',
    'code': 'MT'
  }, {
    'name': 'Marshall Islands',
    'code': 'MH'
  }, {
    'name': 'Martinique',
    'code': 'MQ'
  }, {
    'name': 'Mauritania',
    'code': 'MR'
  }, {
    'name': 'Mauritius',
    'code': 'MU'
  }, {
    'name': 'Mayotte',
    'code': 'YT'
  }, {
    'name': 'Mexico',
    'code': 'MX'
  }, {
    'name': 'Micronesia, Federated States of',
    'code': 'FM'
  }, {
    'name': 'Moldova, Republic of',
    'code': 'MD'
  }, {
    'name': 'Monaco',
    'code': 'MC'
  }, {
    'name': 'Mongolia',
    'code': 'MN'
  }, {
    'name': 'Montserrat',
    'code': 'MS'
  }, {
    'name': 'Mozambique',
    'code': 'MZ'
  }, {
    'name': 'Myanmar',
    'code': 'MM'
  }, {
    'name': 'Namibia',
    'code': 'NA'
  }, {
    'name': 'Nauru',
    'code': 'NR'
  }, {
    'name': 'Nepal',
    'code': 'NP'
  }, {
    'name': 'Netherlands',
    'code': 'NL'
  }, {
    'name': 'Netherlands Antilles',
    'code': 'AN'
  }, {
    'name': 'New Caledonia',
    'code': 'NC'
  }, {
    'name': 'New Zealand',
    'code': 'NZ'
  }, {
    'name': 'Nicaragua',
    'code': 'NI'
  }, {
    'name': 'Niger',
    'code': 'NE'
  }, {
    'name': 'Nigeria',
    'code': 'NG'
  }, {
    'name': 'Niue',
    'code': 'NU'
  }, {
    'name': 'Norfolk Island',
    'code': 'NF'
  }, {
    'name': 'Northern Mariana Islands',
    'code': 'MP'
  }, {
    'name': 'Norway',
    'code': 'NO'
  }, {
    'name': 'Oman',
    'code': 'OM'
  }, {
    'name': 'Pakistan',
    'code': 'PK'
  }, {
    'name': 'Palau',
    'code': 'PW'
  }, {
    'name': 'Palestinian Territory, Occupied',
    'code': 'PS'
  }, {
    'name': 'Panama',
    'code': 'PA'
  }, {
    'name': 'Papua New Guinea',
    'code': 'PG'
  }, {
    'name': 'Paraguay',
    'code': 'PY'
  }, {
    'name': 'Peru',
    'code': 'PE'
  }, {
    'name': 'Philippines',
    'code': 'PH'
  }, {
    'name': 'Pitcairn',
    'code': 'PN'
  }, {
    'name': 'Poland',
    'code': 'PL'
  }, {
    'name': 'Portugal',
    'code': 'PT'
  }, {
    'name': 'Puerto Rico',
    'code': 'PR'
  }, {
    'name': 'Qatar',
    'code': 'QA'
  }, {
    'name': 'Reunion',
    'code': 'RE'
  }, {
    'name': 'Romania',
    'code': 'RO'
  }, {
    'name': 'Russian Federation',
    'code': 'RU'
  }, {
    'name': 'RWANDA',
    'code': 'RW'
  }, {
    'name': 'Saint Helena',
    'code': 'SH'
  }, {
    'name': 'Saint Kitts and Nevis',
    'code': 'KN'
  }, {
    'name': 'Saint Lucia',
    'code': 'LC'
  }, {
    'name': 'Saint Pierre and Miquelon',
    'code': 'PM'
  }, {
    'name': 'Saint Vincent and the Grenadines',
    'code': 'VC'
  }, {
    'name': 'Samoa',
    'code': 'WS'
  }, {
    'name': 'San Marino',
    'code': 'SM'
  }, {
    'name': 'Sao Tome and Principe',
    'code': 'ST'
  }, {
    'name': 'Saudi Arabia',
    'code': 'SA'
  }, {
    'name': 'Senegal',
    'code': 'SN'
  }, {
    'name': 'Serbia and Montenegro',
    'code': 'CS'
  }, {
    'name': 'Seychelles',
    'code': 'SC'
  }, {
    'name': 'Sierra Leone',
    'code': 'SL'
  }, {
    'name': 'Singapore',
    'code': 'SG'
  }, {
    'name': 'Slovakia',
    'code': 'SK'
  }, {
    'name': 'Slovenia',
    'code': 'SI'
  }, {
    'name': 'Solomon Islands',
    'code': 'SB'
  }, {
    'name': 'Somalia',
    'code': 'SO'
  }, {
    'name': 'South Africa',
    'code': 'ZA'
  }, {
    'name': 'South Georgia and the South Sandwich Islands',
    'code': 'GS'
  }, {
    'name': 'Sri Lanka',
    'code': 'LK'
  }, {
    'name': 'Sudan',
    'code': 'SD'
  }, {
    'name': 'Suriname',
    'code': 'SR'
  }, {
    'name': 'Svalbard and Jan Mayen',
    'code': 'SJ'
  }, {
    'name': 'Swaziland',
    'code': 'SZ'
  }, {
    'name': 'Sweden',
    'code': 'SE'
  }, {
    'name': 'Syrian Arab Republic',
    'code': 'SY'
  }, {
    'name': 'Taiwan, Province of China',
    'code': 'TW'
  }, {
    'name': 'Tajikistan',
    'code': 'TJ'
  }, {
    'name': 'Tanzania, United Republic of',
    'code': 'TZ'
  }, {
    'name': 'Thailand',
    'code': 'TH'
  }, {
    'name': 'Timor-Leste',
    'code': 'TL'
  }, {
    'name': 'Togo',
    'code': 'TG'
  }, {
    'name': 'Tokelau',
    'code': 'TK'
  }, {
    'name': 'Tonga',
    'code': 'TO'
  }, {
    'name': 'Trinidad and Tobago',
    'code': 'TT'
  }, {
    'name': 'Turkey',
    'code': 'TR'
  }, {
    'name': 'Turkmenistan',
    'code': 'TM'
  }, {
    'name': 'Turks and Caicos Islands',
    'code': 'TC'
  }, {
    'name': 'Tuvalu',
    'code': 'TV'
  }, {
    'name': 'Uganda',
    'code': 'UG'
  }, {
    'name': 'Ukraine',
    'code': 'UA'
  }, {
    'name': 'United Arab Emirates',
    'code': 'AE'
  }, {
    'name': 'United States Minor Outlying Islands',
    'code': 'UM'
  }, {
    'name': 'Uruguay',
    'code': 'UY'
  }, {
    'name': 'Uzbekistan',
    'code': 'UZ'
  }, {
    'name': 'Vanuatu',
    'code': 'VU'
  }, {
    'name': 'Venezuela',
    'code': 'VE'
  }, {
    'name': 'Viet Nam',
    'code': 'VN'
  }, {
    'name': 'Virgin Islands, British',
    'code': 'VG'
  }, {
    'name': 'Virgin Islands, U.S.',
    'code': 'VI'
  }, {
    'name': 'Wallis and Futuna',
    'code': 'WF'
  }, {
    'name': 'Western Sahara',
    'code': 'EH'
  }, {
    'name': 'Yemen',
    'code': 'YE'
  }, {
    'name': 'Zambia',
    'code': 'ZM'
  }, {
    'name': 'Zimbabwe',
    'code': 'ZW'
  }]
};
var getters = {
  getAllCountries: function getAllCountries(state) {
    return state.list;
  },
  getTopCountries: function getTopCountries(state) {
    var topCountries = [];

    var topNumber = 6;
    for (var i = 0; i < topNumber; i++) {
      topCountries[i] = state.list[i];
    }
    return topCountries;
  },
  getOtherCountries: function getOtherCountries(state) {
    var otherCountries = [{ name: '_______________', code: '_' }];
    var j = 1;
    for (var i = 4; i < state.list.length; i++) {
      otherCountries[j] = state.list[i];
      j++;
    }
    return otherCountries;
  },
  getCountryByName: function getCountryByName(state, name) {
    for (var i = 0; i < state.list.length; i++) {
      if (state.list[i].name === name) {
        return state.list[i];
      }
    }
    return {};
  },
  getCountryByCode: function getCountryByCode(state, code) {
    for (var i = 0; i < state.list.length; i++) {
      if (state.list[i].code === code) {
        return state.list[i];
      }
    }
    return {};
  }
};

var mutations = {};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  total_donations: 0
};

var getters = {
  getDonationsTotal: function getDonationsTotal(state) {
    return state.total_donations;
  }
};

var mutations = {
  setDonationTotal: function setDonationTotal(state, context) {
    state.total_donations = parseFloat(context.total_donations) / 100;
  }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  Establishment: {
    created_at: '',
    updated_at: '',
    unique_id: '',
    qr_code: '',
    qr_url: '',
    geo_x: 0,
    geo_y: 0,
    address: '',
    zip_code: 0,
    city: '',
    country: '',
    id: 0,
    user_id: 0,
    active: false,
    name: '',
    cif: '0',
    end_subscription: '',
    Subscriptions: null
  },
  UserEstablishments: [],
  AllEstablishments: []
};

var getters = {
  getAllEstablishments: function getAllEstablishments(state) {
    return state.AllEstablishments;
  },
  getUserEstablishments: function getUserEstablishments(state) {
    return state.UserEstablishments;
  },
  getPOSQRCode: function getPOSQRCode(state) {
    return state.Establishment.qr_code;
  },
  getEstablishment: function getEstablishment(state) {
    return state.Establishment;
  },
  getPosSubscriptionEnd: function getPosSubscriptionEnd(state) {
    console.log('getPosSubscriptionEnd');
    if (state.Establishment.end_subscription && state.Establishment.end_subscription === '') {
      return 0;
    }
    var end = new Date(state.Establishment.end_subscription);
    var now = new Date();
    var days = Math.floor((end - now) / (3600000 * 24));
    return typeof days === 'number' ? days : parseInt(days);
  }
};

var mutations = {
  setAllEstablishments: function setAllEstablishments(state, context) {
    console.log('setting all establishments');
    console.log(context);
    state.AllEstablishments = context;
  },
  setUserEstablishments: function setUserEstablishments(state, list) {
    state.UserEstablishments = list;
  },
  setEstablishment: function setEstablishment(state, pos) {
    state.Establishment = pos;
  }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  errorMessages: [],
  warningMessage: '',
  infoMessage: '',
  successMessage: ''
};

var getters = {
  getErrors: function getErrors(state) {
    return state.errorMessages;
  },
  getWarning: function getWarning(state) {
    return state.warningMessage;
  },
  getInfo: function getInfo(state) {
    return state.infoMessage;
  },
  getSuccess: function getSuccess(state) {
    return state.successMessage;
  }
};

var mutations = {
  setErrors: function setErrors(state, errors) {
    for (var i = 0; i < errors.length; i++) {
      console.log(errors[i]);
      if (errors[i].error) {
        state.errorMessages.push(errors[i].error);
      }
    }
  },
  resetMessages: function resetMessages(state) {
    state.errorMessages = [];
    state.warningMessage = '';
    state.infoMessage = '';
    state.successMessage = '';
  },
  setError: function setError(state, error) {
    state.errorMessages.push(error);
  },
  setWarning: function setWarning(state, warning) {
    state.warningMessage = warning;
  },
  setInfo: function setInfo(state, info) {
    state.infoMessage = info;
  },
  setSuccess: function setSuccess(state, success) {
    state.successMessage = success;
  }
};

var actions = {
  error: function error(context) {
    context.commit('setErrors');
  },
  warning: function warning(context) {
    context.commit('setWarning');
  },
  info: function info(context) {
    context.commit('setInfo');
  },
  success: function success(context) {
    context.commit('setSuccess');
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  currentImages: [{ 'img': 'Webapp-Plain-1.png', 'title': '', 'styles': { backgroundColor: '#fff', width: '100%', height: '100%' } }, { 'img': 'Webapp-Plain-1.png', 'title': '', 'styles': { backgroundColor: '#fff', width: '100%', height: '100%' } }],
  images: {
    'en': { 'img': 'slide-img-fr.png', 'title': '' },
    'ar': { 'img': 'slide-img-fr.png', 'title': '' },
    'es': { 'img': 'slide-img-es.png', 'title': '' },
    'fr': { 'img': 'slide-img-fr.png', 'title': '' },
    'it': { 'img': 'slide-img-fr.png', 'title': '' },
    'pt': { 'img': 'slide-img-fr.png', 'title': '' },
    'ru': { 'img': 'slide-img-fr.png', 'title': '' }
  },
  list: {
    'images': {
      'jva': [{ 'img': 'Webapp-JeVaisAider-1.png', 'title': '', 'styles': { backgroundColor: '#fff', width: '100%', height: '100%' } }, { 'img': 'Webapp-JeVaisAider-2.png', 'title': '', 'styles': { backgroundColor: '#fff', width: '100%', height: '100%' } }],
      'mhs': [{ 'img': 'Webapp-YoQuieroAyudar-1.png', 'title': '', 'styles': { backgroundColor: '#fff', width: '100%', height: '100%' } }, { 'img': 'Webapp-YoQuieroAyudar-2.png', 'title': '', 'styles': { backgroundColor: '#fff', width: '100%', height: '100%' } }]
    },
    'en': {
      'slides': [{
        'text': 'I create and validate my account.<br>I credit my account with my credit card...',
        'style': { backgroundColor: '#FF9933', width: '100%', height: '100%' }
      }, {
        'text': 'I can browse non-profit charities and I decide to donate from 2 to 10 euros. I can give as many times as I want...',
        'style': { backgroundColor: '#CC0066', width: '100%', height: '100%' }
      }, {
        'text': 'my donation is transmitted to the charity with 0 comission...',
        'style': { backgroundColor: '#CCCC33', width: '100%', height: '100%' }
      }, {
        'text': 'I can ask the charity for my tax certificate.',
        'style': { backgroundColor: '#FF9933', width: '100%', height: '100%' }
      }]
    }
  }
};

var getters = {
  getSlideImage: function getSlideImage(state) {
    var lang = localStorage.getItem('user_locale');
    if (lang === '' || lang === null) {
      return state.images.fr;
    }
    if (state.images[lang] !== undefined) {
      return state.images[lang];
    }
    return state.currentImages;
  },
  getCurrentSlides: function getCurrentSlides(state) {
    var lang = localStorage.getItem('user_locale');
    if (lang === '' || lang === null) {
      return state.list.en;
    }
    if (state.list[lang] !== undefined) {
      return state.list[lang];
    }
    return state.list.en;
  },
  getCurrentImages: function getCurrentImages(state) {
    console.log('getCurrentImages');
    return state.currentImages;
  },
  getAllImages: function getAllImages(state) {
    return state.list.images;
  }
};

var mutations = {
  setCurrentImages: function setCurrentImages(state, context) {
    console.log('getCurrentImages');

    var api = context;
    console.log('api_db: ' + api);
    switch (api) {
      case 'jva':
        state.currentImages = state.list.images.jva;
        break;
      case 'mhs':
        state.currentImages = state.list.images.mhs;
        break;
      case 'iwth':
        state.currentImages = state.list.images.jva;
        break;
      default:
        state.currentImages = state.list.images.jva;
        break;
    }
  }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  user: {
    email: '',
    password: ''
  },
  jwt_token: '',
  userType: ''
};

var getters = {
  getUserType: function getUserType(state) {
    return state.userType;
  },
  getLogin: function getLogin(state) {
    return state.jwt_token !== '';
  },
  getEmail: function getEmail(state) {
    return state.user.email;
  },
  getToken: function getToken(state) {
    return state.jwt_token;
  }
};

var mutations = {
  setUserType: function setUserType(state, type) {
    state.userType = type.toUpperCase();
  },
  setToken: function setToken(state, token) {
    state.jwt_token = token;
  },
  login: function login(state) {},
  logout: function logout(state) {
    state.jwt_token = '';
  },
  updateEmail: function updateEmail(state, email) {
    state.user.email = email;
  },
  updatePassword: function updatePassword(state, password) {
    state.user.password = password;
  }
};

var actions = {
  login: function login(context) {
    context.commit('loginMutation');
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jwt_decode__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_ga__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_ga__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Home_vue__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Logout_vue__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Logout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Logout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Login_vue__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Signup_vue__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Signup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Signup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SignupPOS_vue__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SignupPOS_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_SignupPOS_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Messages_vue__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Messages_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Messages_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Share_vue__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Share_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Share_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Associations_vue__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Associations_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Associations_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Association_vue__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Association_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Association_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Donations_vue__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Donations_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Donations_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_SolidarityAccount_vue__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_SolidarityAccount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_SolidarityAccount_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Settings_vue__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Slides_vue__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Slides_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Slides_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Subscription__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Subscription___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Subscription__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_QRCode_vue__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_QRCode_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_QRCode_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Map_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Map_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Map_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_SupportivePOS_vue__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_SupportivePOS_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_SupportivePOS_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_GoTo_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_GoTo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_GoTo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Transactions_vue__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Transactions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_Transactions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_FBLogin_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_FBLogin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_FBLogin_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Admin_vue__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Admin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_Admin_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__api_variables__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_axios__);







var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]();
__WEBPACK_IMPORTED_MODULE_2_vue_ga___default()(router, 'UA-86334488-3');


























(function (d, s, id) {
  var js;
  var fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s);js.id = id;
  js.src = '//connect.facebook.net/en_US/sdk.js';
  fjs.parentNode.insertBefore(js, fjs);
})(document, 'script', 'facebook-jssdk');

/* harmony default export */ __webpack_exports__["default"] = ({
  beforeDestroy: function beforeDestroy() {
    console.log('beforeDestroy');
  },
  mounted: function mounted() {
    var _this = this;

    this.$events.listen('socialLoginEvent', function (eventData) {
      var vm = _this;
      console.log('socialLoginEvent');
      if (eventData.type !== undefined && eventData.type.length > 1) {
        var url = __WEBPACK_IMPORTED_MODULE_25__api_variables__["a" /* API_URL */].CurrentUrl + '/signin/' + eventData.type;
        console.log('data');
        var Data = { 'token': eventData.token };

        __WEBPACK_IMPORTED_MODULE_26_axios___default()({
          method: 'POST',
          url: url,
          data: Data
        }).then(function (resp) {
          console.log(eventData.type + ' login response');
          console.log(resp);
          if (resp.data !== undefined && resp.data.token !== undefined) {
            var decoded = __WEBPACK_IMPORTED_MODULE_1_jwt_decode___default()(resp.data.token);
            console.log('loggedin successfully');
            vm.$store.commit('setShowSocialLogin', false);

            vm.$events.$emit('loginEvent', { token: resp.data.token, 'decoded': decoded });
            vm.$events.emit('goToPageEvent', 'home');
          } else if (resp.token) {
            console.log('loggedin successfully');
            vm.$store.commit('setToken', resp.token);
            vm.$events.emit('goToPageEvent', 'home');
            localStorage.setItem('socialLogin', true);
          }
        }).catch(function (err) {
          console.log(eventData.type + ' login error');
          console.log(err);
        });
      }
    });

    this.$events.listen('initializeFBEvent', function (eventData) {
      console.log('initializeFBEvent');
      var vm = _this;
      var FBAPPID = '';
      var domainName = window.location.hostname;
      switch (domainName) {
        case 'web.jevaisaider.org':
          console.log('using jva id');
          FBAPPID = '1279278258816835';
          break;
        case 'web.microhuchasolidaria.org':
          console.log('using mhs id');
          FBAPPID = '219601041795109';
          break;
        default:
          console.log('using default id');
          FBAPPID = '219601041795109';
      }
      window.fbAsyncInit = function () {
        console.log('FACEBOOK LOGIN fbAsyncInit');

        window.FB.init({
          appId: FBAPPID,
          cookie: true,
          xfbml: true,
          version: 'v2.9'
        });
        window.FB.getLoginStatus(function (response) {
          console.log('FACEBOOK LOGIN getLoginStatus');
          console.log(response);
          vm.$events.emit('statusChangeFBEvent', response);
        });
      };
    });

    this.$events.listen('getFBProfileEvent', function (eventData) {
      console.log('FACEBOOK LOGIN getProfile()');

      window.FB.api('/me', function (response) {
        console.log('getProfile response');
        console.log(response);

        vm.$store.commit('setFBProfile', response);
      });
    });

    this.$events.listen('loginFBEvent', function (eventData) {
      console.log('FACEBOOK LOGIN login()');
      var vm = _this;

      FB.login(function (response) {
        console.log('login response');
        console.log(response);
        vm.$events.emit('statusChangeFBEvent', response);
      }, { scope: 'publish_actions' });
    });
    this.$events.listen('logoutFBEvent', function (eventData) {
      console.log('FACEBOOK LOGIN logout()');
      var vm = _this;

      FB.logout(function (response) {
        console.log('logout response');
        console.log(response);
        vm.$events.emit('statusChangeFBEvent', response);
      });
    });
    this.$events.listen('statusChangeFBEvent', function (response) {
      console.log('FACEBOOK LOGIN statusChangeCallback');
      var vm = _this;
      vm.ready = true;
      console.log('statusChangeCallback');
      console.log(response);
      if (response.status === 'connected') {
        vm.$events.emit('socialLoginEvent', {
          type: 'facebook',
          token: response.authResponse.accessToken
        });
        vm.$store.commit('setFBAuthorized', true);
        vm.authorized = true;
        vm.$events.imit('getFBProfileEvent', response);
      } else if (response.status === 'not_authorized') {
        vm.authorized = false;
        vm.$store.commit('setFBAuthorized', false);
        localStorage.removeItem('socialLoginToken');
      } else {
        vm.authorized = false;
        vm.$store.commit('setFBAuthorized', false);
        localStorage.removeItem('socialLoginToken');
      }
    });

    this.$events.listen('changeLanguage', function (eventData) {
      console.log('changeLanguage');
      var lang = String(eventData).toLowerCase();
      if (lang === null || lang === 'null') {
        return;
      }
      _this.setLang(lang);
      console.log('changedLanguage to: ' + lang);
      _this.$events.emit('languageChanged', lang);
    });

    var langFromUrl = this.getQueryParam('lang');
    this.$events.emit('changeLanguage', langFromUrl);
    console.log('langFromUrl');
    console.log(langFromUrl);

    var currentUrl = window.location.hostname;
    console.log('You are on ' + currentUrl);
    this.$store.commit('setAPI', this.getApiByCurrentDomainName());
    localStorage.setItem('country_code', this.getCountryByCurrentDomainName());

    var allPars = this.parseAllParams();
    console.log('allPars:');
    console.log(allPars);

    if (allPars.db !== undefined && allPars.country === undefined) {
      clearTimeout(this.tOuts.changeApiTimeout);
      this.tOuts.changeApiTimeout = setTimeout(function () {
        console.log('apiType = ' + allPars.db);
        console.log('setAPIUrlLEvent');
        _this.$events.emit('setAPIUrlLEvent', allPars.db);
        _this.$store.commit('setCurrentImages', allPars.db);
      }, 500);
    }
    if (allPars.country !== undefined) {
      clearTimeout(this.tOuts.selectCountryTimeout);
      this.tOuts.selectCountryTimeout = setTimeout(function () {
        console.log('setting country to ' + allPars.country);
        var countryCode = typeof allPars.country === 'string' ? allPars.country.toUpperCase() : _this.getCountryByCurrentDomainName();
        _this.$store.commit('setSelectedCountry', countryCode);
        _this.$store.commit('setAPI', undefined);
        _this.$store.commit('setCurrentImages', _this.$store.getters.getApiDB);
      }, 500);
    }

    if (allPars.height !== undefined) {
      this.setCurrentHeight(allPars.height);
    }
    if (allPars.width !== undefined) {
      this.setCurrentWidth(allPars.width);
    }
    var singupAsPOS = allPars['pos-signup'];
    console.log('SIGNUP POST VALUE:', singupAsPOS);
    var singupAsUser = allPars['user-signup'];
    var loginAsPOS = allPars['pos-login'];

    if (singupAsPOS) {
      this.goDirectlyTo('signupPOS');
    } else if (singupAsUser) {
      this.goDirectlyTo('signup');
    } else if (loginAsPOS) {
      this.goDirectlyTo('loginPOS');
    }

    this.$events.listen('testEvent', function (eventData) {
      console.log('testEvent');
      console.log(eventData);
    });

    this.$events.listen('getCharitiesEvent', function (eventData) {
      var now = new Date();

      _this.lastChecked.associations = now;

      console.log('getCharitiesEvent');

      _this.getAssociationsFromAPI();
    });

    this.$events.listen('setAPIUrlLEvent', function (eventData) {
      console.log('setAPIUrlLEvent');
      if (!eventData) {
        return;
      }
      console.log('db = ' + eventData);
      if (eventData !== undefined) {
        _this.$store.commit('setAPI', eventData);
        return;
      }
      if (eventData && eventData.url) {
        _this.$store.commit('setAPIUrl', eventData.url);
      }
      _this.$store.commit('setCurrentImages', _this.$store.getters.getApiDB);
    });
    this.$events.listen('showGoToModalEvent', function (eventData) {
      _this.goToModalData = eventData;
      _this.$store.commit('setShowGoTo', true);
    });
    this.$events.listen('fetchUserEstablishmentsEvent', function (eventData) {
      _this.fetchUserEstablishments();
    });
    this.$events.listen('fetchEstablishmentEvent', function (eventData) {
      if (_this.$store.getters.waitingForEstablishment) {
        console.log('already waiting for the last requested Establishment');
        return;
      }
      var tOut = 1000;
      if (eventData && eventData.timeOut !== undefined) {
        tOut = eventData.timeOut;
      }
      _this.$store.commit('setWaitingForEstablishment', true);
      console.log('fetchEstablishmentEvent');
      clearTimeout(_this.tOuts.establishmentsTimeout);
      _this.tOuts.establishmentsTimeout = setTimeout(function () {
        _this.fetchEstablishment();
        if (eventData && eventData.loop) {
          setTimeout(function () {
            _this.$events.emit('fetchEstablishmentEvent', {});
          });
        }
      }, tOut);
    });
    this.$events.listen('sendLoginEvent', function (eventData) {
      console.log('sendLoginEvent');
      _this.sendLogin(eventData);
    });

    this.$events.listen('sendEvent', function (eventData) {
      console.log('got sendEvent');
      console.log(eventData);

      __WEBPACK_IMPORTED_MODULE_2_vue_ga___default()('send', 'event', eventData.type, eventData.action, eventData.label, eventData.value);
    });

    this.$events.listen('goToPageEvent', function (pageName) {
      console.log('got goToPageEvent');
      var slash = pageName.indexOf('/');
      if (slash > 0) {
        pageName = pageName.slice(0, slash);
      }
      _this.$store.commit('setCurrentPage', pageName);
      _this.$events.emit('pageChangedEvent', pageName);
    });

    this.$events.listen('subscriptionSuccessEvent', function (months) {
      _this.$events.emit('pageChangedEvent', '/subscription/success/url-' + document.location.hostname + '/' + months + 'month');
    });

    __WEBPACK_IMPORTED_MODULE_2_vue_ga___default()(function (collect) {
      _this.$events.listen('pageChangedEvent', function (name) {
        console.log('visitng ' + name);
        collect(name);
      });
    }, 'UA-86334488-3');

    this.$events.listen('skipSlideEvent', function (eventData) {
      console.log('got skipSlideEvent');
      _this.$store.commit('setShowSlides', false);
    });

    this.$events.listen('logoutEvent', function (eventData) {
      console.log('LOGING OUT EVENT');
      _this.sentLoginEvent = false;
      console.log(eventData);
      _this.$store.commit('logout');
      _this.$store.commit('setCurrentState', 'login');

      _this.$events.emit('goToPageEvent', 'login');
      _this.$store.commit('resetMessages');
      _this.$store.commit('resetAssoList');
      localStorage.clear();
      _this.$store.commit('setAPI', 'mhs');
      window.location.reload();
    });

    this.$events.listen('checkDonationMeterics', function (eventData) {
      _this.getDonationMetrics();
    });

    this.$events.listen('loginEvent', function (eventData) {
      console.log('LOGIN EVENT');
      console.log(eventData);
      console.log('saving user data');
      if (eventData.decoded !== undefined) {
        localStorage.setItem('user_data', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(eventData.decoded));
        var userType = eventData.decoded.status || 'USER';
        if (userType === 'POS') {
          console.log('user type is POS');
          _this.$events.emit('fetchEstablishmentEvent');
        }
        _this.$store.commit('setUserType', eventData.decoded.status);
      }

      console.log('saving user token');
      localStorage.setItem('user_token', eventData.token);
      _this.$store.commit('setToken', eventData.token);
      localStorage.setItem('rememberMe', eventData.rememberMe);
      console.log('setting USER TYPE: ');
      _this.$store.commit('setCurrentState', 'loggedin');
      _this.$store.commit('setCurrentPage', 'home');
      _this.setMessage({ 'success': 'Login successfully!' });
      var vm = _this;
      clearTimeout(_this.tOuts.balanceTimout);
      _this.tOuts.balanceTimout = setTimeout(function () {
        vm.$events.$emit('acountUpdate', {});
      }, 1000);
    });

    this.$events.listen('acountUpdate', function (eventData) {
      console.log('acountUpdate EVENT');
      if (!_this.$store.getters.getLogin) {
        console.log('not loggedin, returning');
        return;
      }
      if (_this.$store.getters.waitingForBalance) {
        console.log('already waiting for balance request');
        return;
      }
      _this.$store.commit('setWaitingForBalance', true);

      if (_this.$store.getters.getUserType === 'POS') {
        return;
      }
      var vm = _this;
      var url = __WEBPACK_IMPORTED_MODULE_25__api_variables__["a" /* API_URL */].CurrentUrl + __WEBPACK_IMPORTED_MODULE_25__api_variables__["b" /* WALLET_BALANCE_URL */];

      __WEBPACK_IMPORTED_MODULE_26_axios___default()({
        url: url,
        headers: { 'Authorization': 'Bearer ' + localStorage.getItem('user_token') }
      }).then(function (resp) {
        _this.$store.commit('setWaitingForBalance', false);
        if (!resp.data) {
          console.log('no response data');
          return;
        }
        console.log('response data');
        console.log(resp.data);
        if (resp.data.balance) {
          console.log('no balance data');

          vm.$store.commit('setCurrency', resp.data.balance.Currency);
          vm.$store.commit('setBalance', resp.data.balance.Amount);
          if (localStorage.getItem('lastBalance') < resp.data.balance.Amount) {
            localStorage.setItem('lastBalance', null);
          }
        }
      }).catch(function (err) {
        _this.$store.commit('setWaitingForBalance', false);
        console.log('axios failed');
        console.log(err.data);
      });
    });
  },
  beforeCreate: function beforeCreate() {
    console.log('beforeCreate');

    console.log('clearing all Event Listeners');
    this.$events.remove('changeLanguage');
    this.$events.remove('getCharitiesEvent');
    this.$events.remove('setAPIUrlLEvent');
    this.$events.remove('showGoToModalEvent');
    this.$events.remove('fetchEstablishmentEvent');
    this.$events.remove('setWaitingForEstablishment');
    this.$events.remove('sendLoginEvent');
    this.$events.remove('sendEvent');
    this.$events.remove('goToPageEvent');
    this.$events.remove('pageChangedEvent');
    this.$events.remove('skipSlideEvent');
    this.$events.remove('logoutEvent');
    this.$events.remove('checkDonationMeterics');
    this.$events.remove('loginEvent');
    this.$events.remove('acountUpdate');
    this.$events.remove('initializeFBEvent');
    this.$events.remove('getFBProfileEvent');
    this.$events.remove('loginFBEvent');
    this.$events.remove('logoutFBEvent');
    this.$events.remove('statusChangeFBEvent');
    this.$events.remove('socialLoginEvent');
    this.$events.remove('fetchUserEstablishmentsEvent');

    var vm = this;
    setTimeout(function () {
      vm.$store.commit('resetMessages');
    }, 5000);

    var rememberMe = localStorage.getItem('rememberMe');

    if (rememberMe !== null) {
      var jwtToken = localStorage.getItem('user_token');
      if (jwtToken !== null) {
        localStorage.clear();
      } else {
        this.$store.commit('setCurrentState', 'login');
        localStorage.setItem('country_code', this.getCountryByCurrentDomainName());
        return 'login';
      }

      return this.$store.getters.getCurrentState;
    }
  },
  beforeMount: function beforeMount() {
    console.log('beforeMount');
  },
  beforeUpdate: function beforeUpdate() {
    console.log('beforeUpdate');
  },
  data: function data() {
    return {
      langDirection: '',
      helpLink: 'https://github.com/YoQuieroAyudar/fundraising-API-web-app/wiki/Help',
      lang: 'en',
      showSlide: true,
      goToModalData: {
        url: '#link',
        title: 'Go To Page',
        message: 'Go to this page',
        buttonText: 'Continue'
      },
      showShare: false,
      tOuts: {
        charityTimeout: 0,
        balanceTimout: 0,
        establishmentsTimeout: 0,
        changeApiTimeout: 0,
        selectCountryTimeout: 0
      },
      sentLoginEvent: false,
      lastChecked: {
        balance: null,
        associations: null
      },
      targetNames: [{
        'name': 'localhost',
        'country': 'ES',
        'db': 'mhs'
      }, {
        'name': 'jevaisaider',
        'country': 'FR',
        'db': 'jva'
      }, {
        'name': 'microhuchasolidaria',
        'country': 'ES',
        'db': 'mhs'
      }, {
        'name': 'iwanttohelp',
        'country': 'UK',
        'db': 'iwth'
      }]
    };
  },

  methods: {
    setCurrentHeight: function setCurrentHeight(value) {
      var element = document.getElementById('wrapper');
      if (parseInt(value) < 370) {
        value = 370;
        this.$store.commit('setShowVideo', false);
      } else if (parseInt(value) < 500) {
        this.$store.commit('setShowVideo', false);
      } else {
        this.$store.commit('setShowVideo', true);
      }
      console.log('setting height to ' + value);
      element.style.height = parseInt(value) + 'px';
    },
    setCurrentWidth: function setCurrentWidth(value) {
      var element = document.getElementById('wrapper');
      value = parseInt(value) < 300 ? 300 : value;
      console.log('setting width to ' + value);
      element.style.width = parseInt(value) + 'px';
    },
    getApiByCurrentDomainName: function getApiByCurrentDomainName() {
      console.log('getApiByCurrentDomainName');
      var currentDomainName = location.hostname;
      currentDomainName = currentDomainName.toLowerCase();

      var targetNames = this.targetNames;

      console.log('current url ' + currentDomainName);

      for (var i = 0; i < targetNames.length; i++) {
        console.log(i + '- name = ' + targetNames[i].name);
        console.log('db = ' + targetNames[i].db);
        console.log('name is in url' + currentDomainName.indexOf(targetNames[i].name));

        if (currentDomainName.indexOf(targetNames[i].name.toLowerCase()) > -1) {
          console.log('current url ' + currentDomainName);
          console.log('setting db to ' + targetNames[i].db);
          return targetNames[i].db;
        }
      }
      return 'mhs';
    },
    getCountryByCurrentDomainName: function getCountryByCurrentDomainName() {
      console.log('getCountryByCurrentDomainName');
      var currentDomainName = location.hostname;
      currentDomainName = currentDomainName.toLowerCase();

      console.log('current url ' + currentDomainName);

      var targetNames = this.targetNames;

      for (var i = 0; i < targetNames.length; i++) {
        console.log(i + '- target ' + targetNames[i].name);
        if (currentDomainName.indexOf(targetNames[i].name.toLowerCase()) > -1) {
          console.log('setting country to ' + targetNames[i].country);
          return targetNames[i].country;
        }
      }
      return 'ES';
    },
    goToCharityPage: function goToCharityPage(id) {
      console.log('going to charity ' + id + ' page');
      var assos = this.$store.getters.getAssociations;
      console.log('found ' + assos.length + ' charities');
      console.log('found ' + this.$store.getters.getCurrentAssoList.length + ' charities');
      var found = null;

      for (var i = 0; i < assos.length; i++) {
        console.log('asso.id = ' + assos[i].id);
        console.log('asso.id === id ' + (parseInt(assos[i].id) === parseInt(id)));
        if (parseInt(assos[i].id) === parseInt(id)) {
          console.log('found');
          console.log(assos[i]);
          found = assos[i];
        }
      }
      if (found !== null) {
        this.$store.commit('selectAssoById', found.id);
        this.$events.emit('goToPageEvent', 'asso_details/' + found.id);
      }
    },
    goDirectlyTo: function goDirectlyTo(pageName) {
      console.log('goDirectlyTo: ' + pageName);
      var vm = this;
      vm.$store.commit('setLoading', true);
      vm.$store.commit('setShowSlides', false);

      var loginAsUser = !(pageName === 'signupPOS' || pageName === 'loginPOS');

      pageName = pageName === 'loginPOS' ? 'login' : pageName;

      console.log('goDirectlyTo: ' + pageName + ' loginAsUser: ' + loginAsUser);

      setTimeout(function () {
        vm.$store.commit('setLoginAsUser', loginAsUser);
        vm.$events.emit('goToPageEvent', pageName);
        vm.$store.commit('setLoading', false);
      }, 500);
    },
    fetchUserEstablishments: function fetchUserEstablishments() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_26_axios___default()({
        method: 'POST',
        url: __WEBPACK_IMPORTED_MODULE_25__api_variables__["a" /* API_URL */].CurrentUrl + '/search/pos',
        data: { 'geo_x': 1, 'geo_y': 1 },
        headers: { 'Authorization': 'Bearer ' + localStorage.getItem('user_token') }
      }).then(function (resp) {
        console.log(resp);
        console.log(resp.data.list);
        vm.$store.commit('setUserEstablishments', resp.data.list || []);
      });
    },
    fetchEstablishment: function fetchEstablishment() {
      console.log('getEstablishment');

      var token = localStorage.getItem('user_token');
      if (token.length < 1) {
        return;
      }

      if (this.$store.getters.getLoginAsUser) {
        return;
      }
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_26_axios___default()({
        method: 'GET',
        url: __WEBPACK_IMPORTED_MODULE_25__api_variables__["a" /* API_URL */].CurrentUrl + '/pos',
        headers: { 'Authorization': 'Bearer ' + token }
      }).then(function (resp) {
        vm.$store.commit('setWaitingForEstablishment', false);
        console.log('POS response');
        console.log(resp.data);
        if (resp.data) {
          if (resp.data.list) {
            if (resp.data.list.length) {
              vm.$store.commit('setEstablishment', resp.data.list[0]);
            }
          }
        }
      }).catch(function (err) {
        vm.$store.commit('setWaitingForEstablishment', false);
        console.log('fetchEstablishment error');
        console.log(err);
      });
    },
    getQueryParam: function getQueryParam(n) {
      var half = location.search.split(n + '=')[1];
      return half !== undefined ? decodeURIComponent(half.split('&')[0]) : null;
    },
    parseAllParams: function parseAllParams() {
      var parameters = {};
      var all = location.search;
      all = all.replace('?', '');

      var pv = all.split('&');
      for (var i = 0; i < pv.length; i++) {
        var keyVal = pv[i].split('=');
        parameters[keyVal[0]] = keyVal[1];
      }
      return parameters;
    },
    getQueryParams: function getQueryParams(n) {
      console.log('getQueryParams');
      console.log(location.search);
      var half = location.search.split(n + '=')[1];
      console.log('half = ' + half);
      return half !== undefined ? decodeURIComponent(half.split('&')[0]) : null;
    },
    setMessage: function setMessage(response) {
      if (!response) {
        return;
      }

      var vm = this;
      setTimeout(function () {
        vm.$store.commit('resetMessages');
      }, 5000);

      if (response.errors) {
        this.$store.commit('setErrors', response.errors);
      } else if (response.error) {
        this.$store.commit('setError', response.error);
      } else if (response.warning) {
        this.$store.commit('setWarning', response.warning);
      } else if (response.info) {
        this.$store.commit('setInfo', response.info);
      } else if (response.success) {
        this.$store.commit('setSuccess', response.success);
      }

      this.$store.commit('setLoading', false);
    },
    sendLogin: function sendLogin(loginData) {
      this.$store.commit('setLoading', true);
      var country = localStorage.getItem('country');
      if (!country) {
        localStorage.setItem('country_code', this.getCountryByCurrentDomainName());
      }
      var creds = loginData;

      var setReponseMessage = this.setMessage;
      this.$store.commit('resetMessages');
      var url = __WEBPACK_IMPORTED_MODULE_25__api_variables__["a" /* API_URL */].CurrentUrl + __WEBPACK_IMPORTED_MODULE_25__api_variables__["c" /* LOGIN_URL */];
      var vm = this;
      this.$http.post(url, creds).then(function (resp) {
        var data = {};

        if (resp.status === 200) {
          if (resp.data) {
            data = resp.data;
            if (data.token) {
              var decoded = __WEBPACK_IMPORTED_MODULE_1_jwt_decode___default()(data.token);
              console.log('JWT DECODED');
              console.log(decoded);
              console.log('STATUS: ' + decoded.status);
              if (vm.$store.getters.getLoginAsUser) {
                console.log('You are loggin in as USER');
                if (!(decoded.status === 'USER' || decoded.status === 'ADMIN')) {
                  console.log('But your current user type is ' + decoded.status);
                  setReponseMessage({ 'error': 'Sorry, only users are allowed to login through this form' });
                  return;
                }
              } else {
                console.log('You are loggin in as POS');
                if (decoded.status !== 'POS') {
                  console.log('But your current user type is ' + decoded.status);
                  setReponseMessage({ 'error': 'Sorry, only establishments are allowed to login through this form' });
                  return;
                }
              }

              vm.$events.$emit('loginEvent', { token: data.token, user: creds.mail, rememberMe: vm.rememberMe, 'decoded': decoded });
            }
          }
        }
      }, function (err) {
        setReponseMessage(err.data);

        console.log('Error');
        console.log(err);
      });
    },
    updateVNCC: function updateVNCC() {
      this.$store.commit('incrementVNCC');
    },
    getDonationMetrics: function getDonationMetrics() {
      if (this.$store.getters.getCurrentPage !== 'home' && this.$store.getters.getCurrentPage !== '') {
        return;
      }
      var vm = this;
      var url = __WEBPACK_IMPORTED_MODULE_25__api_variables__["a" /* API_URL */].CurrentUrl + __WEBPACK_IMPORTED_MODULE_25__api_variables__["d" /* DONATION_URL */];

      __WEBPACK_IMPORTED_MODULE_26_axios___default()({
        url: url,
        headers: { 'Authorization': 'Bearer ' + localStorage.getItem('user_token') }
      }).then(function (resp) {
        console.log('call success');
        console.log(resp.data);
        if (resp.data) {
          if (resp.data.total_donations) {
            vm.$store.commit('setDonationTotal', resp.data);
            vm.loadingDonationMetrics = true;
          }
        }
      }).catch(function (err) {
        console.log('call error');
        console.log(err.status + ': ' + err.statusText);
      });
    },
    setLang: function setLang(lang) {
      console.log('LANGUAGE ' + lang);
      this.$i18n.set(lang);
      localStorage.setItem('user_locale', lang);
      this.langDirection = this.getLangDir();
      this.helpLink = this.setHelpUrl(lang);
      this.lang = lang;
    },
    getLang: function getLang() {
      return localStorage.getItem('user_locale');
    },
    goSharePage: function goSharePage(e) {
      e.preventDefault();

      this.$events.emit('goToPageEvent', 'share');
    },
    goToPrevPage: function goToPrevPage(e) {
      e.preventDefault();

      if (!(this.$store.getters.getCurrentState === 'login' || this.$store.getters.getCurrentState === '')) {
        this.$events.emit('goToPageEvent', 'home');
        return;
      }

      this.$events.emit('goToPageEvent', '');
    },
    goToNextPage: function goToNextPage(e) {
      e.preventDefault();
      this.$store.commit('goToNextPage');
    },
    getLangDir: function getLangDir() {
      var lang = localStorage.getItem('user_locale');
      console.log('lang ' + lang);
      console.log('dir ' + this.langDirection);
      if (lang !== 'ar') {
        return 'ltr';
      }
      return 'rtl';
    },
    setHelpUrl: function setHelpUrl(lang) {
      var url = 'https://github.com/YoQuieroAyudar/fundraising-API-web-app/wiki/';

      if (lang === 'ar') {
        return url + 'مساعدة';
      } else if (lang === 'fr') {
        return 'https://guide.jevaisaider.org';
      } else if (lang === 'es') {
        return 'https://guia.microhuchasolidaria.org';
      } else {
        return url + 'Help';
      }
    },
    getAssociationsFromAPI: function getAssociationsFromAPI() {
      var _this2 = this;

      console.log('App.vue: getAssociationsFromAPI');
      var vm = this;
      var country = this.$store.getters.getSelectedCountry;
      if (country === undefined) {
        console.log('no country, default is ES');
        country = this.getCountryByCurrentDomainName();
      }
      var url = __WEBPACK_IMPORTED_MODULE_25__api_variables__["a" /* API_URL */].CurrentUrl + __WEBPACK_IMPORTED_MODULE_25__api_variables__["e" /* ASSO_SEARCH_URL */];
      var data = {};
      data.POS_id = 1;

      if (country !== undefined && country !== null && country !== '') {
        console.log('country = ' + country);
        url += '?country=' + country;
        data.country = country;
      }

      var jwtToken = localStorage.getItem('user_token');

      console.log('calling to: ' + url);

      __WEBPACK_IMPORTED_MODULE_26_axios___default()({
        method: 'POST',
        url: url,
        data: data,
        headers: { 'Authorization': 'Bearer ' + jwtToken }
      }).then(function (resp) {
        console.log(resp.status);
        console.log(resp.statusText);
        console.log(resp);
        if (resp.data) {
          var allParams = _this2.parseAllParams();
          if ('target' in allParams) {
            console.log('set target charity');
            console.log(allParams.target);

            setTimeout(function () {
              vm.goToCharityPage(allParams.target);
            }, 500);
          }
          vm.$store.commit('setAssoList', resp.data);
        } else {
          vm.$store.commit('setErrors', [{ error: 'Unable to set associations list' }]);
        }
      }).catch(function (err) {
        if (!err.data) {
          vm.$store.commit('setError', { error: 'Error while loading associations list' });
          return;
        }
        if (err.data.errors) {
          vm.$store.commit('setErrors', err.data.errors);
        }
      });
    }
  },
  computed: {
    currentLangDirection: function currentLangDirection() {
      return this.getLangDir();
    },
    currentState: function currentState() {
      return this.$store.getters.getCurrentState;
    },
    getMyBalance: function getMyBalance() {
      return this.$store.getters.getBalance;
    },
    getWidthClass: function getWidthClass() {
      var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
      if (width > 479) {
        return 'desktop-max';
      }
      return 'mobile-full-page';
    },
    loggedin: function loggedin() {
      var token = localStorage.getItem('user_token');
      if (token) {
        this.$store.commit('setToken', token);
        this.current_state = 'loggedin';
      }
      return this.$store.getters.getLogin;
    },
    isLoggedIn: function isLoggedIn() {
      return this.$store.getters.getLogin;
    }
  },
  destroyed: function destroyed() {
    localStorage.clear();
  },

  components: {
    'home-page': __WEBPACK_IMPORTED_MODULE_4__components_Home_vue___default.a,
    'share-page': __WEBPACK_IMPORTED_MODULE_10__components_Share_vue___default.a,
    'login-form': __WEBPACK_IMPORTED_MODULE_6__components_Login_vue___default.a,
    'signup-form': __WEBPACK_IMPORTED_MODULE_7__components_Signup_vue___default.a,
    'signup-pos-form': __WEBPACK_IMPORTED_MODULE_8__components_SignupPOS_vue___default.a,
    'logout-button': __WEBPACK_IMPORTED_MODULE_5__components_Logout_vue___default.a,
    'message-items': __WEBPACK_IMPORTED_MODULE_9__components_Messages_vue___default.a,
    'associations-page': __WEBPACK_IMPORTED_MODULE_11__components_Associations_vue___default.a,
    'association-page': __WEBPACK_IMPORTED_MODULE_12__components_Association_vue___default.a,
    'donations-page': __WEBPACK_IMPORTED_MODULE_13__components_Donations_vue___default.a,
    'solidarity-account-page': __WEBPACK_IMPORTED_MODULE_14__components_SolidarityAccount_vue___default.a,
    'settings-page': __WEBPACK_IMPORTED_MODULE_15__components_Settings_vue___default.a,
    'slide-page': __WEBPACK_IMPORTED_MODULE_16__components_Slides_vue___default.a,
    'subscription-page': __WEBPACK_IMPORTED_MODULE_17__components_Subscription___default.a,
    'qr-code-page': __WEBPACK_IMPORTED_MODULE_18__components_QRCode_vue___default.a,
    'map-page': __WEBPACK_IMPORTED_MODULE_19__components_Map_vue___default.a,
    'supportive-pos-page': __WEBPACK_IMPORTED_MODULE_20__components_SupportivePOS_vue___default.a,
    'go-to-box': __WEBPACK_IMPORTED_MODULE_21__components_GoTo_vue___default.a,
    'transactions-page': __WEBPACK_IMPORTED_MODULE_22__components_Transactions_vue___default.a,
    'fb-login': __WEBPACK_IMPORTED_MODULE_23__components_FBLogin_vue___default.a,
    'admin-page': __WEBPACK_IMPORTED_MODULE_24__components_Admin_vue___default.a
  }
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_variables__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Terms_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Terms_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Terms_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      tabs: [],
      acceptTerms: false,
      showTerms: false,
      newAsso: {
        mail: '',
        password: '',
        name: '',
        status: 'ASSO',
        first_name: '',
        last_name: '',
        birthday: '',
        nationality: '',
        country_of_residence: '',
        bank_account_iban: '',
        bank_account_bic: '',
        country: '',
        address: '',
        description: '',
        logo_url: '',
        twitter_username: ''
      }
    };
  },

  methods: {
    registerAssoUser: function registerAssoUser(e) {
      var _this = this;

      e.preventDefault();
      var vm = this;
      var creds = this.newAsso;
      creds.birthday = new Date(creds.birthday);
      var url = __WEBPACK_IMPORTED_MODULE_1__api_variables__["a" /* API_URL */].CurrentUrl + '/signup';

      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'POST',
        url: url,
        data: creds
      }).then(function (resp) {
        console.log('Association registration response');
        console.log(resp);
        if (resp.status === 200) {
          document.getElementById('add-asso-form').reset();
          vm.$store.commit('setSuccess', 'Association registration successful');
          _this.$events.emit('goToPageEvent', 'admin');
        }
      }).catch(function (err) {
        console.log('Association registration error');
        console.log(err);
        vm.$store.commit('setErrors', ['Association registration failed, please try again']);
      });
      return false;
    },
    updateAddress: function updateAddress() {
      var ad = this.newAsso.address + ', ' + this.newAsso.zip_code + ' ' + this.newAsso.city;
      this.address = ad;
    },
    toggleTermsModal: function toggleTermsModal(e) {
      e.preventDefault();
      this.showTerms = !this.showTerms;
    }
  },
  components: {
    'terms-modal': __WEBPACK_IMPORTED_MODULE_2__Terms_vue___default.a
  }
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_variables__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      donationAmount: 0
    };
  },

  methods: {
    submitDonation: function submitDonation() {
      if (!this.assoc.id) {
        this.$store.commit('setError', 'Invalid association id');
        return;
      }
      console.log('donationAmount: ' + this.donationAmount);
      if (this.donationAmount < 200) {
        this.$store.commit('setError', '2 euros are the least amount you can donate');
        return;
      }
      var donationUrl = __WEBPACK_IMPORTED_MODULE_0__api_variables__["a" /* API_URL */].CurrentUrl + __WEBPACK_IMPORTED_MODULE_0__api_variables__["h" /* DONATATION_URL */];
      var instance = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
        headers: { 'Authorization': 'Bearer ' + localStorage.getItem('user_token') }
      });
      var vm = this;
      var donationData = {
        'association_id': this.assoc.id,
        'amount': this.donationAmount
      };

      instance.post(donationUrl, donationData).then(function (resp) {
        console.log('donation successful');
        var successMessage = resp.data.message;
        console.log(successMessage);
        if (successMessage) {
          vm.$store.commit('setSuccess', successMessage);
          return;
        }
        vm.$events.$emit('acountUpdate', {});
        vm.$store.commit('setSuccess', 'Donation successful');
        vm.donationAmount = 0;
      }).catch(function (err) {
        console.log('donation error');
        console.log(err);
        vm.$store.commit('setLoading', false);
        vm.$store.commit('setError', 'Sorry, your donation to this association failed');
      });
    }
  },
  computed: {
    assoc: function assoc() {
      return this.$store.getters.getSelectedAssociation;
    }
  }
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_variables__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);






/* harmony default export */ __webpack_exports__["default"] = ({
  beforeMount: function beforeMount() {
    console.log('beforeUpdate');
    if (this.$store.getters.getAssociations.length === 0) {
      console.log('associations length = 0');
      console.log('Getting new list');
      this.getAssociationsFromAPI();
    }
  },
  data: function data() {
    return {
      associations: [],
      search: '',
      searchTimout: 0
    };
  },

  methods: {
    searchAsso: function searchAsso(e) {
      console.log('searchAsso');
      var searchText = this.search;
      var vm = this;
      clearTimeout(this.searchTimout);
      this.searchTimout = setTimeout(function () {
        var assos = vm.$store.getters.getAssociations.filter(function (asso) {
          var name = asso.name !== undefined ? asso.name.toLowerCase() : '';
          var description = asso.description !== undefined ? asso.description.toLowerCase() : '';
          searchText = searchText.toLowerCase();
          return name.indexOf(searchText) > -1 || description.indexOf(searchText) > -1;
        });
        console.log('associations found ' + assos.length);
        vm.$store.commit('setCurrentAssoList', assos);
      }, 500);
    },
    selectAssociation: function selectAssociation(assocId) {
      console.log(assocId);
      this.$store.commit('selectAssoById', assocId);
      this.$events.emit('goToPageEvent', 'asso_details/' + assocId);
    },
    getAssociationsFromAPI: function getAssociationsFromAPI() {
      var vm = this;
      var country = this.$store.getters.getSelectedCountry;
      if (country == null) {
        country = 'ES';
      }
      console.log('Searching for ' + country);
      var url = __WEBPACK_IMPORTED_MODULE_0__api_variables__["a" /* API_URL */].CurrentUrl + __WEBPACK_IMPORTED_MODULE_0__api_variables__["e" /* ASSO_SEARCH_URL */];
      var data = {};
      data.POS_id = 1;

      if (country !== undefined && country !== null && country !== '') {
        url += '?country=' + country;
        data.country = country;
      }

      var jwtToken = localStorage.getItem('user_token');

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'POST',
        url: url,
        data: data,
        headers: { 'Authorization': 'Bearer ' + jwtToken }
      }).then(function (resp) {
        console.log(resp.status);
        console.log(resp.statusText);
        console.log(resp);
        if (resp.data) {
          vm.$store.commit('setAssoList', resp.data);
        } else {
          vm.$store.commit('setErrors', [{ error: 'Unable to set associations list' }]);
        }
      }).catch(function (err) {
        if (!err.data) {
          vm.$store.commit('setError', { error: 'Error while loading associations list' });
          return;
        }
        if (err.data.errors) {
          vm.$store.commit('setErrors', err.data.errors);
        }
      });
    }
  },
  computed: {}
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_variables__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  beforeMount: function beforeMount() {
    this.getTransactions();
  },
  data: function data() {
    var now = new Date();
    var day, year, month;
    day = now.getDate();
    month = now.getMonth();
    year = now.getFullYear();
    return {
      startDate: '2017-01-01',
      endDate: year + '-' + month + '-' + day
    };
  },

  methods: {
    formatDate: function formatDate(date) {
      var now = new Date(date);

      var day, year, month;
      day = now.getDate();
      month = now.getMonth();
      year = now.getFullYear();

      day = day < 10 ? '0' + day : day;
      month = month < 10 ? '0' + month : month;

      return day + '/' + month + '/' + year;
    },
    formatEuros: function formatEuros(amount) {
      return (parseFloat(amount) / 100).toFixed(2);
    },
    getTransactions: function getTransactions() {
      var vm = this;
      var query = '?';
      query += 'before_date=' + encodeURIComponent(this.startDate);
      query += 'after_date=' + encodeURIComponent(this.endDate);
      console.log(query);

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: __WEBPACK_IMPORTED_MODULE_0__api_variables__["a" /* API_URL */].CurrentUrl + '/donation',
        headers: { 'Authorization': 'Bearer ' + localStorage.getItem('user_token') }
      }).then(function (resp) {
        console.log('getTransactions response');
        console.log(resp);
        if (resp.data !== undefined) {
          if (resp.data.donations) {
            vm.$store.commit('setTransactions', resp.data.donations);
          }
        }
      });
    }
  }
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      profile: {},
      ready: false,
      authorized: false
    };
  },
  mounted: function mounted() {
    console.log('FACEBOOK LOGIN mounted');
    var vm = this;
    var FBAPPID = '';
    var domainName = window.location.hostname;
    switch (domainName) {
      case 'web.jevaisaider.org':
        console.log('using jva id');
        FBAPPID = '1279278258816835';
        break;
      case 'web.microhuchasolidaria.org':
        console.log('using mhs id');
        FBAPPID = '219601041795109';
        break;
      default:
        console.log('using default id');
        FBAPPID = '219601041795109';
    }
    window.fbAsyncInit = function () {
      console.log('FACEBOOK LOGIN fbAsyncInit');

      window.FB.init({
        appId: FBAPPID,
        cookie: true,
        xfbml: true,
        version: 'v2.9'
      });
      window.FB.getLoginStatus(function (response) {
        console.log('FACEBOOK LOGIN getLoginStatus');
        console.log(response);
        vm.statusChangeCallback(response);
      });
    };
    setTimeout(function () {
      window.fbAsyncInit();
    }, 1000);
  },
  beforeCreate: function beforeCreate() {
    console.log('FACEBOOK LOGIN beforeCreate');
  },

  methods: {
    getProfile: function getProfile() {
      console.log('FACEBOOK LOGIN getProfile()');

      var vm = this;
      window.FB.api('/me', function (response) {
        console.log('getProfile response');
        console.log(response);

        vm.$store.commit('setFBProfile', response);
      });
    },
    login: function login() {
      console.log('FACEBOOK LOGIN login()');
      var vm = this;

      FB.login(function (response) {
        console.log('login response');
        console.log(response);
        vm.statusChangeCallback(response);
      }, { scope: 'email,public_profile,user_birthday,user_friends,user_location' });
    },
    logout: function logout() {
      console.log('FACEBOOK LOGIN logout()');
      var vm = this;

      FB.logout(function (response) {
        console.log('logout response');
        console.log(response);
        vm.statusChangeCallback(response);
        vm.$events.emit('logoutEvent');
      });
    },
    statusChangeCallback: function statusChangeCallback(response) {
      console.log('FACEBOOK LOGIN statusChangeCallback');
      var vm = this;
      vm.ready = true;
      console.log('statusChangeCallback');
      console.log(response);
      if (response.status === 'connected') {
        console.log('authResponse');
        console.log(response.authResponse);
        vm.$events.emit('socialLoginEvent', {
          type: 'facebook',
          token: response.authResponse.accessToken
        });
        vm.$store.commit('setFBAuthorized', true);
        vm.authorized = true;
        vm.getProfile();
      } else if (response.status === 'not_authorized') {
        vm.authorized = false;
        vm.$store.commit('setFBAuthorized', false);
      } else {
        vm.authorized = false;
        vm.$store.commit('setFBAuthorized', false);
        localStorage.removeItem('socialLoginToken');
      }
    }
  }

});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: 'Click below'
    },
    targetUrl: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      default: 'Continue'
    }
  },
  data: function data() {
    return {
      url: this.targetUrl
    };
  },

  watch: {},
  methods: {
    closeMe: function closeMe() {
      this.$events.$emit('acountUpdate', {});
      this.$events.$emit('fetchEstablishmentEvent', {});
      this.$store.commit('setShowGoTo', false);
    }
  },
  computed: {}
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);




/* harmony default export */ __webpack_exports__["default"] = ({
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    console.log('mounted');
    this.$events.emit('getCharitiesEvent');
    this.$events.emit('fetchUserEstablishmentsEvent');
  },
  data: function data() {
    return {
      loadingDonationMetrics: false,
      country: null
    };
  },

  methods: {
    updateCountry: function updateCountry() {
      if (this.country !== null && this.country !== undefined && this.country.code !== undefined) {
        localStorage.setItem('country', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.country));
        localStorage.setItem('country_code', this.country.code);
        localStorage.setItem('country_db', this.country.db);
        this.$store.commit('setSelectedCountry', this.country.code);
        this.$events.emit('getCharitiesEvent');
      }
    },
    parseAllParams: function parseAllParams() {
      var parameters = {};
      var all = location.search;
      all = all.replace('?', '');

      var pv = all.split('&');
      for (var i = 0; i < pv.length; i++) {
        var keyVal = pv[i].split('=');
        parameters[keyVal[0]] = keyVal[1];
      }
      return parameters;
    },
    goToTranactions: function goToTranactions(e) {
      e.preventDefault();
      this.$events.emit('goToPageEvent', 'transactions');
      this.$store.commit('resetMessages');
    },
    gotToMap: function gotToMap(e) {
      e.preventDefault();
      this.$events.emit('goToPageEvent', 'map');
      this.$store.commit('resetMessages');
    },
    gotToSupportivePOSMap: function gotToSupportivePOSMap(e) {
      e.preventDefault();
      this.$events.emit('goToPageEvent', 'supportive-pos');
      this.$store.commit('resetMessages');
    },
    goToAdminPage: function goToAdminPage(e) {
      e.preventDefault();
      this.$events.emit('goToPageEvent', 'admin-page');
      this.$store.commit('resetMessages');
    },
    gotToQRCode: function gotToQRCode(e) {
      e.preventDefault();
      this.$events.emit('goToPageEvent', 'qrCode');
      this.$store.commit('resetMessages');
    },
    goToAssociations: function goToAssociations(e) {
      e.preventDefault();
      this.$events.emit('goToPageEvent', 'associations');
      this.$store.commit('resetMessages');
    },
    goToDonations: function goToDonations(e) {
      e.preventDefault();
      this.$events.emit('goToPageEvent', 'donations');
      this.$store.commit('resetMessages');
    },
    goToSolidarityAccount: function goToSolidarityAccount(e) {
      e.preventDefault();
      this.$events.emit('goToPageEvent', 'solidarity');
      this.$store.commit('resetMessages');
    },
    gotToSubscription: function gotToSubscription(e) {
      this.$events.emit('goToPageEvent', 'subscription');
      this.$store.commit('resetMessages');
    }
  },
  computed: {
    getApiCountries: function getApiCountries() {
      var vm = this;
      var db = this.$store.getters.getApiDB;
      console.log('getApiCountries: ' + db);
      var countries = [];
      var tempList = this.$store.getters.getTopCountries;
      console.log('countries length = ' + tempList.length);
      console.log(tempList);
      countries = tempList.filter(function (c) {
        return c.db === db;
      });

      console.log('typeof countries = ' + (typeof countries === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(countries)));

      console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(countries[0]));
      if (this.country === null) {
        vm.country = countries[0];
        this.$store.commit('setSelectedCountry', this.country.code);
      }
      return countries;
    },
    getUsername: function getUsername() {
      var userData = JSON.parse(localStorage.getItem('user_data'));
      return userData.first_name + ' ' + userData.last_name;
    },
    gettingDonationSum: function gettingDonationSum() {
      return this.loadingDonationMetrics;
    },
    getDonationSum: function getDonationSum() {
      var vm = this;
      setTimeout(function () {
        vm.$events.$emit('checkDonationMeterics');
      }, 10000);
      return this.$store.getters.getDonationsTotal;
    }
  }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Vids_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Vids_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Vids_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LoginPOS_vue__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LoginPOS_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LoginPOS_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      login: {
        mail: '',
        password: ''
      },
      rememberMe: localStorage.getItem('rememberMe'),
      facebookLogin: false,

      asUser: true
    };
  },

  computed: {
    country: {
      get: function get() {
        return this.$store.getters.getSelectedCountry.toUpperCase();
      },
      set: function set(newValue) {
        console.log('new value for country');
        console.log(newValue);
        this.$store.commit('setSelectedCountry', newValue.toUpperCase());
      }
    }
  },
  methods: {
    gotToLoginPOS: function gotToLoginPOS() {
      this.$store.commit('setLoginAsUser', !this.asUser);

      this.asUser = !this.asUser;
    },
    setRememberMe: function setRememberMe() {
      console.log('rememberMe: ' + this.rememberMe);
      localStorage.setItem('rememberMe', this.rememberMe);
      console.log('rememberMe: ' + localStorage.getItem('rememberMe'));
    },
    updateAPI: function updateAPI() {
      this.$store.commit('setAPI', this.country.db);
      localStorage.setItem('country', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.country));
      localStorage.setItem('country_code', this.country.code);
      localStorage.setItem('country_db', this.country.db);
    },
    goToSignupPage: function goToSignupPage(e) {
      e.preventDefault();
      this.$store.commit('resetMessages');

      this.$events.emit('goToPageEvent', 'signup');
      this.$store.commit('setCurrentState', '');
    },
    updateEmail: function updateEmail(e) {
      this.$store.commit('updateEmail', this.login.mail);
    },
    updatePassword: function updatePassword(e) {
      this.$store.commit('updatePassword', this.login.password);
    },
    setMessage: function setMessage(response) {
      if (!response) {
        return;
      }

      var vm = this;
      setTimeout(function () {
        vm.$store.commit('resetMessages');
      }, 5000);

      if (response.errors) {
        this.$store.commit('setErrors', response.errors);
      } else if (response.error) {
        this.$store.commit('setError', response.error);
      } else if (response.warning) {
        this.$store.commit('setWarning', response.warning);
      } else if (response.info) {
        this.$store.commit('setInfo', response.info);
      } else if (response.success) {
        this.$store.commit('setSuccess', response.success);
      }

      this.$store.commit('setLoading', false);
    },
    setUserToken: function setUserToken(token) {},
    loginUser: function loginUser(e) {
      e.preventDefault();
      console.log('COUNTRY: ' + this.country);
      this.$events.emit('sendLoginEvent', this.login);
    }
  },
  components: {
    'login-pos-form': __WEBPACK_IMPORTED_MODULE_2__LoginPOS_vue___default.a,
    'video-frame': __WEBPACK_IMPORTED_MODULE_1__Vids_vue___default.a
  }

});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FBLogin_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FBLogin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FBLogin_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Vids_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Vids_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Vids_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      login: {
        mail: '',
        password: ''
      },
      rememberMe: localStorage.getItem('rememberMe'),
      facebookLogin: false,
      country: { name: 'Spain', db: 'mhs', code: 'ES' }
    };
  },

  computed: {},
  methods: {
    goToLoginPOSPage: function goToLoginPOSPage(e) {
      e.preventDefault();
      this.$events.emit('goToPageEvent', 'loginPOS');
      this.$store.commit('resetMessages');
    },
    setRememberMe: function setRememberMe() {
      localStorage.setItem('rememberMe', this.rememberMe);
    },
    updateAPI: function updateAPI() {
      this.$store.commit('setAPI', this.country.db);
      localStorage.setItem('country', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.country));
      localStorage.setItem('country_code', this.country.code);
    },
    goToSignupPage: function goToSignupPage(e) {
      e.preventDefault();
      this.$store.commit('resetMessages');

      this.$events.emit('goToPageEvent', 'signupPOS');
      this.$store.commit('setCurrentState', '');
    },
    updateEmail: function updateEmail(e) {
      this.$store.commit('updateEmail', this.login.mail);
    },
    updatePassword: function updatePassword(e) {
      this.$store.commit('updatePassword', this.login.password);
    },
    setMessage: function setMessage(response) {
      if (!response) {
        return;
      }

      var vm = this;
      setTimeout(function () {
        vm.$store.commit('resetMessages');
      }, 5000);

      if (response.errors) {
        this.$store.commit('setErrors', response.errors);
      } else if (response.error) {
        this.$store.commit('setError', response.error);
      } else if (response.warning) {
        this.$store.commit('setWarning', response.warning);
      } else if (response.info) {
        this.$store.commit('setInfo', response.info);
      } else if (response.success) {
        this.$store.commit('setSuccess', response.success);
      }

      this.$store.commit('setLoading', false);
    },
    setUserToken: function setUserToken(token) {},
    loginUser: function loginUser(e) {
      e.preventDefault();
      console.log('COUNTRY: ' + this.country);
      this.$events.emit('sendLoginEvent', this.login);
    }
  },
  components: {
    'fb-login': __WEBPACK_IMPORTED_MODULE_1__FBLogin_vue___default.a,
    'video-frame': __WEBPACK_IMPORTED_MODULE_2__Vids_vue___default.a
  }

});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      socialLinks: [{
        db: 'jva',
        links: {
          facebook: 'https://www.facebook.com/JeVaisAider',
          twitter: 'https://twitter.com/JeVaisAider',
          linkedIn: 'https://www.linkedin.com/groups/8527508'
        }
      }, {
        db: 'mhs',
        links: {
          facebook: 'https://www.facebook.com/YQuieroAyudar',
          twitter: 'https://twitter.com/YQuieroAyudar?lang=es',
          linkedIn: 'https://www.linkedin.com/groups/8508381'
        }
      }]
    };
  },

  methods: {
    socialLogout: function socialLogout(e) {
      this.$store.commit('setShowSocialLogin', true);
    },
    goToSettingsPage: function goToSettingsPage(e) {
      this.$events.emit('goToPageEvent', 'settings');
    },
    gotToSubscription: function gotToSubscription(e) {
      this.$events.emit('goToPageEvent', 'subscription');
      this.$store.commit('resetMessages');
      this.$events.$emit('fetchEstablishmentEvent', {});
    },
    goToSolidarityAccount: function goToSolidarityAccount(e) {
      e.preventDefault();

      this.$events.emit('goToPageEvent', 'solidarity');
      this.$store.commit('resetMessages');
      this.$events.$emit('acountUpdate', {});
    },
    logoutUser: function logoutUser(e) {
      e.preventDefault();
      this.$events.emit('logoutEvent');
    }
  },
  computed: {
    linkedInUrl: function linkedInUrl() {
      var apiDb = this.$store.getters.getApiDB;
      for (var i = 0; i < this.socialLinks.length; i++) {
        console.log(this.socialLinks[i].db === apiDb);
        if (this.socialLinks[i].db === apiDb) {
          return this.socialLinks[i].links.linkedIn;
        }
      }
      return this.socialLinks[0].links.linkedIn;
    },
    twitterUrl: function twitterUrl() {
      var apiDb = this.$store.getters.getApiDB;
      for (var i = 0; i < this.socialLinks.length; i++) {
        console.log(this.socialLinks[i].db === apiDb);
        if (this.socialLinks[i].db === apiDb) {
          return this.socialLinks[i].links.twitter;
        }
      }
      return this.socialLinks[0].links.twitter;
    },
    facebookUrl: function facebookUrl() {
      var apiDb = this.$store.getters.getApiDB;
      for (var i = 0; i < this.socialLinks.length; i++) {
        console.log(this.socialLinks[i].db === apiDb);
        if (this.socialLinks[i].db === apiDb) {
          return this.socialLinks[i].links.facebook;
        }
      }
      return this.socialLinks[0].links.facebook;
    },
    walletBalance: function walletBalance() {
      return this.$store.getters.getBalance;
    },
    daysLeftLabelClasses: function daysLeftLabelClasses() {
      var cs = 'label pull-right balance-label label-';
      if (this.$store.getters.getPosSubscriptionEnd > 15) {
        cs += 'success';
      } else if (this.$store.getters.getPosSubscriptionEnd > 7) {
        cs += 'warning';
      } else {
        cs += 'danger';
      }
      return cs;
    },
    balanceLabelClasses: function balanceLabelClasses() {
      var cs = 'label pull-right balance-label label-';
      this.walletBalance > 0 ? cs += 'success' : cs += 'warning';
      return cs;
    },
    getUserEmail: function getUserEmail() {
      var email = this.$store.state.user.user.email;
      email = email.split('@');
      if (email.length > 1) {
        return email[1];
      }
      return this.$store.state.user.user.email;
    }
  }
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_gmaps__ = __webpack_require__(122);




/* harmony default export */ __webpack_exports__["default"] = ({
  beforeMount: function beforeMount() {
    var country = this.$store.getters.getSelectedCountry;
    this.center = __WEBPACK_IMPORTED_MODULE_0__service_gmaps__["a" /* default */].getCenter(country.toLowerCase());

    var establishments = this.$store.getters.getUserEstablishments;
    console.log('establishments');
    console.log(establishments);
    var allMarkers = __WEBPACK_IMPORTED_MODULE_0__service_gmaps__["a" /* default */].getMarkers(establishments);
    console.log('allMarkers');
    console.log(allMarkers);
    if (allMarkers.length > 0) {
      this.markers = allMarkers;
      this.$gmapDefaultResizeBus.$emit('resize');
    }
  },
  data: function data() {
    return {
      center: {
        lat: 47.376332,
        lng: 8.547511
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      currentMidx: null,

      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      newMarkers: [],
      markers: [{
        position: {
          lat: 47.376332,
          lng: 8.547511
        },
        infoText: 'Marker 1'
      }, {
        position: {
          lat: 47.374592,
          lng: 8.548867
        },
        infoText: 'Marker 2'
      }, {
        position: {
          lat: 47.379592,
          lng: 8.549867
        },
        infoText: 'Marker 3'
      }],
      search: '',
      searchTimout: 0
    };
  },

  methods: {
    searchEstablishment: function searchEstablishment(e) {
      console.log('searchEstablishment');
      var vm = this;
      var address = this.search;
      clearTimeout(this.searchTimout);
      this.searchTimout = setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0__service_gmaps__["a" /* default */].getCoordinates(address).then(function (resp) {
          console.log('getCoordinates response');
          console.log(resp);
          if (resp.geometry !== undefined) {
            console.log('location');
            console.log(resp.geometry.location);
            vm.center = resp.geometry.location;
          }
        }, function (err) {
          console.log('error');
          console.log(err);
        });
      }, 1000);
    },

    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.infoText;

      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    updateCenter: function updateCenter(newCenter) {
      console.log('updateCenter');
      console.log(newCenter);
      this.center = {
        lat: newCenter.lat(),
        lng: newCenter.lng()
      };
    }
  },
  computed: {}
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  computed: {
    errors: function errors() {
      return this.$store.getters.getErrors;
    },
    warning: function warning() {
      return this.$store.getters.getWarning;
    },
    info: function info() {
      return this.$store.getters.getInfo;
    },
    success: function success() {
      return this.$store.getters.getSuccess;
    }
  },
  methods: {},
  destroyed: function destroyed() {
    console.log('destroyed messages');
  }
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  computed: {
    qrCodeImage: function qrCodeImage() {
      return this.$store.getters.getPOSQRCode;
    }
  },
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_variables__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GoTo_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GoTo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__GoTo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var thisMonth = new Date().getUTCMonth();
    var thisYear = new Date().getFullYear() - 2000;
    if (thisMonth < 10) {
      thisMonth = '0' + thisMonth;
    }
    if (thisYear < 10) {
      thisYear = '0' + thisYear;
    }

    return {
      amount: 10,
      cardNo: '',
      CVV: '',
      expirationDate: { month: thisMonth, year: thisYear },
      registerCardResponse: {},
      secureUrl: '#'
    };
  },

  computed: {
    totalAmountCharged: function totalAmountCharged() {
      return (parseFloat(this.amount) + parseFloat(this.amount) * 0.018 + 0.18).toFixed(2);
    }
  },
  methods: {
    registerCard: function registerCard() {
      if (!this.rechargeFormIsValid()) {
        return;
      }
      var vm = this;

      var authorizationHeader = 'Bearer ' + localStorage.getItem('user_token');
      var options = {
        url: __WEBPACK_IMPORTED_MODULE_1__api_variables__["a" /* API_URL */].CurrentUrl + __WEBPACK_IMPORTED_MODULE_1__api_variables__["f" /* REGISTER_CARD_URL */],
        method: 'POST',
        headers: { 'Authorization': authorizationHeader }
      };
      console.log('Calling: ' + __WEBPACK_IMPORTED_MODULE_1__api_variables__["a" /* API_URL */].CurrentUrl + __WEBPACK_IMPORTED_MODULE_1__api_variables__["f" /* REGISTER_CARD_URL */]);
      this.$http(options).then(function (resp) {
        if (resp.data) {
          vm.$store.commit('setRegCardResponse', resp.data);

          vm.callToMangoPayToGetToken(resp.data);
        } else {
          if (resp.error) {
            vm.$store.commit('setError', { error: resp.error });
          } else {
            vm.$store.commit('setError', { error: 'Not data in resp' });
          }
        }
      }, function (err) {
        if (!err.data) {
          vm.$store.commit('setError', { error: 'Card registeration error' });
          return;
        }
        if (err.data.errors) {
          vm.$store.commit('setErrors', err.data.errors);
        }
        vm.$store.commit('setLoading', false);
      });
    },
    callToMangoPayToGetToken: function callToMangoPayToGetToken(data) {
      this.sendToMangopay(data.accessKeyRef, data.cardRegistrationURL, data.data, this.cardNo, this.expirationDate, this.CVV, this.rechargeAccount);
    },
    sendToMangopay: function sendToMangopay(accessKeyRef, cardRegistrationURL, data, cardNo, expirationDate, CVV, rechargeAccountCallBack) {
      var mangopayData = {
        data: data,
        accessKeyRef: accessKeyRef,
        cardNumber: cardNo,
        cardExpirationDate: expirationDate.month + expirationDate.year,
        cardCvx: CVV
      };
      var mangoParameters = '';
      for (var key in mangopayData) {
        mangoParameters += (mangoParameters.length > 0 ? '&' : '') + key + '=' + encodeURIComponent(mangopayData[key]);
      }

      var vm = this;

      console.log('mangopayData');
      console.log(mangopayData);
      console.log(encodeURIComponent(mangoParameters));

      console.log('Calling ' + cardRegistrationURL + mangoParameters);

      var instance = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
      });
      instance.post(cardRegistrationURL + '?' + mangoParameters, mangopayData).then(function (resp) {
        console.log('sendToMangopay response');
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resp));
        rechargeAccountCallBack(resp.data);
      }).catch(function (err) {
        console.log('sendToMangopay error');
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err));
        vm.$store.commit('setLoading', false);
        vm.$store.commit('setError', 'Error occured while waiting for the payments service');
        console.log(err);
      });
    },
    rechargeAccount: function rechargeAccount(token) {
      var _this = this;

      token = '' + token;
      var vm = this;

      var rechargeData = { amount: parseFloat(this.amount) * 100, token: token };

      var url = __WEBPACK_IMPORTED_MODULE_1__api_variables__["a" /* API_URL */].CurrentUrl + __WEBPACK_IMPORTED_MODULE_1__api_variables__["g" /* RECHARGE_ACCOUNT_URL */];
      console.log('Calling: ' + url);
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'post',
        url: url,
        data: rechargeData,
        headers: { 'Authorization': 'Bearer ' + localStorage.getItem('user_token') }
      }).then(function (resp) {
        console.log(resp);
        console.log('status = ', resp.status);
        console.log('is 3DS = ', resp.data.transtion_type === '3DS');
        console.log(resp.data);
        console.log('resp.data.transtion_type = ' + resp.data.transtion_type);
        if (resp.data.transtion_type === '3DS') {
          console.log('initiating 3DS transaction');
          var link = resp.data.verification_url;
          if (link.length < 5) {
            console.log('link is too short');
            vm.$store.commit('setError', 'Sorry, no 3DS link to complete the transaction');
            return;
          }
          console.log('setting last balance');
          localStorage.setItem('lastBalance', _this.$store.getters.getBalance);
          console.log('link = ' + link);
          vm.secureUrl = link;
          console.log('secureUrl = ' + vm.secureUrl);

          vm.$events.emit('showGoToModalEvent', {
            url: link,
            message: 'You are redirected to complete the 3DS secure transaction. If you want the transaction to complete continue to the following page and come back when done',
            title: '3DS Transaction',
            buttonText: 'Continue'
          });

          vm.$store.commit('setLoading', false);
          vm.$events.$emit('acountUpdate', {});
          vm.$store.commit('setSuccess', 'Started secure transaction please complete process in the new window after you click continue');
          return;
        }
        vm.$store.commit('setLoading', false);
        vm.$events.$emit('acountUpdate', {});
        vm.$store.commit('setSuccess', 'Recharge successful');
      }).catch(function (err) {
        console.log('Recharge request error');
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err));
        if (err === undefined) {
          return;
        }
        if (err.error) {
          vm.$store.commit('setError', err.error);
        } else if (err.errors !== undefined) {
          vm.$store.commit('setErrors', err.errors);
        } else if (err.data.errors !== undefined) {
          vm.$store.commit('setErrors', err.data.errors);
        } else if (err.data.error !== undefined) {
          vm.$store.commit('setError', err.data.error);
        } else {
          vm.$store.commit('setError', err);
        }

        vm.$store.commit('setLoading', false);
      });
    },
    rechargeFormIsValid: function rechargeFormIsValid() {
      var isValid = true;

      if (this.cardNo.length < 16) {
        this.$store.commit('setError', 'The card number is too short');
        isValid = false;
      }
      var thisYear = new Date().getFullYear();
      var y = thisYear - 2000;
      if (this.expirationDate.month < 1 && this.expirationDate.month > 12 || this.expirationDate.year < y) {
        this.$store.commit('setError', 'The expiration date is either invalid or already expired');
        isValid = false;
      }

      return isValid;
    },
    registerCardAndRecharge: function registerCardAndRecharge() {
      if (!this.rechargeFormIsValid()) {
        return;
      }
      this.$store.commit('setLoading', true);

      this.registerCard();
    }
  },
  components: {
    'go-to-box': __WEBPACK_IMPORTED_MODULE_2__GoTo_vue___default.a
  }
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      newPass1: '',
      newPass2: '',
      oldPass: ''
    };
  },

  methods: {
    checkOldPassword: function checkOldPassword() {
      var email = this.$store.getters.getEmail;
      if (!email) {
        this.$store.commit('setError', 'No email in the store, please logout and login again');
      }
    }
  }
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      title: 'IWantToHelp',
      description: 'I have donated to a charity with IWantToHelp http://web.iwanttohelp.org.uk #IWantToHelp',
      hashtags: 'fundraising,user,widget,IWantToHelp',
      outTwitterUser: 'YQuieroAyudar'
    };
  },

  methods: {
    endsWith: function endsWith(item, end) {
      return item.lastIndexOf(end) === item.length - 1;
    }
  },
  computed: {
    url: function url() {
      var address = window.location.href.replace('#/', '');
      var baseUrl = '';

      if (address.indexOf('localhost') > -1) {
        baseUrl = 'https://yoquieroayudar.github.io';
      } else {
        baseUrl = address;
      }
      var lang = localStorage.getItem('user_locale');
      lang = lang === null ? this.$i18n.locale() : lang;
      if (baseUrl.indexOf('?') < 0) {
        baseUrl += '?';
      }
      if (baseUrl.indexOf('lang=') < 0) {
        lang = 'lang=' + encodeURIComponent(lang);
        this.endsWith(baseUrl, '&') ? baseUrl += lang : baseUrl += '&' + lang;
      }
      var db = this.$store.getters.getApiDB;
      var country = this.$store.getters.getSelectedCountry;
      if (country === null && baseUrl.indexOf('')) {
        db = 'db=' + encodeURIComponent(db);
        this.endsWith(baseUrl, '&') ? baseUrl += db : baseUrl + '&' + db;
      }
      return baseUrl;
    }
  }
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_variables__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Terms_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Terms_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Terms_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      signup: {
        first_name: '',
        last_name: '',
        status: 'USER',
        birthday: '',
        gender: '',
        nationality: 'ES',
        country_of_residence: 'ES',
        mail: '',
        password: ''
      },
      readTerms: false,
      acceptTerms: false,
      showTerms: false
    };
  },

  computed: {},
  methods: {
    toggleTermsModal: function toggleTermsModal(e) {
      e.preventDefault();
      this.showTerms = !this.showTerms;
    },
    goToSignupPOSPage: function goToSignupPOSPage(e) {
      e.preventDefault();

      this.$events.emit('goToPageEvent', 'signupPOS');
      this.$store.commit('resetMessages');
    },
    goToLoginPage: function goToLoginPage(e) {
      e.preventDefault();

      this.$events.emit('goToPageEvent', 'login');
      this.$store.commit('resetMessages');
    },
    updateNationality: function updateNationality(e) {
      e.preventDefault();
      console.log(e.log);
      this.signup.nationality = e.code;
    },
    updateEmail: function updateEmail(e) {
      e.preventDefault();
      this.$store.commit('updateEmail', this.signup.mail);
    },
    updatePassword: function updatePassword(e) {
      e.preventDefault();
      this.$store.commit('updatePassword', this.signup.password);
    },
    setMessage: function setMessage(response) {
      if (!response) {
        return;
      }
      console.log('setting repsonse message');
      console.log(response);
      if (response.errors) {
        this.$store.commit('setErrors', response.errors);
      } else if (response.warning) {
        this.$store.commit('setWarning', response.warning);
      } else if (response.info) {
        this.$store.commit('setInfo', response.info);
      } else if (response.success) {
        this.$store.commit('setSuccess', response.success);
      }

      this.$store.commit('setLoading', false);
    },
    setUserToken: function setUserToken(token) {
      console.log('setting token:');
      this.$store.commit('setToken', token);
      console.log('setting current_state');
      this.$store.commit('setCurrentState', 'loggedin');
    },
    signupUser: function signupUser(e) {
      var _this = this;

      e.preventDefault();
      var vm = this;
      this.$store.commit('setLoading', true);
      var creds = this.signup;
      console.log(creds);

      creds.birthday += 'T15:04:05+00:00';
      console.log(creds.birthday);

      var setReponseMessage = this.setMessage;
      var goToLoginPage = function goToLoginPage() {
        _this.$events.emit('goToPageEvent', 'login');
        vm.$store.commit('setCurrentState', 'login');
        vm.$store.commit('resetMessages');
      };
      this.$store.commit('resetMessages');

      var url = __WEBPACK_IMPORTED_MODULE_0__api_variables__["a" /* API_URL */].CurrentUrl + __WEBPACK_IMPORTED_MODULE_0__api_variables__["i" /* SIGNUP_URL */];
      this.$http.post(url, creds).then(function (resp) {
        var data = {};
        console.log(resp);
        if (resp.status === 200) {
          if (resp.data) {
            data = resp.data;
            if (data.message) {
              setReponseMessage({ 'success': 'Please confirm your email now to access your account!' });
              goToLoginPage();
            }
          }
        }
      }, function (err) {
        setReponseMessage(err.data);

        console.log('Error');
        console.log(err);
      });
    }
  },
  components: {
    'terms-modal': __WEBPACK_IMPORTED_MODULE_1__Terms_vue___default.a
  }

});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_variables__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Terms_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Terms_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Terms_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      signup: {
        first_name: '',
        last_name: '',
        status: 'POS',
        birthday: '',
        gender: '',
        nationality: 'ES',
        country_of_residence: 'ES',

        POS_name: '',
        cif: '',
        zip_code: 0,
        country: 'ES',
        address: '',
        city: 'Madrid',

        geo_x: 0,
        geo_y: 0,

        mail: '',
        password: ''
      },
      readTerms: false,
      acceptTerms: false,
      showTerms: false,
      addressIsValid: false,
      updateAddressTimer: 0
    };
  },

  computed: {},
  methods: {
    getLocationFromGoogle: function getLocationFromGoogle(address) {
      var vm = this;
      var key = 'AIzaSyB16sGmIekuGIvYOfNoW9T44377IU2d2Es';
      var url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + address + '&key=' + key;
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: 'GET',
        url: url
      }).then(function (resp) {
        console.log('Geocode response');
        console.log(resp);
        if (resp.data && resp.data.results.length > 0 && resp.data.results[0].geometry.location) {
          var location = resp.data.results[0].geometry.location;
          console.log(location);
          vm.signup.geo_x = location.lng;
          vm.signup.geo_y = location.lat;
        }
      });
    },
    updateAddress: function updateAddress() {
      var _this = this;

      clearTimeout(this.updateAddressTimer);
      this.updateAddressTimer = setTimeout(function () {
        var address = (_this.signup.address + ', ' + _this.signup.zip_code + ' ' + _this.signup.city).replace(' ', '+');
        console.log('updateAddress: ' + address);
        _this.getLocationFromGoogle(address);
      }, 1000);
    },
    toggleTermsModal: function toggleTermsModal(e) {
      e.preventDefault();
      this.showTerms = !this.showTerms;
    },
    goToSignupPage: function goToSignupPage(e) {
      e.preventDefault();

      this.$events.emit('goToPageEvent', 'signup');
      this.$store.commit('resetMessages');
    },
    goToLoginPOSPage: function goToLoginPOSPage(e) {
      e.preventDefault();
      this.$store.commit('setLoginAsUser', false);

      this.$events.emit('goToPageEvent', 'login');
      this.$store.commit('resetMessages');
    },
    updateNationality: function updateNationality(e) {
      e.preventDefault();
      console.log(e.log);
      this.signup.nationality = e.code;
    },
    updateEmail: function updateEmail(e) {
      e.preventDefault();
      this.$store.commit('updateEmail', this.signup.mail);
    },
    updatePassword: function updatePassword(e) {
      e.preventDefault();
      this.$store.commit('updatePassword', this.signup.password);
    },
    setMessage: function setMessage(response) {
      if (!response) {
        return;
      }
      console.log('setting repsonse message');
      console.log(response);
      if (response.errors) {
        this.$store.commit('setErrors', response.errors);
      } else if (response.warning) {
        this.$store.commit('setWarning', response.warning);
      } else if (response.info) {
        this.$store.commit('setInfo', response.info);
      } else if (response.success) {
        this.$store.commit('setSuccess', response.success);
      }

      this.$store.commit('setLoading', false);
    },
    setUserToken: function setUserToken(token) {
      console.log('setting token:');
      this.$store.commit('setToken', token);
      console.log('setting current_state');
      this.$store.commit('setCurrentState', 'loggedin');
    },
    signupUser: function signupUser(e) {
      e.preventDefault();
      var vm = this;
      this.$store.commit('setLoading', true);
      var creds = this.signup;
      console.log(creds);

      creds.birthday += 'T15:04:05+00:00';
      console.log(creds.birthday);

      creds.zip_code = parseInt(creds.zip_code);

      var setReponseMessage = this.setMessage;
      var goToLoginPOSPage = function goToLoginPOSPage() {
        vm.$store.commit('setLoginAsUser', 'loginPOS');
        vm.$events.emit('goToPageEvent', 'login');
        vm.$store.commit('setCurrentState', 'login');
        vm.$store.commit('resetMessages');
      };
      this.$store.commit('resetMessages');

      var url = __WEBPACK_IMPORTED_MODULE_1__api_variables__["a" /* API_URL */].CurrentUrl + __WEBPACK_IMPORTED_MODULE_1__api_variables__["i" /* SIGNUP_URL */];
      this.$http.post(url, creds).then(function (resp) {
        var data = {};
        console.log(resp);
        if (resp.status === 200) {
          if (resp.data) {
            data = resp.data;
            if (data.message) {
              vm.setMessage({ 'success': 'Please confirm your email now to access your account!' });
              goToLoginPOSPage();
            }
          }
        }
      }, function (err) {
        setReponseMessage(err.data);

        console.log('Error');
        console.log(err);
      });
    }
  },
  components: {
    'terms-modal': __WEBPACK_IMPORTED_MODULE_2__Terms_vue___default.a
  }

});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_carousel__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_carousel__);





/* harmony default export */ __webpack_exports__["default"] = ({
  beforeCreate: function beforeCreate() {
    console.log('SLIDES beforeCreate');
  },
  beforeMount: function beforeMount() {
    console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.getImages));
  },
  mounted: function mounted() {
    var vm = this;
    var imageCounter = parseInt(this.getImages.length);
    imageCounter *= this.autoplayTimout;
    var slideCounter = parseInt(this.$store.getters.getCurrentSlides.slides.length);
    slideCounter *= this.autoplayTimout;
    var autoTimeout = imageCounter + slideCounter || this.autoplayTimout;
    console.log('TIMEOUT: ' + autoTimeout);
    setTimeout(function () {
      if (vm.$store.getters.getShowSlide) {
        vm.$events.emit('skipSlideEvent');
      }
    }, autoTimeout + 3000);
    console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.getImages));
    console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.getters.getCurrentImages.slides));
  },

  methods: {
    seperatedSentences: function seperatedSentences(value) {
      if (!value) {
        return '';
      }
      value = value.toString().split('<br>');
      return value;
    },
    skipSlide: function skipSlide(e) {
      e.preventDefault();
      this.$events.emit('skipSlideEvent');
    }
  },
  data: function data() {
    return {
      autoplayTimout: 2330
    };
  },

  computed: {
    getImages: function getImages() {
      var api = this.$store.getters.getApiDB;
      switch (api) {
        case 'mhs':
          return this.$store.getters.getAllImages.mhs;
        case 'jva':
          return this.$store.getters.getAllImages.jva;
        case 'iwth':
          return this.$store.getters.getAllImages.jva;
        default:
          return this.$store.getters.getCurrentImages;
      }
    },
    getSlideImage: function getSlideImage() {
      var lang = localStorage.getItem('user_locale');
      if (lang === 'es') {
        return 'slide-img-es.png';
      } else {
        return 'slide-img-fr.png';
      }
    }
  },
  components: {
    Carousel: __WEBPACK_IMPORTED_MODULE_1_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_1_vue_carousel__["Slide"]
  }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Recharge_vue__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Recharge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Recharge_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {},
  components: {
    'recharge-account-page': __WEBPACK_IMPORTED_MODULE_0__Recharge_vue___default.a
  }
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_variables__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GoTo_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GoTo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__GoTo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var thisMonth = new Date().getUTCMonth();
    var thisYear = new Date().getFullYear() - 2000;
    if (thisMonth < 10) {
      thisMonth = '0' + thisMonth;
    }
    if (thisYear < 10) {
      thisYear = '0' + thisYear;
    }

    return {
      amount: 10,
      cardNo: '',
      CVV: '',
      expirationDate: { month: thisMonth, year: thisYear },
      registerCardResponse: {},
      fee: 0,
      tax: 0,
      taxRate: 0,
      months: 1,
      remainingDays: 30,
      feesData: {},
      Establishment: {},
      secureUrl: '#',
      lastDuration: 0
    };
  },

  watch: {
    lastDuration: function lastDuration(val, oldVal) {
      console.log('new: %s, old: %s', val, oldVal);
      var waitingForSubscriptionSuccess = localStorage.getItem('waitingForSubscriptionSuccess');
      if (Boolean(waitingForSubscriptionSuccess) === false) {
        return;
      }
      if (oldVal !== 0 && oldVal !== val) {
        var lastSubscriptionData = JSON.parse(localStorage.getItem('lastSubscriptionData'));
        if (lastSubscriptionData.end !== undefined) {
          this.$events.emit('pageChangedEvent', '/subscription/success/url-' + lastSubscriptionData.url + '/' + lastSubscriptionData.months + 'month' + '?user=' + lastSubscriptionData.user.email);
          localStorage.removeItem('lastSubscriptionData');
        }
      }
    }
  },
  computed: {
    getLastDuration: function getLastDuration() {
      this.lastDuration = this.$store.getters.getPosSubscriptionEnd;
      return this.lastDuration;
    },
    getSubscriptionEnd: function getSubscriptionEnd() {
      console.log('getSubscriptionEnd');
      return parseInt(this.$store.getters.getPosSubscriptionEnd);
    },
    feesValue: function feesValue() {
      var fee = this.feesData.fee;
      if (fee === undefined) {
        fee = 0.001;
      }
      return (parseFloat(fee) / 100).toFixed(2);
    },
    totalAmountCharged: function totalAmountCharged() {
      var amount = this.months * 10 * 100;
      if (this.feesData.vat_rate === undefined) {
        this.feesData.vat_rate = 21 / 100;
      }
      var taxRate = this.feesData.vat_rate;
      var total = amount + amount * taxRate;

      return total / 100;
    }
  },
  methods: {
    rechargeFormIsValid: function rechargeFormIsValid() {
      var isValid = true;

      if (this.cardNo.length < 16) {
        this.$store.commit('setError', 'The card number is too short');
        isValid = false;
      }
      var thisYear = new Date().getFullYear();
      var y = thisYear - 2000;
      if (this.expirationDate.month < 1 && this.expirationDate.month > 12 || this.expirationDate.year < y) {
        this.$store.commit('setError', 'The expiration date is either invalid or already expired');
        isValid = false;
      }

      return isValid;
    },
    sendSubscription: function sendSubscription() {
      console.log('sendSubscription');
      this.registerCard();
    },
    registerCard: function registerCard() {
      console.log('registerCard');
      if (!this.rechargeFormIsValid()) {
        return;
      }
      var vm = this;

      var authorizationHeader = 'Bearer ' + localStorage.getItem('user_token');
      var options = {
        url: __WEBPACK_IMPORTED_MODULE_1__api_variables__["a" /* API_URL */].CurrentUrl + __WEBPACK_IMPORTED_MODULE_1__api_variables__["f" /* REGISTER_CARD_URL */],
        method: 'POST',
        headers: { 'Authorization': authorizationHeader }
      };
      this.$http(options).then(function (resp) {
        if (resp.data) {
          vm.$store.commit('setRegCardResponse', resp.data);

          vm.callToMangoPayToGetToken(resp.data);
        } else {
          if (resp.error) {
            vm.$store.commit('setError', { error: resp.error });
          } else {
            vm.$store.commit('setError', { error: 'Not data in resp' });
          }
        }
      }, function (err) {
        if (!err.data) {
          vm.$store.commit('setError', { error: 'Card registeration error' });
          return;
        }
        if (err.data.errors) {
          vm.$store.commit('setErrors', err.data.errors);
        }
        vm.$store.commit('setLoading', false);
      });
    },
    callToMangoPayToGetToken: function callToMangoPayToGetToken(data) {
      console.log('callToMangoPayToGetToken');

      this.sendToMangopay(data.accessKeyRef, data.cardRegistrationURL, data.data, this.cardNo, this.expirationDate, this.CVV, this.paySubscription);
    },
    paySubscription: function paySubscription(months, data) {
      var _this = this;

      console.log('paySubscription');
      console.log(months);
      console.log(data);
      var vm = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default()({
        method: 'POST',
        url: __WEBPACK_IMPORTED_MODULE_1__api_variables__["a" /* API_URL */].CurrentUrl + '/pay_subscription',
        data: { months: months, token: data },
        headers: { 'Authorization': 'Bearer ' + localStorage.getItem('user_token') }
      }).then(function (resp) {
        console.log('paySubscription response');
        console.log(resp);
        console.log('status = ', resp.status);
        console.log(resp.data);
        if (resp.data && resp.data.transtion_type === '3DS') {
          if (resp.data.verification_url === '') {
            vm.$store.commit('setError', 'Sorry, no 3DS link to complete the transaction');
            vm.$store.commit('setLoading', false);
            return;
          }
          localStorage.setItem('lastSubscriptionDays', _this.$store.getters.getBalance);
          var decoded = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(localStorage.getItem('user_token'));
          localStorage.setItem('lastSubscriptionData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ end: _this.$store.getters.getSubscriptionEnd, months: _this.months, url: document.location.hostname, user: decoded }));

          vm.$events.emit('showGoToModalEvent', {
            url: resp.data.verification_url,
            message: 'You are redirected to complete the 3DS secure transaction. If you want the transaction to complete continue to the following page and come back when done',
            title: '3DS Transaction',
            buttonText: 'Continue'
          });

          var est = _this.getEstablishment();
          var dt = new Date();
          var transactionData = {
            amount: _this.amount,
            months: _this.months,
            Establishment: est,
            date: dt,
            redirectUrl: _this.secureUrl
          };

          console.log('transactionData');
          console.log(transactionData);

          localStorage.setItem('waitingForSubscriptionSuccess', true);

          vm.$store.commit('setLoading', false);
          vm.$store.commit('setSuccess', 'Started secure transaction please complete process in the new window after you click continue');
          return;
        }
        vm.$store.commit('setLoading', false);
        vm.$store.commit('setSuccess', 'Subscription successful');
      }).catch(function (err) {
        console.log('paySubscription error');
        console.log(err);
        vm.$store.commit('setError', 'Sorry transaction failed');
      });
    },
    sendToMangopay: function sendToMangopay(accessKeyRef, cardRegistrationURL, data, cardNo, expirationDate, CVV, paySubscriptionCallback) {
      console.log('sendToMangopay');
      var mangopayData = {
        data: data,
        accessKeyRef: accessKeyRef,
        cardNumber: cardNo,
        cardExpirationDate: expirationDate.month + expirationDate.year,
        cardCvx: CVV
      };
      var mangoParameters = '';
      for (var key in mangopayData) {
        mangoParameters += (mangoParameters.length > 0 ? '&' : '') + key + '=' + encodeURIComponent(mangopayData[key]);
      }

      var vm = this;
      var instance = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.create({
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
      });
      instance.post(cardRegistrationURL + '?' + mangoParameters, mangopayData).then(function (resp) {
        console.log('sendToMangopay response');
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resp));
        paySubscriptionCallback(vm.months, resp.data);
      }).catch(function (err) {
        vm.$store.commit('setLoading', false);
        vm.$store.commit('setError', 'Error occured while waiting for the payments service');
        console.log(err);
      });
    },
    getEstablishment: function getEstablishment() {
      this.Establishment = this.$store.getters.getEstablishment;
    },
    calculateFees: function calculateFees() {
      console.log('calculateFees:');
      var amount = 10 * this.months * 100;

      var currentUser = JSON.parse(localStorage.getItem('user_data'));
      var countryOfResidence = currentUser.country_of_residence;
      if (countryOfResidence === undefined) {
        countryOfResidence = 'ES';
      }
      countryOfResidence = countryOfResidence.toUpperCase();
      this.getFees(amount, countryOfResidence);
    },
    getFees: function getFees(amount, country) {
      console.log('getFees: amount = ' + amount + ' country = ' + country);
      var vm = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default()({
        method: 'POST',
        url: __WEBPACK_IMPORTED_MODULE_1__api_variables__["a" /* API_URL */].CurrentUrl + '/fees',
        headers: { 'Authorization': 'Bearer ' + localStorage.getItem('user_token') },
        data: {
          amount: amount,
          country: country
        }
      }).then(function (resp) {
        console.log('fee response');
        console.log(resp.data);

        vm.feesData = resp.data;
        vm.fee = parseFloat(vm.feesData.fees) / 100;
        vm.tax = parseFloat(vm.feesData.vat) / 100;
        vm.taxRate = parseFloat(vm.feesData.vat_rate).toFixed(2);
        vm.amount = (parseFloat(vm.feesData.total) / 100).toFixed(2);
      });
    }
  },
  beforeMount: function beforeMount() {
    this.calculateFees();
    this.getEstablishment();
  },

  components: {
    'go-to-box': __WEBPACK_IMPORTED_MODULE_2__GoTo_vue___default.a
  }
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Map_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Map_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      showAddPosModal: false,
      notice: 'Are you sure to logout and register new establishment?'
    };
  },

  methods: {
    logoutAll: function logoutAll(e) {
      this.$store.getters.getFBAuthorized ? this.$events.emit('logoutFBEvent') : this.$events.emit('logoutEvent');
      return true;
    }
  },
  computed: {
    registerPosUrl: function registerPosUrl() {
      var lang = localStorage.getItem('user_locale');
      var url = '/?pos-signup=true&lang=' + encodeURIComponent(lang);
      return url;
    }
  },
  components: {
    'g-map-window': __WEBPACK_IMPORTED_MODULE_0__Map_vue___default.a
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    selected_country: {
      type: String,
      default: 'FR'
    }
  },
  data: function data() {
    return {
      currentTerms: '\n      De conformidad con la Ley Org\xE1nica 15/1999, de 13 de diciembre, de Protecci\xF3n de Datos de Car\xE1cter Personal, le informamos que los datos de car\xE1cter personal que has proporcionado a la asociaci\xF3n Micro Hucha Solidaria est\xE1n incluidos en un fichero automatizado el responsable del cual es la asociaci\xF3n Micro Hucha Solidaria, tambi\xE9n se facilitar\xE1n su nombre y appellidos a las entidades destinatarias de los donativos (Asociaciones o Fundaciones) para la tramitaci\xF3n de su donativo. Asimismo, le informamos que puede ejercer los derechos de acceso, rectificaci\xF3n, cancelaci\xF3n y oposici\xF3n de sus datos solicit\xE1ndolo por correo electr\xF3nico: lopd@microhuchasolidaria.org con una fotocopia de su DNI o documento equivalente para comprobar su identidad.\n      ',
      countries: [{
        'name': 'Spain',
        'db': 'mhs',
        'code': 'ES'
      }, {
        'name': 'France',
        'db': 'jva',
        'code': 'FR'
      }],
      terms: {
        'en': '\n        In accordance with the law 15/1999 of December 13th for the protection of personal data, we inform you that the personal data you have provided are included in an automated file property  of charity Je Vais Aider. Your first name and lastname will also be provided to the charities receiving your donations to process your donation. We also inform you that you can exercise your rights of access, rectification, cancellation and opposition of your data by e-mail to info@jevaisaider.org with proof of your identity.',
        'es': '\n        De conformidad con la Ley Org\xE1nica 15/1999, de 13 de diciembre, de Protecci\xF3n de Datos de Car\xE1cter Personal, le informamos que los datos de car\xE1cter personal que has proporcionado a la asociaci\xF3n Micro Hucha Solidaria est\xE1n incluidos en un fichero automatizado el responsable del cual es la asociaci\xF3n Micro Hucha Solidaria, tambi\xE9n se facilitar\xE1n su nombre y appellidos a las entidades destinatarias de los donativos (Asociaciones o Fundaciones) para la tramitaci\xF3n de su donativo. Asimismo, le informamos que puede ejercer los derechos de acceso, rectificaci\xF3n, cancelaci\xF3n y oposici\xF3n de sus datos solicit\xE1ndolo por correo electr\xF3nico: lopd@microhuchasolidaria.org con una fotocopia de su DNI o documento equivalente para comprobar su identidad.\n        ',
        'fr': '\n        Conform\xE9ment \xE0 la loi 15/1999 du 13 d\xE9cembre de protection des donn\xE9es personnelles, nous vous informons que les donn\xE9es personnelles que vous avez fournies sont inclus dans un fichier automatis\xE9 titulaire de l\'association Je Vais Aider, votre nom et pr\xE9nom seront \xE9galement fournies aux entit\xE9s destinataires des dons (associations ou fondations) pour le traitement de vos dons. Nous vous informons \xE9galement que vous pouvez exercer vos droits d\'acc\xE8s, de rectification, annulation et opposition de vos donn\xE9es par courriel avec une preuve de votre identit\xE9: info@jevaisaider.org\n        '
      }
    };
  },

  watch: {},
  methods: {
    changedCountry: function changedCountry() {
      console.log('changed country');
      console.log(this.POS_country);
      this.currentTerms = this.terms[this.selected_country.toLowerCase()];
    },
    getTerms: function getTerms(lang) {
      console.log('terms');
      var t = this.terms[lang];
      if (t) {
        return t.trim();
      }
      return this.terms.en;
    },
    updateTerms: function updateTerms(lang) {
      this.currentTerms = this.terms['en'];
    }
  },
  computed: {
    getCurrentTerms: function getCurrentTerms() {
      var t = this.terms[this.selected_country.toLowerCase()];
      this.currentTerms = t === '' ? t : this.terms['en'];
      return this.currentTerms;
    }
  }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_variables__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
  beforeMount: function beforeMount() {
    this.getTransactions();
  },
  data: function data() {
    var now = new Date();
    var day, year, month;
    day = now.getDate();
    month = now.getMonth();
    year = now.getFullYear();
    return {
      startDate: '2017-01-01',
      endDate: year + '-' + month + '-' + day
    };
  },

  methods: {
    formatEuros: function formatEuros(amount) {
      return (parseFloat(amount) / 100).toFixed(2);
    },
    getTransactions: function getTransactions() {
      var vm = this;
      var query = '?';
      query += 'before_date=' + encodeURIComponent(this.startDate);
      query += 'after_date=' + encodeURIComponent(this.endDate);
      console.log(query);

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        url: __WEBPACK_IMPORTED_MODULE_0__api_variables__["a" /* API_URL */].CurrentUrl + '/donation',
        headers: { 'Authorization': 'Bearer ' + localStorage.getItem('user_token') }
      }).then(function (resp) {
        console.log('getTransactions response');
        console.log(resp);
        if (resp.data !== undefined) {
          if (resp.data.donations) {
            vm.$store.commit('setTransactions', resp.data.donations);
          }
        }
      });
    }
  }
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      youtube_link_prefix: 'https://www.youtube.com/embed/',
      youtube_link_sufix: '?wmode=transparent&amp;rel=0&amp;autohide=1&amp;showinfo=0&amp;enablejsapi=1',
      videos: [{ id: 'fFIODvFNxJQ' }, { id: 'Du0L6F2uquc' }, { id: 'uGpufaTRlCM' }],
      currentVidID: { id: '8PMJNUjaivw' },
      videoLink: ''
    };
  },
  beforeMount: function beforeMount() {
    var rn = parseInt(Math.random(1) * 10) - 1;
    var lastVidIndex = localStorage.getItem('last_vid');

    if (rn === this.videos.length) {
      rn = rn - 1;
    }
    if (parseInt(lastVidIndex) === rn) {
      rn = parseInt(Math.random(1) * 10) - 1;
      rn === this.videos.length ? rn = 0 : console.log('no change in rn');
    }

    localStorage.setItem('last_vid', rn);
    var randomVideo = this.videos[rn];

    if (randomVideo !== undefined) {
      this.currentVidID = randomVideo;
    } else {
      this.currentVidID = this.videos[0];
    }

    this.videoLink = this.youtube_link_prefix + this.currentVidID.id + this.youtube_link_sufix;
  }
});

/***/ }),
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/glyphicons-halflings-regular.8988968.svg";

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.e18bbf6.ttf";

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.fa27723.woff";

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.448c34a.woff2";

/***/ }),
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(234)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(319),
  /* scopeId */
  "data-v-cb3cfeb6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(232)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(316),
  /* scopeId */
  "data-v-9cb96b52",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(239)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(324),
  /* scopeId */
  "data-v-f31cbca8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(236)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(321),
  /* scopeId */
  "data-v-d2cd3f12",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(228)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(312),
  /* scopeId */
  "data-v-6c05d5f9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(217)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(301),
  /* scopeId */
  "data-v-3299cfbf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(219)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(303),
  /* scopeId */
  "data-v-3b472c45",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(230)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(314),
  /* scopeId */
  "data-v-6db130a4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(222)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(306),
  /* scopeId */
  "data-v-51b512e6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(233)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(318),
  /* scopeId */
  "data-v-a4407eb0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(216)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(299),
  /* scopeId */
  "data-v-1d2e6ac1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(231)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(315),
  /* scopeId */
  "data-v-85a8eb86",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(218)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(302),
  /* scopeId */
  "data-v-3ac80535",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(229)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(313),
  /* scopeId */
  "data-v-6cfa1532",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(240)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(326),
  /* scopeId */
  "data-v-f70de41c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(227)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(311),
  /* scopeId */
  "data-v-652fb008",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(224)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(308),
  /* scopeId */
  "data-v-56d6c511",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(235)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(153),
  /* template */
  __webpack_require__(320),
  /* scopeId */
  "data-v-ce946d92",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(237)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(154),
  /* template */
  __webpack_require__(322),
  /* scopeId */
  "data-v-d2f5af7e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(223)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(307),
  /* scopeId */
  "data-v-5253c522",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(325),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(159),
  /* template */
  __webpack_require__(300),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(226)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(310),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(317),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(238)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(323),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "webapp-wrapper"
  }, [_c('div', {
    staticClass: "other"
  }, [_c('div', {
    class: _vm.getWidthClass,
    attrs: {
      "dir": _vm.currentLangDirection,
      "id": "wrapper"
    }
  }, [_c('span', {
    staticClass: "hidden"
  }, [_vm._v(_vm._s(_vm.currentState))]), _vm._v(" "), _c('div', {
    staticClass: "langs btn-group btn-group-xs",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    class: _vm.lang === 'en' || _vm.lang === '' ? 'btn btn-success' : 'btn btn-default',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLang('en')
      }
    }
  }, [_vm._v("English")]), _vm._v(" "), _c('button', {
    class: _vm.lang === 'es' ? 'btn btn-success' : 'btn btn-default',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLang('es')
      }
    }
  }, [_vm._v("Español")]), _vm._v(" "), _c('button', {
    class: _vm.lang === 'fr' ? 'btn btn-success' : 'btn btn-default',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLang('fr')
      }
    }
  }, [_vm._v("Français")]), _vm._v(" "), _c('button', {
    class: _vm.lang === 'ar' ? 'btn btn-success' : 'btn btn-default',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLang('ar')
      }
    }
  }, [_vm._v("العربية")]), _vm._v(" "), _c('button', {
    class: _vm.lang === 'ru' ? 'btn btn-success' : 'btn btn-default',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setLang('ru')
      }
    }
  }, [_vm._v("русский")])]), _vm._v(" "), (_vm.$store.getters.getShowSlide) ? _c('div', [_c('slide-page')], 1) : _c('div', {
    staticClass: "content"
  }, [(_vm.$store.getters.getLoading) ? _c('div', {
    staticClass: "loading"
  }, [_c('h1', [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-fw"
  }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")]), _vm._v(" "), (_vm.$store.getters.getStillLoading) ? _c('div', {
    staticClass: "loading-takes-long"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('Loading is taking longer than normal')) + "\n            "), _c('a', {
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setLoading', false);
        _vm.$events.emit('goToPageEvent', '')
      }
    }
  }, [_vm._v("Go home")])]) : _vm._e()]) : _c('div', {
    staticClass: "notloading"
  }, [_c('message-items'), _vm._v(" "), _c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-inner"
  }, [_c('vodal', {
    attrs: {
      "show": _vm.$store.getters.getShowGoTo,
      "width": 250,
      "height": 300,
      "animation": "rotate"
    },
    on: {
      "hide": function($event) {
        _vm.$store.commit('setShowGoTo', false)
      }
    }
  }, [_c('go-to-box', {
    attrs: {
      "title": _vm.goToModalData.title,
      "message": _vm.goToModalData.message,
      "targetUrl": _vm.goToModalData.url
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-inner"
  }, [_c('vodal', {
    attrs: {
      "show": _vm.$store.getters.getShowShare,
      "width": 250,
      "height": 300,
      "animation": "rotate"
    },
    on: {
      "hide": function($event) {
        _vm.$store.commit('setShowShare', false)
      }
    }
  }, [_c('share-page')], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-inner"
  }, [_c('vodal', {
    attrs: {
      "show": _vm.$store.getters.getSocialLogin,
      "width": 250,
      "height": 300,
      "animation": "rotate"
    },
    on: {
      "hide": function($event) {
        _vm.$store.commit('setShowSocialLogin', false)
      }
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('Social Login')))]), _vm._v(" "), _c('fb-login')], 1)], 1)]), _vm._v(" "), ((_vm.$store.getters.getCurrentPage != 'login' && _vm.$store.getters.getCurrentPage != '' && _vm.$store.getters.getCurrentState != '' && _vm.$store.getters.getCurrentPage != 'signup')) ? _c('div', {
    staticClass: "top-container"
  }, [_c('div', {
    staticClass: "top-menu"
  }, [_c('div', {
    staticClass: "logout-area"
  }, [_c('button', {
    staticClass: "btn btn-plain btn-back",
    style: (_vm.langDirection == 'rtl' ? 'float:right' : 'float:left'),
    on: {
      "click": _vm.goToPrevPage
    }
  }, [(_vm.langDirection == 'rtl') ? _c('i', {
    staticClass: "fa fa-angle-right fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-angle-left fa-fw"
  })]), _vm._v(" "), _c('span', {
    staticClass: "hidden"
  }, [_vm._v(_vm._s(_vm.getMyBalance))]), _vm._v(" "), _c('div', {
    style: (_vm.langDirection == 'rtl' ? 'float:left' : 'float:right')
  }, [_c('logout-button')], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-wrapper"
  }, [(_vm.$store.getters.getCurrentState == 'login' || _vm.$store.getters.getCurrentState == '') ? _c('div', {
    staticClass: "login-area"
  }, [(_vm.$store.getters.getCurrentPage == 'login' || _vm.$store.getters.getCurrentPage == '') ? _c('div', [_c('login-form')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'signup') ? _c('div', [_c('signup-form')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'signupPOS') ? _c('div', [_c('signup-pos-form')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'share') ? _c('div', [_c('share-page')], 1) : _vm._e()]) : _c('div', {
    staticClass: "loggedin-area"
  }, [_c('div', {}, [(_vm.$store.getters.getCurrentPage == 'home' || _vm.$store.getters.getCurrentPage == '') ? _c('div', [_c('home-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'share') ? _c('div', [_c('share-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'associations') ? _c('div', [_c('associations-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'asso_details') ? _c('div', [_c('association-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'donations') ? _c('div', [_c('donations-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'transactions') ? _c('div', [_c('transactions-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'subscription') ? _c('div', [_c('subscription-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'qrCode') ? _c('div', [_c('qr-code-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'map') ? _c('div', [_c('map-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'admin-page') ? _c('div', [_c('admin-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'supportive-pos') ? _c('div', [_c('supportive-pos-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'solidarity') ? _c('div', [_c('solidarity-account-page')], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.getCurrentPage == 'settings') ? _c('div', [_c('settings-page')], 1) : _vm._e()])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-menu"
  }, [_c('label', {
    class: _vm.$store.getters.getAppMode == 'test' ? 'test-mode version' : 'version'
  }, [_c('span', {
    on: {
      "click": _vm.updateVNCC
    }
  }, [_vm._v("Version: " + _vm._s(_vm.$store.getters.getVersion))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#EEE"
    }
  }, [_vm._v(_vm._s(_vm.$store.getters.getVNCC))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setShowSlides', true);
        return false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o fa-fw"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.helpLink
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('Help')) + "\n            ")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "terms-area"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Terms and conditions')))]), _vm._v(" "), _vm._v("\n      " + _vm._s(_vm.getCurrentTerms) + "\n\n\n")])
},staticRenderFns: []}

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('Account balance')) + ": " + _vm._s(_vm.$store.getters.getBalance) + " " + _vm._s(_vm.$t(_vm.$store.getters.getCurrency)) + " ")]), _vm._v(" "), _c('form', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "title": _vm.$t('Net Amount')
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "amount",
      "aria-describedby": "amount-addon1",
      "type": "number",
      "min": "1",
      "step": "1",
      "placeholder": _vm.$t('Net Amount')
    },
    domProps: {
      "value": _vm.amount,
      "value": (_vm.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "title": _vm.$t('Card Number')
    }
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cardNo),
      expression: "cardNo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cardNo",
      "aria-describedby": "cardNo-addon1",
      "type": "number",
      "min": "1",
      "step": "1",
      "placeholder": _vm.$t('Card Number')
    },
    domProps: {
      "value": _vm.cardNo,
      "value": (_vm.cardNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cardNo = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "title": _vm.$t('CVV Code')
    }
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CVV),
      expression: "CVV"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CVV",
      "aria-describedby": "CVV-addon1",
      "type": "number",
      "min": "1",
      "step": "1",
      "placeholder": _vm.$t('CVV Code')
    },
    domProps: {
      "value": _vm.CVV,
      "value": (_vm.CVV)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.CVV = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "title": _vm.$t('Expiration Date')
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "month-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expirationDate.month),
      expression: "expirationDate.month"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "expirationDateMonth",
      "aria-describedby": "expirationDate-addon1",
      "type": "number",
      "min": "1",
      "max": "12",
      "step": "1",
      "placeholder": _vm.$t('MM')
    },
    domProps: {
      "value": _vm.expirationDate.month,
      "value": (_vm.expirationDate.month)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.expirationDate.month = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "year-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expirationDate.year),
      expression: "expirationDate.year"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "expirationDateYear",
      "width": "3",
      "aria-describedby": "expirationDate-addon1",
      "type": "number",
      "min": "1",
      "step": "1",
      "placeholder": _vm.$t('YY')
    },
    domProps: {
      "value": _vm.expirationDate.year,
      "value": (_vm.expirationDate.year)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.expirationDate.year = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "title": _vm.$t('Charged Amount')
    }
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.totalAmountCharged),
      expression: "totalAmountCharged"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ChargedAmount",
      "disabled": "",
      "aria-describedby": "ChargedAmount-addon1",
      "type": "number",
      "min": "1",
      "step": "1",
      "placeholder": "$t('Charged Ammount')"
    },
    domProps: {
      "value": _vm.totalAmountCharged,
      "value": (_vm.totalAmountCharged)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.totalAmountCharged = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block recharge-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.registerCardAndRecharge
    }
  }, [_vm._v(_vm._s(_vm.$t('Refill')))])]), _vm._v(" "), _c('img', {
    staticClass: "powered-by-mangopay-img",
    attrs: {
      "src": "powered-by-mangopay.png",
      "alt": "Powered by Mangopay"
    }
  }), _vm._v(" "), _c('hr')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "amount-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-euro fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "cardNo-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "CVV-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-key fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "expirationDate-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-times-o fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "ChargedAmount-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-money fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2)])
},staticRenderFns: []}

/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-area-wrapper"
  }, [_c('div', {
    staticClass: "share-button"
  }, [_c('button', {
    class: _vm.$i18n.locale() == 'ar' ? 'btn btn-success btn-xs pull-left' : 'btn btn-success btn-xs pull-right',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setShowShare', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Share')))])]), _vm._v(" "), _c('h1', {
    staticClass: "page-top-title"
  }, [(_vm.$store.getters.getLoginAsUser) ? _c('span', [_vm._v(_vm._s(_vm.$t('Login as User')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('Login as Establishment')))])]), _vm._v(" "), (_vm.$store.getters.getLoginAsUser) ? _c('div', {
    staticClass: "user-login"
  }, [_c('form', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Country'),
      "id": "country-addon1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Donation Destination')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country),
      expression: "country"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "nationality-addon1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateAPI]
    }
  }, _vm._l((_vm.$store.getters.getTopCountries), function(ctry, i) {
    return _c('option', {
      domProps: {
        "selected": i == 1,
        "value": ctry.code
      }
    }, [_vm._v(_vm._s(ctry.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr",
      "title": _vm.$t('Email')
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.mail),
      expression: "login.mail"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "mail",
      "aria-describedby": "email-addon1",
      "type": "email",
      "placeholder": _vm.$t('Email')
    },
    domProps: {
      "value": _vm.login.email,
      "value": (_vm.login.mail)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.login.mail = $event.target.value
      }, _vm.updateEmail]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr",
      "title": _vm.$t('Password')
    }
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.password),
      expression: "login.password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "aria-describedby": "password-addon1",
      "type": "password",
      "placeholder": _vm.$t('Password')
    },
    domProps: {
      "value": _vm.login.password,
      "value": (_vm.login.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.login.password = $event.target.value
      }, _vm.updatePassword]
    }
  })]), _vm._v("\n\n      " + _vm._s(_vm.$t("If you don't have an account yet")) + " "), _c('a', {
    on: {
      "click": _vm.goToSignupPage
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Sign up here')))]), _vm._v(" "), _c('p', {
    staticClass: "tpbutton btn-toolbar text-center"
  }, [_c('button', {
    staticClass: "btn navbar-btn btn-primary login-btn",
    on: {
      "click": _vm.loginUser
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('Login')))]), _vm._v(" "), _c('button', {
    staticClass: "btn navbar-btn btn-primary login-btn",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setShowSocialLogin', true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link fa-fw"
  }), _vm._v(" " + _vm._s(_vm.$t('Social Login')))])]), _vm._v("\n\n      " + _vm._s(_vm.$t('Remember me')) + " "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    attrs: {
      "name": "remember_me",
      "aria-describedby": "password-addon1",
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.rememberMe,
      "value": _vm.rememberMe,
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, _vm.rememberMe) > -1 : (_vm.rememberMe)
    },
    on: {
      "click": _vm.setRememberMe,
      "__c": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.rememberMe,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.rememberMe = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.$store.getters.getShowVideo) ? _c('video-frame') : _vm._e()], 1) : _c('div', {
    staticClass: "POS-login"
  }, [_c('login-pos-form')], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs btn-block",
    on: {
      "click": _vm.gotToLoginPOS
    }
  }, [(!_vm.$store.getters.getLoginAsUser) ? _c('span', [_vm._v(_vm._s(_vm.$t('Login as User')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('Login as Establishment')))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "email-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "password-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('social-sharing', {
    attrs: {
      "url": _vm.url,
      "title": _vm.$t(_vm.title),
      "description": _vm.$t(_vm.description),
      "quote": _vm.$t(_vm.description),
      "hashtags": _vm.$t(_vm.hashtags),
      "twitter-user": _vm.$t(_vm.outTwitterUser)
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('div', {
            staticClass: "container",
            staticStyle: {
              "margin-top": "2em",
              "width": "14em"
            }
          }, [_c('div', {
            staticClass: "row"
          }, [_c('div', {
            staticClass: "col-xs-6",
            staticStyle: {
              "height": "4em",
              "border": "1px solid #fff",
              "background-color": "#3b5998"
            }
          }, [_c('a', {
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-facebook",
            staticStyle: {
              "font-size": "2em",
              "margin": "0.5em 0.8em",
              "color": "white"
            }
          })])], 1)]), _vm._v(" "), _c('div', {
            staticClass: "col-xs-6",
            staticStyle: {
              "height": "4em",
              "border": "1px solid white",
              "background-color": "#55acee"
            }
          }, [_c('a', {
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-twitter",
            staticStyle: {
              "font-size": "2em",
              "margin": "0.5em 0.8em",
              "color": "white"
            }
          })])], 1)])]), _vm._v(" "), _c('div', {
            staticClass: "row"
          }, [_c('div', {
            staticClass: "col-xs-6",
            staticStyle: {
              "height": "4em",
              "border": "1px solid white",
              "background-color": "#4dc247"
            }
          }, [_c('a', {
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "whatsapp"
            }
          }, [_c('i', {
            staticClass: "fa fa-whatsapp",
            staticStyle: {
              "font-size": "2em",
              "margin": "0.5em 0.8em",
              "color": "white"
            }
          })])], 1)]), _vm._v(" "), _c('div', {
            staticClass: "col-xs-6",
            staticStyle: {
              "height": "4em",
              "border": "1px solid white",
              "background-color": "#dd4b39"
            }
          }, [_c('a', {
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "googleplus"
            }
          }, [_c('i', {
            staticClass: "fa fa-google-plus",
            staticStyle: {
              "font-size": "2em",
              "margin": "0.5em 0.8em",
              "color": "white"
            }
          })])], 1)])]), _vm._v(" "), _c('div', {
            staticClass: "row"
          }, [_c('div', {
            staticClass: "col-xs-6",
            staticStyle: {
              "height": "4em",
              "border": "1px solid white",
              "background-color": "#cb2027"
            }
          }, [_c('a', {
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "pinterest"
            }
          }, [_c('i', {
            staticClass: "fa fa-pinterest",
            staticStyle: {
              "font-size": "2em",
              "margin": "0.5em 0.8em",
              "color": "white"
            }
          })])], 1)]), _vm._v(" "), _c('div', {
            staticClass: "col-xs-6",
            staticStyle: {
              "height": "4em",
              "border": "1px solid white",
              "background-color": "#007bb5"
            }
          }, [_c('a', {
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-linkedin",
            staticStyle: {
              "font-size": "2em",
              "margin": "0.5em 0.8em",
              "color": "white"
            }
          })])], 1)])]), _vm._v(" "), _c('div', {
            staticClass: "row"
          }, [_c('div', {
            staticClass: "col-xs-6",
            staticStyle: {
              "height": "4em",
              "border": "1px solid white",
              "background-color": "#ff4500"
            }
          }, [_c('a', {
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "reddit"
            }
          }, [_c('i', {
            staticClass: "fa fa-reddit",
            staticStyle: {
              "font-size": "2em",
              "margin": "0.5em 0.8em",
              "color": "white"
            }
          })])], 1)]), _vm._v(" "), _c('div', {
            staticClass: "col-xs-6",
            staticStyle: {
              "height": "4em",
              "border": "1px solid white",
              "background-color": "#45668e"
            }
          }, [_c('a', {
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "vk"
            }
          }, [_c('i', {
            staticClass: "fa fa-vk",
            staticStyle: {
              "font-size": "2em",
              "margin": "0.5em 0.8em",
              "color": "white"
            }
          })])], 1)])])])])
        
      },
      staticRenderFns: []
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-area-wrapper"
  }, [_c('form', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Country'),
      "id": "country-addon1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Donation Destination')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country),
      expression: "country"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "nationality-addon1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateAPI]
    }
  }, _vm._l((_vm.$store.getters.getTopCountries), function(ctry, i) {
    return _c('option', {
      domProps: {
        "selected": true,
        "value": ctry
      }
    }, [_vm._v(_vm._s(ctry.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr",
      "title": _vm.$t('Email')
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.mail),
      expression: "login.mail"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "mail",
      "aria-describedby": "email-addon1",
      "type": "email",
      "placeholder": _vm.$t('Email')
    },
    domProps: {
      "value": _vm.login.email,
      "value": (_vm.login.mail)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.login.mail = $event.target.value
      }, _vm.updateEmail]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr",
      "title": _vm.$t('Password')
    }
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.password),
      expression: "login.password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "aria-describedby": "password-addon1",
      "type": "password",
      "placeholder": _vm.$t('Password')
    },
    domProps: {
      "value": _vm.login.password,
      "value": (_vm.login.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.login.password = $event.target.value
      }, _vm.updatePassword]
    }
  })]), _vm._v("\n\n    " + _vm._s(_vm.$t("If you don't have an account yet")) + " "), _c('a', {
    on: {
      "click": _vm.goToSignupPage
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Sign up here')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block login-btn",
    on: {
      "click": _vm.loginUser
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('Login')))]), _vm._v("\n    " + _vm._s(_vm.$t('Remember me')) + " "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    attrs: {
      "name": "remember_me",
      "aria-describedby": "password-addon1",
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.rememberMe,
      "value": _vm.rememberMe,
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, _vm.rememberMe) > -1 : (_vm.rememberMe)
    },
    on: {
      "click": _vm.setRememberMe,
      "__c": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.rememberMe,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.rememberMe = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.$store.getters.getShowVideo) ? _c('video-frame') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "email-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "password-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.ready) ? _c('div', {}, [(_vm.authorized) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook fa-fw"
  }), _vm._v(" " + _vm._s(_vm.$t('Logout from facebook')))]) : _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook fa-fw"
  }), _vm._v(" " + _vm._s(_vm.$t('Login from facebook')))]), _vm._v(" "), (_vm.authorized) ? _c('div', {}) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "go-to-box-area"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t(_vm.title)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success btn-block",
    attrs: {
      "href": _vm.url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.buttonText)))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger btn-block",
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": _vm.closeMe
    }
  }, [_vm._v(_vm._s(_vm.$t('Close')))])])
},staticRenderFns: []}

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messages"
  }, [_c('div', {
    staticClass: "error"
  }, _vm._l((_vm.errors), function(error) {
    return _c('div', {
      staticClass: "alert alert-danger alert-dismissible",
      attrs: {
        "track-by": "$index",
        "role": "alert"
      }
    }, [_vm._m(0, true), _vm._v("\n      " + _vm._s(_vm.$t(error)) + "\n    ")])
  })), _vm._v(" "), (_vm.warning) ? _c('div', {
    staticClass: "error"
  }, [_c('div', {
    staticClass: "alert alert-warning alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(1), _vm._v("\n      " + _vm._s(_vm.$t(_vm.warning)) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('div', {
    staticClass: "error"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(2), _vm._v("\n      " + _vm._s(_vm.$t(_vm.info)) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "error"
  }, [_c('div', {
    staticClass: "alert alert-success alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(3), _vm._v("\n      " + _vm._s(_vm.$t(_vm.success)) + "\n    ")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "share-button"
  }, [_c('button', {
    class: _vm.$i18n.locale() == 'ar' ? 'btn btn-success btn-xs pull-left' : 'btn btn-success btn-xs pull-right',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setShowShare', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Share')))])]), _vm._v(" "), _c('h1', {
    staticClass: "page-top-title"
  }, [_vm._v(_vm._s(_vm.$t('Transactions')))]), _vm._v(" "), _c('label', {
    staticClass: "label label-warning"
  }, [_vm._v(_vm._s(_vm.$t('Page is under-construction')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "transacion-date-filters"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "startDate-addon"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Start date')) + " ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "date",
      "type": "date",
      "aria-describedby": "startDate-addon"
    },
    domProps: {
      "value": _vm.startDate
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "endDate-addon"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('End date')) + " ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "date",
      "type": "date",
      "aria-describedby": "endDate-addon"
    },
    domProps: {
      "value": _vm.endDate
    }
  })])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.$t('Transactions')))]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('Charity')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Amount')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.$store.getters.getTransactions), function(item) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(item.association.name)), _c('hr'), _vm._v("\n              " + _vm._s(item.date) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatEuros(item.amount)) + " €")])])
  }))])])])])
},staticRenderFns: []}

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "share-button"
  }, [_c('button', {
    class: _vm.$i18n.locale() == 'ar' ? 'btn btn-success btn-xs pull-left' : 'btn btn-success btn-xs pull-right',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setShowShare', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Share')))])]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('Solidarity Account')))])]), _vm._v(" "), _c('div', [_c('recharge-account-page')], 1)])
},staticRenderFns: []}

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vid-area"
  }, [_c('div', {
    staticStyle: {
      "left": "0",
      "width": "100%",
      "height": "0",
      "position": "relative",
      "padding-bottom": "56.2493%"
    }
  }, [_c('iframe', {
    staticStyle: {
      "border": "0",
      "top": "0",
      "left": "0",
      "width": "100%",
      "height": "100%",
      "position": "absolute"
    },
    attrs: {
      "src": _vm.videoLink,
      "allowfullscreen": "",
      "scrolling": "no"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slides-area"
  }, [_c('div', {
    staticClass: "wrapword"
  }, [_c('carousel', {
    attrs: {
      "autoplay": true,
      "autoplayTimeout": _vm.autoplayTimout,
      "autoplayHoverPause": true,
      "navigationEnabled": true,
      "perPage": 1
    }
  }, [_vm._l((_vm.getImages), function(image, index) {
    return _c('slide', {
      key: index,
      style: (image.styles)
    }, [_c('button', {
      staticClass: "btn btn-default skip-btn",
      attrs: {
        "type": "button",
        "title": _vm.$t('Skip'),
        "name": "skip"
      },
      on: {
        "click": _vm.skipSlide
      }
    }, [_vm._v(" X ")]), _vm._v(" "), _c('div', {
      staticClass: "slider-image"
    }, [_c('img', {
      attrs: {
        "src": image.img,
        "alt": image.title
      }
    })])])
  }), _vm._v(" "), _vm._l((_vm.$store.getters.getCurrentSlides.slides), function(slide, index) {
    return _c('slide', {
      key: index,
      style: (slide.style)
    }, [_c('button', {
      staticClass: "btn btn-default skip-btn",
      attrs: {
        "type": "button",
        "title": _vm.$t('Skip'),
        "name": "skip"
      },
      on: {
        "click": _vm.skipSlide
      }
    }, [_vm._v(" X ")]), _vm._v(" "), _c('div', {
      staticClass: "label",
      attrs: {
        "dir": "ltr"
      }
    }, _vm._l((_vm.seperatedSentences(_vm.$t(slide.text))), function(text) {
      return _c('p', {
        staticClass: "sentence",
        attrs: {
          "dir": "ltr"
        }
      }, [_vm._v(_vm._s(text))])
    }))])
  })], 2)], 1)])
},staticRenderFns: []}

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$store.getters.getUserType === 'USER' || _vm.$store.getters.getUserType === 'ADMIN') ? _c('div', {
    staticClass: "user-home"
  }, [_c('div', {
    staticClass: "share-button"
  }, [_c('button', {
    class: _vm.$i18n.locale() == 'ar' ? 'btn btn-success btn-xs pull-left' : 'btn btn-success btn-xs pull-right',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setShowShare', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Share')))])]), _vm._v(" "), _c('h4', {
    staticClass: "page-top-title"
  }, [_vm._v(_vm._s(_vm.$t('hi')) + ", " + _vm._s(_vm.getUsername))]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t('Thanks for your generous heart. You are changing the world for a lot of people who lost hope')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Country'),
      "id": "country-addon1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Donation Destination')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country),
      expression: "country"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "nationality-addon1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateCountry]
    }
  }, _vm._l((_vm.getApiCountries), function(ctry, i) {
    return _c('option', {
      domProps: {
        "selected": i === 0,
        "value": ctry
      }
    }, [_vm._v(_vm._s(ctry.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-group-vertical btn-block",
    attrs: {
      "role": "group",
      "aria-label": "home-menu-items"
    }
  }, [_c('button', {
    staticClass: "btn btn-default active"
  }, [_vm._v(_vm._s(_vm.$t('Home')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.goToAssociations
    }
  }, [_vm._v(_vm._s(_vm.$t('Charities')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.goToDonations
    }
  }, [_vm._v(_vm._s(_vm.$t('My Donations')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.goToSolidarityAccount
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Solidarity Account')) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.gotToSupportivePOSMap
    }
  }, [_vm._v(_vm._s(_vm.$t('Supportive Establishments')))]), _vm._v(" "), (_vm.$store.getters.getUserType === 'ADMIN') ? _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.goToAdminPage
    }
  }, [_vm._v(_vm._s(_vm.$t('Admin')))]) : _vm._e()]), _vm._v(" "), (_vm.$store.getters.getBalance) ? _c('p', [_vm._v("\n      " + _vm._s(_vm.$t('Total Donations')) + ": "), _c('span', {}, [_vm._v(_vm._s(_vm.$store.getters.getBalance) + " €")])]) : _c('p', [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-fw"
  })])]) : (_vm.$store.getters.getUserType === 'POS') ? _c('div', {
    staticClass: "pos-home"
  }, [_c('div', {
    staticClass: "share-button"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setShowShare', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Share')))])]), _vm._v(" "), _c('h4', {
    staticClass: "page-top-title"
  }, [_vm._v(_vm._s(_vm.$t('hi')) + ", " + _vm._s(_vm.getUsername))]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.$t('Thanks for your generous heart. You are changing the world for a lot of people who lost hope')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-group-vertical btn-block",
    attrs: {
      "role": "group",
      "aria-label": "home-menu-items"
    }
  }, [_c('button', {
    staticClass: "btn btn-default active"
  }, [_vm._v(_vm._s(_vm.$t('Home')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.goToAssociations
    }
  }, [_vm._v(_vm._s(_vm.$t('Charities')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.gotToSubscription
    }
  }, [_vm._v(_vm._s(_vm.$t('Subscription')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.gotToQRCode
    }
  }, [_vm._v(_vm._s(_vm.$t('My QR Code')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.gotToMap
    }
  }, [_vm._v(_vm._s(_vm.$t('Map')))])])]) : _c('div', {}, [_c('p', [_vm._v("Sorry! this page don't support your user type")]), _vm._v(" "), _c('p', [_vm._v("Type: " + _vm._s(_vm.$store.getters.getUserType))])])])
},staticRenderFns: []}

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signup-area-wrapper"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-inner"
  }, [_c('vodal', {
    attrs: {
      "show": _vm.showTerms,
      "width": 250,
      "height": 300,
      "animation": "rotate"
    },
    on: {
      "hide": function($event) {
        _vm.showTerms = false
      }
    }
  }, [_c('terms-modal', {
    attrs: {
      "selected_country": _vm.signup.country_of_residence
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "share-button"
  }, [_c('button', {
    class: _vm.$i18n.locale() == 'ar' ? 'btn btn-success btn-xs pull-left' : 'btn btn-success btn-xs pull-right',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setShowShare', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Share')))])]), _vm._v(" "), _c('h1', {
    staticClass: "page-top-title"
  }, [_vm._v(_vm._s(_vm.$t('Sign up')))]), _vm._v(" "), _c('form', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('First name'),
      "id": "fname-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-o fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.first_name),
      expression: "signup.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "first_name",
      "aria-describedby": "fname-addon1",
      "type": "text",
      "placeholder": _vm.$t('First name')
    },
    domProps: {
      "value": _vm.signup.first_name,
      "value": (_vm.signup.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.first_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Last name'),
      "id": "lname-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-o fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.last_name),
      expression: "signup.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "last_name",
      "aria-describedby": "lname-addon1",
      "type": "text",
      "placeholder": _vm.$t('Last name')
    },
    domProps: {
      "value": _vm.signup.last_name,
      "value": (_vm.signup.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.last_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Birthday'),
      "id": "birthday-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-birthday-cake fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.birthday),
      expression: "signup.birthday"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "birthday",
      "aria-describedby": "birthday-addon1",
      "type": "date",
      "placeholder": _vm.$t('Birthday')
    },
    domProps: {
      "value": _vm.signup.birthday,
      "value": (_vm.signup.birthday)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.birthday = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Gender'),
      "id": "gender-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-venus-mars fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "gender-addon1"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.gender),
      expression: "signup.gender"
    }],
    attrs: {
      "type": "radio",
      "name": "gender",
      "checked": "",
      "value": "M"
    },
    domProps: {
      "checked": _vm._q(_vm.signup.gender, "M")
    },
    on: {
      "__c": function($event) {
        _vm.signup.gender = "M"
      }
    }
  }), _vm._v(_vm._s(_vm.$t('Male')))]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.gender),
      expression: "signup.gender"
    }],
    attrs: {
      "type": "radio",
      "name": "gender",
      "value": "F"
    },
    domProps: {
      "checked": _vm._q(_vm.signup.gender, "F")
    },
    on: {
      "__c": function($event) {
        _vm.signup.gender = "F"
      }
    }
  }), _vm._v(_vm._s(_vm.$t('Female')))])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Nationality'),
      "id": "nationality-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-globe fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.nationality),
      expression: "signup.nationality"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "nationality-addon1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.signup.nationality = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.$store.getters.getAllCountries), function(country) {
    return _c('option', {
      attrs: {
        "disabled": country.code == '_'
      },
      domProps: {
        "selected": country.code == 'ES',
        "value": country.code
      },
      on: {
        "changed": function($event) {
          _vm.signup.nationality = country.code
        }
      }
    }, [_vm._v(_vm._s(_vm.$t(country.name)))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Country of residence'),
      "id": "country_of_residence-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.country_of_residence),
      expression: "signup.country_of_residence"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "country_of_residence-addon1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.signup.country_of_residence = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.$store.getters.getAllCountries), function(country) {
    return _c('option', {
      attrs: {
        "disabled": country.code == '_'
      },
      domProps: {
        "selected": country.code == 'ES',
        "value": country.code
      },
      on: {
        "changed": function($event) {
          _vm.signin.country_of_residence = country.code
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(country.name)))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Email'),
      "id": "email-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.mail),
      expression: "signup.mail"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "mail",
      "aria-describedby": "email-addon1",
      "type": "email",
      "placeholder": _vm.$t('Email')
    },
    domProps: {
      "value": _vm.signup.email,
      "value": (_vm.signup.mail)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.mail = $event.target.value
      }, _vm.updateEmail]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Password'),
      "id": "password-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.password),
      expression: "signup.password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "aria-describedby": "password-addon1",
      "type": "password",
      "placeholder": _vm.$t('Password')
    },
    domProps: {
      "value": _vm.signup.password,
      "value": (_vm.signup.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.password = $event.target.value
      }, _vm.updatePassword]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Terms and conditions'),
      "id": "terms-addon1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.acceptTerms),
      expression: "acceptTerms"
    }],
    attrs: {
      "name": "accept_terms",
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.acceptTerms,
      "value": _vm.acceptTerms,
      "checked": Array.isArray(_vm.acceptTerms) ? _vm._i(_vm.acceptTerms, _vm.acceptTerms) > -1 : (_vm.acceptTerms)
    },
    on: {
      "click": _vm.toggleTermsModal,
      "__c": function($event) {
        var $$a = _vm.acceptTerms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.acceptTerms,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.acceptTerms = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.acceptTerms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.acceptTerms = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "form-control",
    attrs: {
      "for": "accept_terms",
      "aria-describedby": "terms-addon1"
    }
  }, [_vm._v(_vm._s(_vm.$t('Terms and conditions')))])]), _vm._v("\n\n    " + _vm._s(_vm.$t('If you already have an account')) + " "), _c('a', {
    on: {
      "click": _vm.goToLoginPage
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Login here')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block signup-btn",
    attrs: {
      "disabled": !_vm.acceptTerms
    },
    on: {
      "click": _vm.signupUser
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('Sign up')))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs btn-block",
    on: {
      "click": _vm.goToSignupPOSPage
    }
  }, [_vm._v(_vm._s(_vm.$t('Signup as Establishment')))])])
},staticRenderFns: []}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.getters.getCurrentState !== 'login' && _vm.$store.getters.getCurrentState !== '') ? _c('div', {
    staticClass: "logout-area"
  }, [_c('div', {
    staticClass: "nav navbar-default"
  }, [(!_vm.$store.getters.getFBAuthorized) ? _c('button', {
    staticClass: "btn btn-danger btn-xs pull-right",
    attrs: {
      "title": _vm.$t('Logout')
    },
    on: {
      "click": _vm.logoutUser
    }
  }, [_vm._v(_vm._s(_vm.$t('Logout')))]) : _c('button', {
    staticClass: "btn btn-danger btn-xs pull-right",
    attrs: {
      "title": _vm.$t('Logout')
    },
    on: {
      "click": _vm.socialLogout
    }
  }, [_vm._v(_vm._s(_vm.$t('Logout')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs pull-right",
    attrs: {
      "title": _vm.$t('Settings')
    },
    on: {
      "click": _vm.goToSettingsPage
    }
  }, [_c('i', {
    staticClass: "fa fa-cog fa-fw"
  })]), _vm._v(" "), (_vm.$store.getters.getLoginAsUser) ? _c('label', {
    class: _vm.balanceLabelClasses,
    attrs: {
      "title": _vm.$t('Wallet Balance')
    },
    on: {
      "click": _vm.goToSolidarityAccount
    }
  }, [_vm._v(" " + _vm._s(_vm.$store.getters.getBalance) + " € ")]) : _c('label', {
    class: _vm.daysLeftLabelClasses,
    attrs: {
      "title": _vm.$t('Days left from subscription')
    },
    on: {
      "click": _vm.gotToSubscription
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('{x} day ::: {x} days', {
    x: _vm.$store.getters.getPosSubscriptionEnd
  }, _vm.$store.getters.getPosSubscriptionEnd)) + " ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xs our-twitter-link",
    attrs: {
      "title": _vm.$t('twitter'),
      "target": "_blank",
      "href": _vm.twitterUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter fa-fw"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xs our-facebook-link",
    attrs: {
      "title": _vm.$t('facebook'),
      "target": "_blank",
      "href": _vm.facebookUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook fa-fw"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-xs our-linkedin-link",
    attrs: {
      "title": _vm.$t('LinkedIn'),
      "target": "_blank",
      "href": _vm.linkedInUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin fa-fw"
  })])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "share-button"
  }, [_c('button', {
    class: _vm.$i18n.locale() == 'ar' ? 'btn btn-success btn-xs pull-left' : 'btn btn-success btn-xs pull-right',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setShowShare', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Share')))])]), _vm._v(" "), _c('h1', {
    staticClass: "page-top-title"
  }, [_vm._v(_vm._s(_vm.$t('Settings')))]), _vm._v(" "), _c('label', {
    staticClass: "label label-warning"
  }, [_vm._v(_vm._s(_vm.$t('Page is under-construction')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPass),
      expression: "oldPass"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "oldpassword",
      "aria-describedby": "oldpass-addon1",
      "type": "password",
      "placeholder": _vm.$t('Old Password')
    },
    domProps: {
      "value": _vm.oldPass,
      "value": (_vm.oldPass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPass = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPass1),
      expression: "newPass1"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "newpassword1",
      "aria-describedby": "newPass1-addon1",
      "type": "password",
      "placeholder": _vm.$t('New Password')
    },
    domProps: {
      "value": _vm.newPass1,
      "value": (_vm.newPass1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPass1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPass2),
      expression: "newPass2"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "newpassword2",
      "aria-describedby": "newPass1-addon1",
      "type": "password",
      "placeholder": _vm.$t('Confirm Password')
    },
    domProps: {
      "value": _vm.newPass2,
      "value": (_vm.newPass2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPass2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t('Change Password')))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "oldpass-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "newPass1-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "associations-list"
  }, [_c('div', {
    staticClass: "association-box"
  }, [_c('div', {}, [_c('div', {
    staticClass: "btn-group donation-section",
    attrs: {
      "role": "group",
      "aria-label": "donation-section"
    }
  }, [_c('button', {
    class: 'btn btn-default' + (_vm.donationAmount == 200 ? ' active' : ''),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.donationAmount = 200
      }
    }
  }, [_vm._v("€ 2")]), _vm._v(" "), _c('button', {
    class: 'btn btn-default' + (_vm.donationAmount == 400 ? ' active' : ''),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.donationAmount = 400
      }
    }
  }, [_vm._v("€ 4")]), _vm._v(" "), _c('button', {
    class: 'btn btn-default' + (_vm.donationAmount == 600 ? ' active' : ''),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.donationAmount = 600
      }
    }
  }, [_vm._v("€ 6")]), _vm._v(" "), _c('button', {
    class: 'btn btn-default' + (_vm.donationAmount == 800 ? ' active' : ''),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.donationAmount = 800
      }
    }
  }, [_vm._v("€ 8")]), _vm._v(" "), _c('button', {
    class: 'btn btn-default' + (_vm.donationAmount == 1000 ? ' active' : ''),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.donationAmount = 1000
      }
    }
  }, [_vm._v("€ 10")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-right donate-btn",
    attrs: {
      "disabled": _vm.donationAmount < 200,
      "type": "button",
      "name": "donate"
    },
    on: {
      "click": _vm.submitDonation
    }
  }, [_vm._v(_vm._s(_vm.$t('Donate')))])])]), _vm._v(" "), _c('img', {
    staticClass: "assoc-logo-large",
    attrs: {
      "src": _vm.assoc.logo_url,
      "alt": _vm.assoc.short_description
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.assoc.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.assoc.description))]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item",
    attrs: {
      "title": _vm.$t('address')
    }
  }, [_c('i', {
    staticClass: "fa fa-map fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "assoc-labels"
  }, [_vm._v(_vm._s(_vm.assoc.address))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item",
    attrs: {
      "title": _vm.$t('city')
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "assoc-labels"
  }, [_vm._v(_vm._s(_vm.assoc.city))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item",
    attrs: {
      "title": _vm.$t('twitter')
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "assoc-labels"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": 'https://twitter.com/' + _vm.assoc.twitter_username
    }
  }, [_vm._v("@" + _vm._s(_vm.assoc.twitter_username))])])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item",
    attrs: {
      "title": _vm.$t('Total Donations')
    }
  }, [_c('i', {
    staticClass: "fa fa-line-chart fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "assoc-labels"
  }, [_vm._v("€ " + _vm._s(_vm.assoc.total_donations / 100))])])])])])
},staticRenderFns: []}

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qr-code-area"
  }, [(_vm.qrCodeImage) ? _c('div', {
    staticClass: "rotate90degrees qr-code-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.qrCodeImage,
      "alt": _vm.$t('Your QR Code'),
      "title": _vm.$t('Your QR Code')
    }
  })]) : _c('div', {}, [_c('p', [_vm._v(_vm._s(_vm.$t('Sorry, no QR code image found')))])])])
},staticRenderFns: []}

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-inner"
  }, [_c('vodal', {
    attrs: {
      "show": _vm.showTerms,
      "width": 250,
      "height": 300,
      "animation": "rotate"
    },
    on: {
      "hide": function($event) {
        _vm.showTerms = false
      }
    }
  }, [_c('terms-modal', {
    attrs: {
      "selected_country": _vm.newAsso.country
    }
  })], 1)], 1)]), _vm._v(" "), _c('h4', {
    staticClass: "page-top-title"
  }, [_vm._v(_vm._s(_vm.$t('Dashboard')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Associations')))]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#all-assoc"
    }
  }, [_vm._v(_vm._s(_vm.$t('All')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#add-assoc"
    }
  }, [_vm._v(_vm._s(_vm.$t('Add')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#update-assoc"
    }
  }, [_vm._v(_vm._s(_vm.$t('Update')))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-wrapper associations-tabs"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": "all-assoc"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('All Associations')))]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.$store.getters.getAssociations.length))]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.$store.getters.getAssociations), function(item) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('div', {
      staticClass: "association-list-item"
    }, [_c('span', {
      staticClass: "asso-name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._m(0, true)])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "add-assoc"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Add New Association')))]), _vm._v(" "), _c('form', {
    staticClass: "form",
    attrs: {
      "id": "add-asso-form"
    }
  }, [_c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('First name'),
      "id": "fname-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-o fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.first_name),
      expression: "newAsso.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "first_name",
      "aria-describedby": "fname-addon1",
      "type": "text",
      "placeholder": _vm.$t('First name')
    },
    domProps: {
      "value": _vm.newAsso.first_name,
      "value": (_vm.newAsso.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.first_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Last name'),
      "id": "lname-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-o fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.last_name),
      expression: "newAsso.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "last_name",
      "aria-describedby": "lname-addon1",
      "type": "text",
      "placeholder": _vm.$t('Last name')
    },
    domProps: {
      "value": _vm.newAsso.last_name,
      "value": (_vm.newAsso.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.last_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Birthday'),
      "id": "birthday-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-birthday-cake fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.birthday),
      expression: "newAsso.birthday"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "birthday",
      "aria-describedby": "birthday-addon1",
      "type": "date",
      "placeholder": _vm.$t('Birthday')
    },
    domProps: {
      "value": _vm.newAsso.birthday,
      "value": (_vm.newAsso.birthday)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.birthday = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Nationality'),
      "id": "nationality-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-globe fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.nationality),
      expression: "newAsso.nationality"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "aria-describedby": "nationality-addon1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newAsso.nationality = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.$store.getters.getAllCountries), function(ctr) {
    return _c('option', {
      attrs: {
        "disabled": ctr.code == '_'
      },
      domProps: {
        "selected": ctr.code == 'ES',
        "value": ctr.code
      },
      on: {
        "changed": function($event) {
          _vm.newAsso.nationality = ctr.code
        }
      }
    }, [_vm._v(_vm._s(_vm.$t(ctr.name)))])
  }))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Country of residence'),
      "id": "country_of_residence-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.country_of_residence),
      expression: "newAsso.country_of_residence"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "aria-describedby": "country_of_residence-addon1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newAsso.country_of_residence = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.$store.getters.getAllCountries), function(country) {
    return _c('option', {
      attrs: {
        "disabled": country.code == '_'
      },
      domProps: {
        "selected": country.code == 'ES',
        "value": country.code
      },
      on: {
        "changed": function($event) {
          _vm.signin.country_of_residence = country.code
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(country.name)))])
  }))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Association name'),
      "id": "name-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-institution fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.name),
      expression: "newAsso.name"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "name",
      "aria-describedby": "name-addon1",
      "type": "text",
      "placeholder": _vm.$t('Association name')
    },
    domProps: {
      "value": _vm.newAsso.name,
      "value": (_vm.newAsso.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('description'),
      "id": "description-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-signs fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.description),
      expression: "newAsso.description"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "description",
      "aria-describedby": "description-addon1",
      "type": "text",
      "placeholder": _vm.$t('description')
    },
    domProps: {
      "value": _vm.newAsso.description,
      "value": (_vm.newAsso.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Logo URL'),
      "id": "logo_url-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-anchor fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.logo_url),
      expression: "newAsso.logo_url"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "logo_url",
      "aria-describedby": "logo_url-addon1",
      "type": "text",
      "placeholder": _vm.$t('Logo URL')
    },
    domProps: {
      "value": _vm.newAsso.logo_url,
      "value": (_vm.newAsso.logo_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.logo_url = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Twitter Username'),
      "id": "twitter_username-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-anchor fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.twitter_username),
      expression: "newAsso.twitter_username"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "twitter_username",
      "aria-describedby": "twitter_username-addon1",
      "type": "text",
      "placeholder": _vm.$t('Twitter Username')
    },
    domProps: {
      "value": _vm.newAsso.twitter_username,
      "value": (_vm.newAsso.twitter_username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.twitter_username = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('IBAN'),
      "id": "iban-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-institution fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.bank_account_iban),
      expression: "newAsso.bank_account_iban"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "bank_account_iban",
      "aria-describedby": "iban-addon1",
      "type": "text",
      "placeholder": _vm.$t('IBAN')
    },
    domProps: {
      "value": _vm.newAsso.bank_account_iban,
      "value": (_vm.newAsso.bank_account_iban)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.bank_account_iban = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('BIC'),
      "id": "bic-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-institution fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.bank_account_bic),
      expression: "newAsso.bank_account_bic"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "bank_account_bic",
      "aria-describedby": "bic-addon1",
      "type": "text",
      "placeholder": _vm.$t('BIC')
    },
    domProps: {
      "value": _vm.newAsso.bank_account_bic,
      "value": (_vm.newAsso.bank_account_bic)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.bank_account_bic = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Country'),
      "id": "country-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-globe fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.country),
      expression: "newAsso.country"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "aria-describedby": "country-addon1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newAsso.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.$store.getters.getAllCountries), function(country) {
    return _c('option', {
      attrs: {
        "disabled": country.code == '_'
      },
      domProps: {
        "selected": country.code == 'ES',
        "value": country.code
      },
      on: {
        "changed": function($event) {
          _vm.newAsso.country = country.code
        }
      }
    }, [_vm._v(_vm._s(_vm.$t(country.name)))])
  }))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('City'),
      "id": "city-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.city),
      expression: "newAsso.city"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "city",
      "aria-describedby": "city-addon1",
      "type": "text",
      "placeholder": _vm.$t('City')
    },
    domProps: {
      "value": _vm.newAsso.city,
      "value": (_vm.newAsso.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.city = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('address'),
      "id": "address-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-signs fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.address),
      expression: "newAsso.address"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "address",
      "aria-describedby": "address-addon1",
      "type": "text",
      "placeholder": _vm.$t('address')
    },
    domProps: {
      "value": _vm.newAsso.address,
      "value": (_vm.newAsso.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Email'),
      "id": "email-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.mail),
      expression: "newAsso.mail"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "mail",
      "aria-describedby": "email-addon1",
      "type": "email",
      "placeholder": _vm.$t('Email')
    },
    domProps: {
      "value": _vm.newAsso.email,
      "value": (_vm.newAsso.mail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.mail = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Password'),
      "id": "password-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAsso.password),
      expression: "newAsso.password"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "password",
      "aria-describedby": "password-addon1",
      "type": "password",
      "placeholder": _vm.$t('Password')
    },
    domProps: {
      "value": _vm.newAsso.password,
      "value": (_vm.newAsso.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newAsso.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Terms and conditions'),
      "id": "terms-addon1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.acceptTerms),
      expression: "acceptTerms"
    }],
    attrs: {
      "required": "",
      "name": "accept_terms",
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.acceptTerms,
      "value": _vm.acceptTerms,
      "checked": Array.isArray(_vm.acceptTerms) ? _vm._i(_vm.acceptTerms, _vm.acceptTerms) > -1 : (_vm.acceptTerms)
    },
    on: {
      "click": _vm.toggleTermsModal,
      "__c": function($event) {
        var $$a = _vm.acceptTerms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.acceptTerms,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.acceptTerms = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.acceptTerms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.acceptTerms = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "form-control",
    attrs: {
      "for": "accept_terms",
      "aria-describedby": "terms-addon1"
    }
  }, [_vm._v(_vm._s(_vm.$t('Terms and conditions')))])])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block newAsso-btn",
    attrs: {
      "type": "submit",
      "disabled": !_vm.acceptTerms
    },
    on: {
      "click": _vm.registerAssoUser
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('Register')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "update-assoc"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Update Associations.')))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-primary btn-xs edit-asso-btn pull-right",
    attrs: {
      "type": "button",
      "name": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil fa-fw"
  })])
}]}

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form"
  }, [_c('p', {
    staticStyle: {
      "margin": ".3em"
    }
  }, [_vm._v(_vm._s(_vm.$t('Your subscription ends in {days} day ::: Your subscription ends in {days} days', {
    days: _vm.getSubscriptionEnd
  }, _vm.getSubscriptionEnd)))]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Duration'),
      "id": "months-addon1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Duration')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.months),
      expression: "months"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "nationality-addon1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.months = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calculateFees]
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": 1
    }
  }, [_vm._v(_vm._s(_vm.$t('1 month')))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v(_vm._s(_vm.$t('3 month')))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 6
    }
  }, [_vm._v(_vm._s(_vm.$t('6 month')))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 12
    }
  }, [_vm._v(_vm._s(_vm.$t('12 month')))])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr",
      "title": _vm.$t('Card Number')
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cardNo),
      expression: "cardNo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cardNo",
      "aria-describedby": "cardNo-addon1",
      "type": "number",
      "min": "1",
      "step": "1",
      "placeholder": _vm.$t('Card Number')
    },
    domProps: {
      "value": _vm.cardNo,
      "value": (_vm.cardNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cardNo = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr",
      "title": _vm.$t('CVV Code')
    }
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CVV),
      expression: "CVV"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CVV",
      "aria-describedby": "CVV-addon1",
      "type": "number",
      "min": "1",
      "step": "1",
      "placeholder": _vm.$t('CVV Code')
    },
    domProps: {
      "value": _vm.CVV,
      "value": (_vm.CVV)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.CVV = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr",
      "title": _vm.$t('Expiration Date')
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "month-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expirationDate.month),
      expression: "expirationDate.month"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "expirationDateMonth",
      "aria-describedby": "expirationDate-addon1",
      "type": "number",
      "min": "1",
      "max": "12",
      "step": "1",
      "placeholder": _vm.$t('MM')
    },
    domProps: {
      "value": _vm.expirationDate.month,
      "value": (_vm.expirationDate.month)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.expirationDate.month = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "year-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expirationDate.year),
      expression: "expirationDate.year"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "expirationDateYear",
      "width": "3",
      "aria-describedby": "expirationDate-addon1",
      "type": "number",
      "min": "1",
      "step": "1",
      "placeholder": _vm.$t('YY')
    },
    domProps: {
      "value": _vm.expirationDate.year,
      "value": (_vm.expirationDate.year)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.expirationDate.year = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr",
      "title": _vm.$t('TAX %')
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "TAX-addon1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('TAX')) + " " + _vm._s(_vm.taxRate) + "%")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tax),
      expression: "tax"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "tax",
      "disabled": "",
      "aria-describedby": "TAX-addon1",
      "type": "number",
      "min": "1",
      "step": "1",
      "placeholder": _vm.$t('TAX %')
    },
    domProps: {
      "value": (_vm.tax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tax = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr",
      "title": _vm.$t('Fee')
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "Fee-addon1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Fee')) + " ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fee),
      expression: "fee"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "fee",
      "disabled": "",
      "aria-describedby": "Fee-addon1",
      "type": "number",
      "min": "1",
      "step": "1",
      "placeholder": _vm.$t('Fee')
    },
    domProps: {
      "value": (_vm.fee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fee = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr",
      "title": _vm.$t('Total Amount Charged')
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "ChargedAmount-addon1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Total Amount Charged')) + " ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ChargedAmount",
      "disabled": "",
      "aria-describedby": "ChargedAmount-addon1",
      "type": "number",
      "min": "1",
      "step": "1",
      "placeholder": _vm.$t('Total Amount Charged')
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block recharge-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendSubscription
    }
  }, [_vm._v(_vm._s(_vm.$t('Pay Subscription')))])]), _vm._v(" "), _c('img', {
    staticClass: "powered-by-mangopay-img",
    attrs: {
      "src": "powered-by-mangopay.png",
      "alt": _vm.$t('Powered by Mangopay')
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "cardNo-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "CVV-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-key fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "expirationDate-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-times-o fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "share-button"
  }, [_c('button', {
    class: _vm.$i18n.locale() == 'ar' ? 'btn btn-success btn-xs pull-left' : 'btn btn-success btn-xs pull-right',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setShowShare', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Share')))])]), _vm._v(" "), _c('h1', {
    staticClass: "page-top-title"
  }, [_vm._v(_vm._s(_vm.$t('My Donations')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('Charity')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Amount')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.$store.getters.getTransactions), function(item) {
    return _c('tr', [_c('td', [_c('h4', {
      staticClass: "charity-name"
    }, [_vm._v("\n                " + _vm._s(item.association.name) + "\n                "), _c('label', {
      staticClass: "date-label"
    }, [_vm._v(_vm._s(_vm.formatDate(item.created_at)))])])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.formatEuros(item.amount)) + " €")])])])
  }))])])])])
},staticRenderFns: []}

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-inner"
  }, [_c('vodal', {
    attrs: {
      "show": _vm.showAddPosModal,
      "width": 250,
      "height": 300,
      "animation": "rotate"
    },
    on: {
      "hide": function($event) {
        _vm.showAddPosModal = false
      }
    }
  }, [_c('div', {
    staticClass: "notice-box"
  }, [_c('p', [_vm._v("\n              " + _vm._s(_vm.$t(_vm.notice)) + "\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": _vm.registerPosUrl
    },
    on: {
      "click": _vm.logoutAll
    }
  }, [_vm._v(_vm._s(_vm.$t('Logout')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.showAddPosModal = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))])])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "share-button"
  }, [_c('button', {
    class: _vm.$i18n.locale() == 'ar' ? 'btn btn-success btn-xs pull-left' : 'btn btn-success btn-xs pull-right',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setShowShare', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Share')))]), _vm._v(" "), _c('button', {
    class: _vm.$i18n.locale() == 'ar' ? 'btn btn-success pull-left add-pos-btn' : 'btn btn-success pull-right add-pos-btn',
    attrs: {
      "type": "button",
      "title": _vm.$t('Add Supportive Establishment'),
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.showAddPosModal = true
      }
    }
  }, [_vm._v("+")])]), _vm._v(" "), _c('h4', {
    staticClass: "page-top-title"
  }, [_vm._v(_vm._s(_vm.$t('Supportive Establishments')))]), _vm._v(" "), _c('g-map-window')], 1)
},staticRenderFns: []}

/***/ }),
/* 323 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "associations-list"
  }, [_c('div', {
    staticClass: "share-button"
  }, [_c('button', {
    class: _vm.$i18n.locale() == 'ar' ? 'btn btn-success btn-xs pull-left' : 'btn btn-success btn-xs pull-right',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setShowShare', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Share')))])]), _vm._v(" "), _c('h1', {
    staticClass: "page-top-title"
  }, [_vm._v(_vm._s(_vm.$t('Charities')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model:value",
      value: (_vm.search),
      expression: "search",
      arg: "value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "search-asso",
      "placeholder": _vm.$t('Search by name or description')
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }, _vm.searchAsso]
    }
  }), _vm._v(" "), _vm._l((_vm.$store.getters.getCurrentAssoList), function(assoc) {
    return _c('div', {
      staticClass: "association-box",
      on: {
        "click": function($event) {
          _vm.selectAssociation(assoc.id)
        }
      }
    }, [_c('img', {
      staticClass: "assoc-logo",
      attrs: {
        "src": assoc.logo_url,
        "alt": _vm.$t(assoc.short_description)
      }
    }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(assoc.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(assoc.description))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t(assoc.country)))])])])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 325 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),
/* 326 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signup-area-wrapper"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-inner"
  }, [_c('vodal', {
    attrs: {
      "show": _vm.showTerms,
      "width": 250,
      "height": 300,
      "animation": "rotate"
    },
    on: {
      "hide": function($event) {
        _vm.showTerms = false
      }
    }
  }, [_c('terms-modal', {
    attrs: {
      "selected_country": _vm.signup.country
    }
  })], 1)], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "page-top-title"
  }, [_vm._v(_vm._s(_vm.$t('Sign up')))]), _vm._v(" "), _c('div', {
    staticClass: "share-button"
  }, [_c('button', {
    class: _vm.$i18n.locale() == 'ar' ? 'btn btn-success btn-xs pull-left' : 'btn btn-success btn-xs pull-right',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setShowShare', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Share')))])]), _vm._v(" "), _c('form', {
    staticClass: "form"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('Personal Info')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('First name'),
      "id": "fname-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-o fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.first_name),
      expression: "signup.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "first_name",
      "aria-describedby": "fname-addon1",
      "type": "text",
      "placeholder": _vm.$t('First name')
    },
    domProps: {
      "value": _vm.signup.first_name,
      "value": (_vm.signup.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.first_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Last name'),
      "id": "lname-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-o fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.last_name),
      expression: "signup.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "last_name",
      "aria-describedby": "lname-addon1",
      "type": "text",
      "placeholder": _vm.$t('Last name')
    },
    domProps: {
      "value": _vm.signup.last_name,
      "value": (_vm.signup.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.last_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Birthday'),
      "id": "birthday-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-birthday-cake fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.birthday),
      expression: "signup.birthday"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "birthday",
      "aria-describedby": "birthday-addon1",
      "type": "date",
      "placeholder": _vm.$t('Birthday')
    },
    domProps: {
      "value": _vm.signup.birthday,
      "value": (_vm.signup.birthday)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.birthday = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Gender'),
      "id": "gender-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-venus-mars fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "gender-addon1"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.gender),
      expression: "signup.gender"
    }],
    attrs: {
      "type": "radio",
      "name": "gender",
      "checked": "",
      "value": "M"
    },
    domProps: {
      "checked": _vm._q(_vm.signup.gender, "M")
    },
    on: {
      "__c": function($event) {
        _vm.signup.gender = "M"
      }
    }
  }), _vm._v(_vm._s(_vm.$t('Male')))]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.gender),
      expression: "signup.gender"
    }],
    attrs: {
      "type": "radio",
      "name": "gender",
      "value": "F"
    },
    domProps: {
      "checked": _vm._q(_vm.signup.gender, "F")
    },
    on: {
      "__c": function($event) {
        _vm.signup.gender = "F"
      }
    }
  }), _vm._v(_vm._s(_vm.$t('Female')))])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Nationality'),
      "id": "nationality-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-globe fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.nationality),
      expression: "signup.nationality"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "nationality-addon1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.signup.nationality = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.$store.getters.getAllCountries), function(country) {
    return _c('option', {
      attrs: {
        "disabled": country.code == '_'
      },
      domProps: {
        "selected": country.code == 'ES',
        "value": country.code
      },
      on: {
        "changed": function($event) {
          _vm.signup.nationality = country.code
        }
      }
    }, [_vm._v(_vm._s(_vm.$t(country.name)))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Country of residence'),
      "id": "country_of_residence-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.country_of_residence),
      expression: "signup.country_of_residence"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "country_of_residence-addon1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.signup.country_of_residence = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.$store.getters.getAllCountries), function(country) {
    return _c('option', {
      attrs: {
        "disabled": country.code == '_'
      },
      domProps: {
        "selected": country.code == 'ES',
        "value": country.code
      },
      on: {
        "changed": function($event) {
          _vm.signin.country_of_residence = country.code
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(country.name)))])
  }))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.$t('Establishment Info')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Establishment name'),
      "id": "POS_name-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-institution fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.POS_name),
      expression: "signup.POS_name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "first_name",
      "aria-describedby": "POS_name-addon1",
      "type": "text",
      "placeholder": _vm.$t('Establishment name')
    },
    domProps: {
      "value": _vm.signup.POS_name,
      "value": (_vm.signup.POS_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.POS_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('CIF Code'),
      "id": "cif-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-institution fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.cif),
      expression: "signup.cif"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "first_name",
      "aria-describedby": "cif-addon1",
      "type": "text",
      "placeholder": _vm.$t('CIF Code')
    },
    domProps: {
      "value": _vm.signup.cif,
      "value": (_vm.signup.cif)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.cif = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Country'),
      "id": "country-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-globe fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.country),
      expression: "signup.country"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "country-addon1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.signup.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.$store.getters.getAllCountries), function(country) {
    return _c('option', {
      attrs: {
        "disabled": country.code == '_'
      },
      domProps: {
        "selected": country.code == 'ES',
        "value": country.code
      },
      on: {
        "changed": function($event) {
          _vm.signup.country = country.code
        }
      }
    }, [_vm._v(_vm._s(_vm.$t(country.name)))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('City'),
      "id": "city-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.city),
      expression: "signup.city"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "city",
      "aria-describedby": "city-addon1",
      "type": "text",
      "placeholder": _vm.$t('City')
    },
    domProps: {
      "value": _vm.signup.city,
      "value": (_vm.signup.city)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.city = $event.target.value
      }, _vm.updateAddress]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Zip Code'),
      "id": "zip_code-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-pin fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.zip_code),
      expression: "signup.zip_code"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "first_name",
      "aria-describedby": "zip_code-addon1",
      "type": "number",
      "placeholder": _vm.$t('Zip Code')
    },
    domProps: {
      "value": _vm.signup.zip_code,
      "value": (_vm.signup.zip_code)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.zip_code = $event.target.value
      }, _vm.updateAddress],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('address'),
      "id": "address-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-signs fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.address),
      expression: "signup.address"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "first_name",
      "aria-describedby": "address-addon1",
      "type": "text",
      "placeholder": _vm.$t('address')
    },
    domProps: {
      "value": _vm.signup.address,
      "value": (_vm.signup.address)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.address = $event.target.value
      }, _vm.updateAddress]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Email'),
      "id": "email-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.mail),
      expression: "signup.mail"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "mail",
      "aria-describedby": "email-addon1",
      "type": "email",
      "placeholder": _vm.$t('Email')
    },
    domProps: {
      "value": _vm.signup.email,
      "value": (_vm.signup.mail)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.mail = $event.target.value
      }, _vm.updateEmail]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Password'),
      "id": "password-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.signup.password),
      expression: "signup.password"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "aria-describedby": "password-addon1",
      "type": "password",
      "placeholder": _vm.$t('Password')
    },
    domProps: {
      "value": _vm.signup.password,
      "value": (_vm.signup.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.signup.password = $event.target.value
      }, _vm.updatePassword]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    attrs: {
      "dir": "ltr"
    }
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "title": _vm.$t('Terms and conditions'),
      "id": "terms-addon1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.acceptTerms),
      expression: "acceptTerms"
    }],
    attrs: {
      "name": "accept_terms",
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.acceptTerms,
      "value": _vm.acceptTerms,
      "checked": Array.isArray(_vm.acceptTerms) ? _vm._i(_vm.acceptTerms, _vm.acceptTerms) > -1 : (_vm.acceptTerms)
    },
    on: {
      "click": _vm.toggleTermsModal,
      "__c": function($event) {
        var $$a = _vm.acceptTerms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.acceptTerms,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.acceptTerms = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.acceptTerms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.acceptTerms = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "form-control",
    attrs: {
      "for": "accept_terms",
      "aria-describedby": "terms-addon1"
    }
  }, [_vm._v(_vm._s(_vm.$t('Terms and conditions')))])]), _vm._v("\n\n    " + _vm._s(_vm.$t('If you already have an account')) + " "), _c('a', {
    on: {
      "click": _vm.goToLoginPOSPage
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('Login here')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block signup-btn",
    attrs: {
      "disabled": !_vm.acceptTerms
    },
    on: {
      "click": _vm.signupUser
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('Sign up')))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs btn-block",
    attrs: {
      "disabled": _vm.addressIsValid
    },
    on: {
      "click": _vm.goToSignupPage
    }
  }, [_vm._v(_vm._s(_vm.$t('Signup as User')))])])
},staticRenderFns: []}

/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model:value",
      value: (_vm.search),
      expression: "search",
      arg: "value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "search-asso",
      "placeholder": _vm.$t('Search by name or description')
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.searchEstablishment
    }
  }, [_c('i', {
    staticClass: "fa fa-search fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "405px"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 10
    },
    on: {
      "center_changed": _vm.updateCenter
    }
  }, [_c('gmap-info-window', {
    attrs: {
      "options": _vm.infoOptions,
      "position": _vm.infoWindowPos,
      "opened": _vm.infoWinOpen,
      "content": _vm.infoContent
    },
    on: {
      "closeclick": function($event) {
        _vm.infoWinOpen = false
      }
    }
  }), _vm._v(" "), _vm._l((_vm.markers), function(m, i) {
    return _c('gmap-marker', {
      key: i,
      attrs: {
        "position": m.position,
        "clickable": true
      },
      on: {
        "click": function($event) {
          _vm.toggleInfoWindow(m, i)
        }
      }
    })
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[121]);


// WEBPACK FOOTER //
// static/js/app.b971c7fdec9eb4b4e4d6.js